/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 65);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newKey = newKey;
exports.resetTest = resetTest;
exports.getSiteId = getSiteId;
exports.getDeviceType = getDeviceType;
exports.getAccountId = getAccountId;
exports.replacePlaceholders = replacePlaceholders;
exports.isNumbers = isNumbers;
exports.getMonthlyPaymentPerThousand = getMonthlyPaymentPerThousand;
exports.getTotalMonthlyPayments = getTotalMonthlyPayments;
exports.getAdjustedDueAtSigning = getAdjustedDueAtSigning;
exports.getDisclaimerPlaceholderObj = getDisclaimerPlaceholderObj;
exports.filterSummary = filterSummary;
exports.filterFinal = filterFinal;
exports.filterLoanLease = filterLoanLease;
exports.extractEPriceData = extractEPriceData;
exports.parseEPriceButtonLabel = parseEPriceButtonLabel;
exports.titleCase = titleCase;
exports.getDOMContainer = getDOMContainer;
exports.getAffiliatePromotion = exports.getParameterValue = exports.getCookieValue = exports.setClassNames = exports.getDisplayPayments = void 0;

var _constants = __webpack_require__(6);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/* eslint unknown-word: 0 */
var lastKey = 0;

function newKey(prefix) {
  lastKey += 1;
  return "".concat(prefix).concat(lastKey);
} // for testing purpose


function resetTest() {
  lastKey = 0;
}

function getSiteId(rData) {
  return rData.parameterMap && rData.parameterMap.siteId || rData.siteId;
}

function getDeviceType(rData) {
  return rData.parameterMap && rData.parameterMap.deviceType || rData.deviceType;
}

function getAccountId(rData) {
  return rData.parameterMap && rData.parameterMap.accountId || rData.accountId;
}
/**
 *
 * @param {Array} paymentsArray List of all available LOAN, LEASE payment options
 * @param {Array} keys List of payment object properties by which to sort
 * @param {Array} orders Order in which to sort the payment object to their respective properties, asc is default
 * @return {Object} Selected LOAN, LEASE payment object
 */


var getDisplayPayments = function getDisplayPayments(paymentsArray) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var orders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  /**
   * Sort the payment object based on the list of properties in the `keys` argument.
   * The list is maintained if the sort is based on a missing property
   */
  var sortedPaymentsArray = _toConsumableArray(paymentsArray).sort(function (paymentOne, paymentTwo) {
    var sortConditions = keys.map(function (key, index) {
      var order = orders[index] ? orders[index] : _constants.ASC;
      var criterea = 0;

      switch (order) {
        case _constants.DESC:
          criterea = paymentTwo[key] - paymentOne[key];
          break;

        case _constants.ASC:
        default:
          criterea = paymentOne[key] - paymentTwo[key];
          break;
      }

      return criterea;
    });
    return sortConditions.reduce(function (result, condition) {
      return result || condition;
    });
  });
  /* Select the first LOAN LEASE Payment in the list */


  return sortedPaymentsArray.reduce(function (paymentObj, payment) {
    var _payment$financeType = payment.financeType,
        financeType = _payment$financeType === void 0 ? '' : _payment$financeType;

    if (!paymentObj[financeType]) {
      return _objectSpread({}, paymentObj, _defineProperty({}, financeType, payment));
    }

    return paymentObj;
  }, {});
};

exports.getDisplayPayments = getDisplayPayments;

function replacePlaceholders(labelWithPlaceholder, placeholderValuesObj) {
  // global and ignore case flags which permits replace() to replace each occurrence of matched items
  // ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  if (!placeholderValuesObj || Object.entries(placeholderValuesObj).length === 0) {
    if (!labelWithPlaceholder || Object.entries(labelWithPlaceholder).length === 0) {
      return 'Invalid Input';
    }

    return labelWithPlaceholder;
  }

  var regex = new RegExp(Object.keys(placeholderValuesObj).join('|'), 'gi');
  return labelWithPlaceholder.replace(regex, function (matched) {
    return placeholderValuesObj[matched];
  });
}

function numberCheck(num) {
  return typeof num === 'number' && Number.isFinite(num);
}

function isNumbers(nums) {
  if (!nums || !Array.isArray(nums)) {
    return false;
  }

  return nums.every(numberCheck);
} // Logic is copied from PaymentCalculaterTool.java in cms project
// export function getMonthlyPayment(price, downPayment,interestRate,numberOfMonths) {
// 	if (price && downPayment && interestRate && numberOfMonths && isNumbers([price, downPayment,interestRate,numberOfMonths])) {
// 		return Math.round(((price - downPayment) * (interestRate / 100 / 12)) / (1 - (1 + interestRate / 100 / 12) ** (-numberOfMonths)));
// 	}
// 	return '';
// }


function getMonthlyPaymentPerThousand(monthlyPayment, amountFinanced) {
  if (isNumbers([amountFinanced, monthlyPayment]) && amountFinanced > 0) {
    return monthlyPayment / (amountFinanced / 1000.0);
  }

  return '';
}

function getTotalMonthlyPayments(monthlyPayment, term) {
  if (isNumbers([term, monthlyPayment])) {
    return monthlyPayment * term;
  }

  return '';
}

function getAdjustedDueAtSigning(dueAtSigning, rebate) {
  if (isNumbers([dueAtSigning, rebate]) && dueAtSigning - rebate > 0) {
    return dueAtSigning - rebate;
  } else {
    return 0;
  }
}

function getDisclaimerPlaceholderObj(paymentInfo) {
  if (paymentInfo._type === 'LOAN') {
    var apr = paymentInfo.apr,
        dealershipName = paymentInfo.dealershipName,
        downPayment = paymentInfo.downPayment,
        lenderLegalName = paymentInfo.lenderLegalName,
        loanCreditScore = paymentInfo.loanCreditScore,
        monthlyPaymentPerThousand = paymentInfo.monthlyPaymentPerThousand,
        loanProgramEndDate = paymentInfo.loanProgramEndDate,
        term = paymentInfo.term;
    return {
      '<%=loanCreditScore%>': loanCreditScore,
      '<%=APR%>': apr,
      '<%=term%>': term,
      '<%=monthlyPaymentPerThousand%>': monthlyPaymentPerThousand,
      '<%=downPayment%>': downPayment,
      '<%=lenderLegalName%>': lenderLegalName,
      '<%=loanProgramEndDate%>': loanProgramEndDate,
      '<%=dealershipName%>': dealershipName
    };
  } else if (paymentInfo._type === 'LEASE') {
    var leaseCreditScore = paymentInfo.leaseCreditScore,
        leaseLenderLegalName = paymentInfo.leaseLenderLegalName,
        leaseProgramEndDate = paymentInfo.leaseProgramEndDate,
        leaseTerm = paymentInfo.leaseTerm,
        leaseDueAtSigning = paymentInfo.leaseDueAtSigning,
        acquisitionFee = paymentInfo.acquisitionFee,
        capCostTotal = paymentInfo.capCostTotal,
        totalMonthlyPayments = paymentInfo.totalMonthlyPayments,
        capCostReduction = paymentInfo.capCostReduction,
        leaseSecurityDeposit = paymentInfo.leaseSecurityDeposit,
        monthlyPayment = paymentInfo.monthlyPayment,
        excessMileCharge = paymentInfo.excessMileCharge,
        annualMiles = paymentInfo.annualMiles,
        _dealershipName = paymentInfo.dealershipName;
    return {
      '<%=leaseCreditScore%>': leaseCreditScore,
      '<%=leaseLenderLegalName%>': leaseLenderLegalName,
      '<%=leaseProgramEndDate%>': leaseProgramEndDate,
      '<%=leaseTerm%>': leaseTerm,
      '<%=leaseDueAtSigning%>': leaseDueAtSigning,
      '<%=acquisitionFee%>': acquisitionFee,
      '<%=capCostTotal%>': capCostTotal,
      '<%=totalMonthlyPayments%>': totalMonthlyPayments,
      '<%=capCostReduction%>': capCostReduction,
      '<%=leaseSecurityDeposit%>': leaseSecurityDeposit,
      '<%=monthlyPayment%>': monthlyPayment,
      '<%=excessMileCharge%>': excessMileCharge,
      '<%=annualMiles%>': annualMiles,
      '<%=dealershipName%>': _dealershipName
    };
  }

  return {};
} // filter out final price items that do not match the priceType
// this data is consumed by the PricingSummary component


function filterSummary(summaryItems, priceType) {
  return summaryItems.filter(function (item) {
    return item && item.priceType && item.priceType === priceType.toUpperCase() || !item.priceType;
  });
} // filters out the final price from the summary object
// this data is consumed by the PricingSummary component


function filterFinal(summaryItems) {
  return summaryItems.filter(function (item) {
    return item.isFinalPrice === true;
  });
} // filters out the loan and lease from the summary object
// this data is consumed by the PricingLoanLease component


function filterLoanLease(summaryItems) {
  return summaryItems.filter(function (item) {
    return item._type === 'LOAN' || item._type === 'LEASE';
  });
}

function extractEPriceData(ePriceDetail) {
  var ePriceIndex = ePriceDetail.findIndex(function (element) {
    return element._type === 'EPRICE';
  }); // ePrice difference should be placed before ePrice value per Rules Provider

  var ePriceDifference = ePriceDetail[ePriceIndex].formatted;
  var ePriceValue = ePriceDetail[ePriceIndex + 1].formatted;
  var final = {};

  if (ePriceValue) {
    final = {
      ePriceValue: ePriceValue,
      ePriceDifference: ePriceDifference
    };
  }

  return final;
}

function parseEPriceButtonLabel(dPriceArr) {
  var ePriceLabelArr = dPriceArr.filter(function (item) {
    return item._type === 'SHOWEPRICE';
  })[0] || {};
  return ePriceLabelArr.label || 'Show ePrice!';
}

function titleCase(str, sep) {
  return str.toLowerCase().split(sep).map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join('');
}

function getDOMContainer(doc, cssClass) {
  var _doc$querySelectorAll = doc.querySelectorAll(cssClass),
      _doc$querySelectorAll2 = _slicedToArray(_doc$querySelectorAll, 1),
      container = _doc$querySelectorAll2[0];

  return container;
}
/**
 * Filters undefined, null or empty strings as well as boolean false from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 * From Tim Burgher in vehicle title's utility file
 */


var setClassNames = function setClassNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.concat().filter(function (className) {
    return className;
  }).join(' ') || null;
};
/**
 * Filters list of cookies down to the cookie with name matching cookieName param. if it exists, and returns
 * its value, if it is defined, or an empty string otherwise.
 *
 * @param cookies
 * @param cookieName
 * @returns {String} cookie name if the cookie exists, or empty string.
 */


exports.setClassNames = setClassNames;

var getCookieValue = function getCookieValue() {
  var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cookies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return cookies.filter(function (cookie) {
    return cookie.name === cookieName;
  }).reduce(function (value, cookie) {
    return cookie.value || value;
  }, '');
};
/**
 * Returns promo code from the 'affiliate_promotions' url parameter if it exists
 *
 * @param parameterMap
 * @param parameterName
 * @returns {String} parameter value if the url parameter equal to parameterName exists, or empty string.
 */


exports.getCookieValue = getCookieValue;

var getParameterValue = function getParameterValue() {
  var parameterName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var parameterMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return parameterMap[parameterName] || '';
};
/**
 * Returns affiliate offer promo code if one exists in the url parameter 'affiliate_promotions'
 * or in the 'DDC.Affiliate.PromoCode' cookie.
 * Prioritizes url parameter over cookie.
 *
 * @param rData
 * @returns {String} Promo code, if one exists, or empty string
 */


exports.getParameterValue = getParameterValue;

var getAffiliatePromotion = function getAffiliatePromotion() {
  var rData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getParameterValue('affiliate_promotions', rData.parameterMap) || getCookieValue('DDC.Affiliate.PromoCode', rData.cookies);
};

exports.getAffiliatePromotion = getAffiliatePromotion;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Common", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.Common;
  }
});
Object.defineProperty(exports, "CommonTester", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.CommonTester;
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.createStore;
  }
});

var _wsmCommonData = __webpack_require__(16);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THE_DEALERSHIP = exports.SLASH_MO = exports.PLUS_TAXES_ASTERISK = exports.PLUS_SALES_TAXES_ASTERISK = exports.PLEASE_CALL = exports.PER_MONTH = exports.LEASE = exports.INSTANT_EPRICE_DISABLED_POPOVER = exports.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = exports.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = exports.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = exports.FINANCE = exports.EST_LEASE_DISCLAIMER_HEADING = exports.EST_FINANCE_DISCLAIMER_HEADING = exports.EPRICE_PENDING = exports.DETAILS = exports.DETAILED_PRICING = exports.DEALERSHIP_NAME_PRICE = exports.CUSTOMIZE_PAYMENTS = exports.CLICK_TO_VIEW_DISCLAIMER = void 0;
var CLICK_TO_VIEW_DISCLAIMER = 'CLICK_TO_VIEW_DISCLAIMER';
exports.CLICK_TO_VIEW_DISCLAIMER = CLICK_TO_VIEW_DISCLAIMER;
var CUSTOMIZE_PAYMENTS = 'CUSTOMIZE_PAYMENTS';
exports.CUSTOMIZE_PAYMENTS = CUSTOMIZE_PAYMENTS;
var DEALERSHIP_NAME_PRICE = 'DEALERSHIP_NAME_PRICE';
exports.DEALERSHIP_NAME_PRICE = DEALERSHIP_NAME_PRICE;
var DETAILED_PRICING = 'DETAILED_PRICING';
exports.DETAILED_PRICING = DETAILED_PRICING;
var DETAILS = 'DETAILS';
exports.DETAILS = DETAILS;
var EPRICE_PENDING = 'EPRICE_PENDING';
exports.EPRICE_PENDING = EPRICE_PENDING;
var EST_FINANCE_DISCLAIMER_HEADING = 'EST_FINANCE_DISCLAIMER_HEADING';
exports.EST_FINANCE_DISCLAIMER_HEADING = EST_FINANCE_DISCLAIMER_HEADING;
var EST_LEASE_DISCLAIMER_HEADING = 'EST_LEASE_DISCLAIMER_HEADING';
exports.EST_LEASE_DISCLAIMER_HEADING = EST_LEASE_DISCLAIMER_HEADING;
var FINANCE = 'FINANCE';
exports.FINANCE = FINANCE;
var FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
var FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE;
var FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE;
var INSTANT_EPRICE_DISABLED_POPOVER = 'INSTANT_EPRICE_DISABLED_POPOVER';
exports.INSTANT_EPRICE_DISABLED_POPOVER = INSTANT_EPRICE_DISABLED_POPOVER;
var LEASE = 'LEASE';
exports.LEASE = LEASE;
var PER_MONTH = 'PER_MONTH';
exports.PER_MONTH = PER_MONTH;
var PLEASE_CALL = 'PLEASE_CALL';
exports.PLEASE_CALL = PLEASE_CALL;
var PLUS_SALES_TAXES_ASTERISK = 'PLUS_SALES_TAXES_ASTERISK';
exports.PLUS_SALES_TAXES_ASTERISK = PLUS_SALES_TAXES_ASTERISK;
var PLUS_TAXES_ASTERISK = 'PLUS_TAXES_ASTERISK';
exports.PLUS_TAXES_ASTERISK = PLUS_TAXES_ASTERISK;
var SLASH_MO = 'SLASH_MO';
exports.SLASH_MO = SLASH_MO;
var THE_DEALERSHIP = 'THE_DEALERSHIP';
exports.THE_DEALERSHIP = THE_DEALERSHIP;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_PRICING_MODULE = exports.SET_ACCOUNT = exports.SET_DEALER_ADDRESS = exports.SET_WIDGET_INFO = exports.VCDA_ERROR = exports.SET_MODAL = exports.SET_INCENTIVE = exports.SET_PRICING = void 0;
// This file should only contain action type constants.
var SET_PRICING = 'SET_PRICING';
exports.SET_PRICING = SET_PRICING;
var SET_INCENTIVE = 'SET_INCENTIVE';
exports.SET_INCENTIVE = SET_INCENTIVE;
var SET_MODAL = 'SET_MODAL';
exports.SET_MODAL = SET_MODAL;
var VCDA_ERROR = 'VCDA_ERROR';
exports.VCDA_ERROR = VCDA_ERROR;
var SET_WIDGET_INFO = 'SET_WIDGET_INFO';
exports.SET_WIDGET_INFO = SET_WIDGET_INFO;
var SET_DEALER_ADDRESS = 'SET_DEALER_ADDRESS';
exports.SET_DEALER_ADDRESS = SET_DEALER_ADDRESS;
var SET_ACCOUNT = 'SET_ACCOUNT';
exports.SET_ACCOUNT = SET_ACCOUNT;
var SET_PRICING_MODULE = 'SET_PRICING_MODULE';
exports.SET_PRICING_MODULE = SET_PRICING_MODULE;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SRP = exports.VDP = exports.BUTTON_RESET_CLASSES = exports.DESC = exports.ASC = exports.OFFSET_INTEGRATED_DR_HEIGHT = exports.OFFSET_HEIGHT = exports.NO_PRICE_ITEMS = exports.LEASE = exports.LOAN = void 0;
var LOAN = 'LOAN';
exports.LOAN = LOAN;
var LEASE = 'LEASE';
exports.LEASE = LEASE;
var NO_PRICE_ITEMS = 'No prices were returned from vcda.';
exports.NO_PRICE_ITEMS = NO_PRICE_ITEMS;
var OFFSET_HEIGHT = 66;
exports.OFFSET_HEIGHT = OFFSET_HEIGHT;
var OFFSET_INTEGRATED_DR_HEIGHT = 33;
exports.OFFSET_INTEGRATED_DR_HEIGHT = OFFSET_INTEGRATED_DR_HEIGHT;
var ASC = 'asc';
exports.ASC = ASC;
var DESC = 'desc';
exports.DESC = DESC;
var BUTTON_RESET_CLASSES = 'p-0 text-left bg-transparent border-0';
exports.BUTTON_RESET_CLASSES = BUTTON_RESET_CLASSES;
var VDP = 'VDP';
exports.VDP = VDP;
var SRP = 'SRP';
exports.SRP = SRP;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = ReactBootstrap;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CaDisclaimer = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CaDisclaimer = function CaDisclaimer(_ref) {
  var dealerAddress = _ref.dealerAddress,
      isFooter = _ref.isFooter;
  var CAAlternateDisclaimerProvinces = ['AB', 'BC', 'MB', 'ON', 'QC', 'SK'];
  var staticDisclaimerClasses = 'final-price-disclaimer ddc-font-size-xsmall text-muted w-100 ';
  var disclaimerClasses = staticDisclaimerClasses + (isFooter ? 'text-left summary-disclaimer' : 'text-right');
  var disclaimerLabel = _labels.PLUS_TAXES_ASTERISK;

  if (CAAlternateDisclaimerProvinces.includes(dealerAddress.state)) {
    disclaimerLabel = _labels.PLUS_SALES_TAXES_ASTERISK;
  }

  if (dealerAddress.country === 'CA') {
    return _react.default.createElement("div", {
      className: disclaimerClasses
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(disclaimerLabel);
      }
    }));
  } else {
    return null;
  }
};

exports.CaDisclaimer = CaDisclaimer;
CaDisclaimer.propTypes = {
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  })
};
CaDisclaimer.defaultProps = {
  dealerAddress: {},
  isFooter: false
};
var _default = CaDisclaimer;
exports.default = _default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelAsHTML = function LabelAsHTML(props) {
  var label = props.label,
      isStyleEditable = props.isStyleEditable,
      vehicleTypeClass = props.vehicleTypeClass,
      typeClass = props.typeClass;
  return (
    /* eslint react/no-danger: 0 */
    _react.default.createElement("span", {
      className: "price-label",
      "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-label") : null,
      "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-label") : null,
      dangerouslySetInnerHTML: {
        __html: label
      }
    })
  );
};

LabelAsHTML.defaultProps = {
  isStyleEditable: false,
  vehicleTypeClass: '',
  typeClass: ''
};
LabelAsHTML.propTypes = {
  label: _propTypes.default.string.isRequired,
  isStyleEditable: _propTypes.default.bool,
  vehicleTypeClass: _propTypes.default.string,
  typeClass: _propTypes.default.string
};
var _default = LabelAsHTML;
exports.default = _default;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.priceDetailsScrollEvent = priceDetailsScrollEvent;
exports.disclaimerDetailsModalEvents = disclaimerDetailsModalEvents;
exports.ePriceButtonTrackEvent = ePriceButtonTrackEvent;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var defaultClickEvent = {
  event: 'widgetUserEvent',
  element: 'More details button',
  elementCTA: 'Details',
  action: 'clicked',
  result: 'Revealed detail information popup',
  widgetName: 'ws-detailed-pricing',
  widgetId: 'detailed-pricing1',
  widgetState: 'default',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = {};

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
    trackingObject = window.jQuery(document) || {};
  }

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function priceDetailsScrollEvent(widgetName, widgetId) {
  var eventData = {
    element: 'Price details link',
    elementCTA: 'Pricing Detail',
    result: 'Scrolled to destination',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent(eventData);
}

function disclaimerDetailsModalEvents(widgetName, widgetId, modalState) {
  var eventData;

  if (modalState) {
    eventData = {
      element: 'Disclaimer details link',
      elementCTA: undefined,
      result: 'Opened dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  } else {
    eventData = {
      element: 'Close button',
      elementCTA: undefined,
      result: 'Closed dialog',
      widgetState: 'Disclaimer dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  }

  trackGoogleAnalyticsEvent(eventData);
}

function ePriceButtonTrackEvent(buttonLabel, widgetName, widgetId, openModal) {
  var eventData = {
    element: 'Instant ePrice button',
    elementCTA: buttonLabel,
    result: openModal ? 'Opened dialog' : 'ePrice diplayed',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent(eventData);
}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

var _utility = __webpack_require__(2);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DisclaimerContent = function DisclaimerContent(_ref) {
  var dealershipName = _ref.dealershipName,
      disclaimerLabel = _ref.disclaimerLabel,
      placeholderValuesObj = _ref.placeholderValuesObj;
  return _react.default.createElement(_common.Common, {
    render: function render(_ref2) {
      var labels = _ref2.labels;
      var introParagraph = labels.get(_labels.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE);
      var dealershipText = dealershipName === _labels.THE_DEALERSHIP ? labels.get(_labels.THE_DEALERSHIP) : dealershipName;
      var disclaimerHtml = (0, _utility.replacePlaceholders)(labels.get(disclaimerLabel), _objectSpread({}, placeholderValuesObj, {
        '<%=dealershipName%>': dealershipText
      }));
      /* eslint react/no-danger: 0 */

      return [_react.default.createElement("div", {
        key: "introHtml",
        dangerouslySetInnerHTML: {
          __html: introParagraph
        }
      }), _react.default.createElement("div", {
        key: "disclaimerHtml",
        dangerouslySetInnerHTML: {
          __html: disclaimerHtml
        }
      })];
    }
  });
};

DisclaimerContent.propTypes = {
  dealershipName: _propTypes.default.string.isRequired,
  disclaimerLabel: _propTypes.default.string.isRequired,
  placeholderValuesObj: _propTypes.default.shape().isRequired
};
var _default = DisclaimerContent;
exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

var _DisclaimersModal = _interopRequireDefault(__webpack_require__(18));

var _labels = __webpack_require__(4);

var _constants = __webpack_require__(6);

var _analytics = __webpack_require__(11);

var _utility = __webpack_require__(2);

var _PricingSummaryFinalPrice = _interopRequireDefault(__webpack_require__(25));

var _PricingSummaryPayments = _interopRequireDefault(__webpack_require__(29));

var _PricingSummaryLink = _interopRequireDefault(__webpack_require__(28));

var _CanadaDisclaimerContent = __webpack_require__(9);

__webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var getFormattedValue = function getFormattedValue(formatted) {
  var formattedValue = formatted;

  if (formattedValue === _labels.PLEASE_CALL) {
    formattedValue = _react.default.createElement(_common.Common, {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(_labels.PLEASE_CALL);
      }
    });
  }

  return formattedValue;
};

var PricingSummary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummary, _React$Component);

  function PricingSummary(props) {
    var _this;

    _classCallCheck(this, PricingSummary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummary).call(this, props));
    _this.state = {
      isModalVisible: false,
      paymentInfo: null
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingSummary, [{
    key: "closeModal",
    value: function closeModal() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      (0, _analytics.disclaimerDetailsModalEvents)(widgetName, windowId, false);
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "handleHelpCircleIcon",
    value: function handleHelpCircleIcon(paymentInfo) {
      var _this$props$widgetInf2 = this.props.widgetInfo,
          widgetName = _this$props$widgetInf2.widgetName,
          windowId = _this$props$widgetInf2.windowId;
      (0, _analytics.disclaimerDetailsModalEvents)(widgetName, windowId, true);
      this.setState({
        isModalVisible: true,
        paymentInfo: paymentInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$summary = _this$props.summary,
          summary = _this$props$summary === void 0 ? [] : _this$props$summary,
          isMobile = _this$props.isMobile,
          viewPriceDetail = _this$props.viewPriceDetail;
      var _this$props$prefs = this.props.prefs,
          showStickySidebarLoanLease = _this$props$prefs.showStickySidebarLoanLease,
          finalPriceFontWeight = _this$props$prefs.finalPriceFontWeight,
          finalPriceClasses = _this$props$prefs.finalPriceClasses,
          priceLabelClasses = _this$props$prefs.priceLabelClasses,
          pricingSummaryPaymentIntervalColor = _this$props$prefs.pricingSummaryPaymentIntervalColor,
          showCustomizePaymentsLink = _this$props$prefs.showCustomizePaymentsLink,
          pricingSummaryLoanLeaseHelpIconColor = _this$props$prefs.pricingSummaryLoanLeaseHelpIconColor,
          pricingSummaryAlignItems = _this$props$prefs.pricingSummaryAlignItems;
      var finalLabelSize = isMobile ? 'ddc-font-size-base' : 'ddc-font-size-small';
      var finalPriceSize = isMobile ? 'ddc-font-size-xxlarge' : 'ddc-font-size-xlarge';
      var paymentLabelSize = isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall';
      var paymentPriceSize = isMobile ? 'ddc-font-size-xlarge' : 'ddc-font-size-large';
      var summaryLength = summary.length;
      var pricingSummary;

      if (summaryLength === 0) {
        return null;
      } else if (summaryLength > 1 && showStickySidebarLoanLease === 'true') {
        var finalPriceSummary = (0, _utility.filterFinal)(summary);
        var paymentsSummary = (0, _utility.filterLoanLease)(summary);
        pricingSummary = _react.default.createElement("div", null, _react.default.createElement(_DisclaimersModal.default, {
          isModalVisible: this.state.isModalVisible,
          handleClose: this.closeModal,
          paymentInfo: this.state.paymentInfo
        }), _react.default.createElement("ul", {
          className: (0, _utility.setClassNames)('pricing-summary', 'list-unstyled', 'd-flex', 'justify-items-between', 'mb-4', pricingSummaryAlignItems)
        }, _react.default.createElement("li", {
          className: (0, _utility.setClassNames)(summaryLength <= 2 ? 'half-width' : 'third-width', ' d-flex', 'flex-wrap', 'mr-4', 'summary-price')
        }, finalPriceSummary.map(function (price) {
          return _react.default.createElement(_PricingSummaryFinalPrice.default, _extends({
            price: price,
            viewPriceDetail: viewPriceDetail,
            finalLabelSize: finalLabelSize,
            finalPriceSize: finalPriceSize,
            paymentLabelSize: paymentLabelSize
          }, {
            key: price._type,
            buttonResetClasses: _constants.BUTTON_RESET_CLASSES,
            finalPrice: getFormattedValue(price.formatted)
          }));
        }), _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.DETAILED_PRICING,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: false,
          viewPriceDetail: viewPriceDetail
        })), _react.default.createElement("li", {
          className: "d-flex flex-wrap flex-grow-1"
        }, paymentsSummary.map(function (price) {
          return _react.default.createElement(_PricingSummaryPayments.default, _extends({
            price: price,
            paymentLabelSize: paymentLabelSize,
            paymentPriceSize: paymentPriceSize,
            pricingSummaryPaymentIntervalColor: pricingSummaryPaymentIntervalColor,
            pricingSummaryLoanLeaseHelpIconColor: pricingSummaryLoanLeaseHelpIconColor
          }, {
            key: price._type,
            paymentPrice: getFormattedValue(price.formatted),
            handleHelpCircleIcon: function handleHelpCircleIcon() {
              return _this2.handleHelpCircleIcon(price);
            }
          }));
        }), showCustomizePaymentsLink === 'true' && _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.CUSTOMIZE_PAYMENTS,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: true
        }))));
      } else {
        // single item (final price) will get detailed pricing markup
        // summary[0] will always be final price - ref: VCDApricing.js
        var _summary$ = summary[0],
            label = _summary$.label,
            formatted = _summary$.formatted;
        var dealerAddress = this.props.dealerAddress;
        pricingSummary = _react.default.createElement("dl", {
          className: "pricing-detail final-price line-height-condensed mb-4"
        }, _react.default.createElement("dt", {
          className: priceLabelClasses || null
        }, _react.default.createElement("button", {
          className: _constants.BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail
        }, _react.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        }), _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.DETAILED_PRICING,
          labelFontSize: paymentLabelSize
        }))), _react.default.createElement("dd", {
          className: (0, _utility.setClassNames)(finalPriceFontWeight, finalPriceSize, finalPriceClasses)
        }, _react.default.createElement("button", {
          className: _constants.BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail
        }, getFormattedValue(formatted))), _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
          dealerAddress: dealerAddress
        }));
      }

      return pricingSummary;
    }
  }]);

  return PricingSummary;
}(_react.default.Component);

exports.default = PricingSummary;
PricingSummary.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string,
    finalPriceFontWeight: _propTypes.default.string,
    finalPriceClasses: _propTypes.default.string,
    priceLabelClasses: _propTypes.default.string,
    pricingSummaryPaymentIntervalColor: _propTypes.default.string,
    showCustomizePaymentsLink: _propTypes.default.string,
    pricingSummaryLoanLeaseHelpIconColor: _propTypes.default.string,
    pricingSummaryAlignItems: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isMobile: _propTypes.default.bool
};
PricingSummary.defaultProps = {
  dealerAddress: {},
  isMobile: false
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.7.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseGet = __webpack_require__(54),
    toPath = __webpack_require__(55);

/**
 * Gets the property value of `path` on `object`. If the resolved value is
 * `undefined` the `defaultValue` is used in its place.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = DDC.WsmCommonData;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactDom = __webpack_require__(8);

var _WidgetWrapper = _interopRequireDefault(__webpack_require__(44));

var _store = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React hydrate bound to the redux store
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		WS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
var getFlag = function getFlag(name, defaultValue) {
  if (!window.DDC || !window.DDC.Flags) {
    return defaultValue;
  }

  return window.DDC.Flags[name];
};

var serveBundleFromClientSite = getFlag('serve-osiris-bundle-from-clientsite', false) === true;
var stateParentKey = serveBundleFromClientSite ? 'WS' : 'OSIRIS';

var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC[stateParentKey] || !window.DDC[stateParentKey].state || !window.DDC[stateParentKey].state[widgetName]) {
    return {};
  }

  return window.DDC[stateParentKey].state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-detailed-pricing');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store; // When the widget is initially rendered server-side, render.jsx passes outputWrapperDiv
    // to render the widget wrapper div. Here, when hydrating, we pass outputWrapperDiv=false.
    // This is because hydrate takes a DOM element to hydrate into. We can't wrap the widget
    // in an extra div to target because there is a lot of styling in our system that
    // breaks. So, instead, we have to target the widget wrapper div and hydrate the
    // components inside of it.

    (0, _reactDom.hydrate)(React.createElement(_WidgetWrapper.default, {
      outputWrapperDiv: false,
      store: store,
      widgetId: widgetId
    }), document.getElementById("".concat(widgetId, "-app-root"))); // We've initialized. We don't need to keep this data around anymore.
    // Deleting it ensures that we don't accidentally reinitialize later.

    if (serveBundleFromClientSite) {
      delete widgetStates[widgetId];
    }
  });
};

if (serveBundleFromClientSite) {
  initializeWidgets();
} else if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactBootstrap = __webpack_require__(7);

var _common = __webpack_require__(3);

var _DisclaimerContent = _interopRequireDefault(__webpack_require__(13));

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisclaimersModal = function DisclaimersModal(props) {
  var isModalVisible = props.isModalVisible,
      handleClose = props.handleClose,
      paymentInfo = props.paymentInfo;

  if (!paymentInfo) {
    return null;
  }

  var modalBody = '';
  var title = '';
  var _type = paymentInfo._type,
      dealershipName = paymentInfo.dealershipName;
  var placeholderValuesObj = (0, _utility.getDisclaimerPlaceholderObj)(paymentInfo);

  if (_type === 'LOAN') {
    title = _react.default.createElement(_common.Common, {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(_labels.EST_FINANCE_DISCLAIMER_HEADING);
      }
    });
    modalBody = _react.default.createElement(_DisclaimerContent.default, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: _labels.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  if (_type === 'LEASE') {
    title = _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(_labels.EST_LEASE_DISCLAIMER_HEADING);
      }
    });
    modalBody = _react.default.createElement(_DisclaimerContent.default, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: _labels.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  return _react.default.createElement(_reactBootstrap.Modal, {
    show: isModalVisible,
    onHide: handleClose
  }, _react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: true
  }, _react.default.createElement(_reactBootstrap.Modal.Title, {
    className: "text-center"
  }, _react.default.createElement("span", {
    className: "h3 font-weight-bold"
  }, title))), _react.default.createElement(_reactBootstrap.Modal.Body, null, modalBody));
};

DisclaimersModal.defaultProps = {
  paymentInfo: null
};
DisclaimersModal.propTypes = {
  isModalVisible: _propTypes.default.bool.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  paymentInfo: _propTypes.default.shape()
};
var _default = DisclaimersModal;
exports.default = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactBootstrap = __webpack_require__(7);

var _common = __webpack_require__(3);

var _utility = __webpack_require__(2);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstantEPriceButton = function InstantEPriceButton(props) {
  var isModalVisible = props.isModalVisible,
      loadingUserProfile = props.loadingUserProfile,
      userLoggedIn = props.userLoggedIn,
      handleClick = props.handleClick,
      buttonLabel = props.buttonLabel,
      pendingLabel = props.pendingLabel,
      vehicleId = props.vehicleId,
      vehicleCategory = props.vehicleCategory,
      pageAlias = props.pageAlias,
      buttonStyle = props.buttonStyle,
      buttonMobileClass = props.buttonMobileClass,
      disabled = props.disabled,
      preventMultipleEpriceLeads = props.preventMultipleEpriceLeads;
  var formUrl = "/instant-eprice-form.htm?itemId=".concat(vehicleId, "&vehicleId=").concat(vehicleId, "&category=").concat(vehicleCategory) + "&parentPageAlias=".concat(pageAlias, "&vcdaInstantEPrice");

  var allowLeadSubmission = function allowLeadSubmission() {
    // Don't submit a lead if preventMultipleEpriceLeads preference is set and user
    // has already submitted one
    return !(preventMultipleEpriceLeads && window.DDC.userProfile.ePriceVehicles && window.DDC.userProfileController.hasUserContactData());
  };

  var submitLeadConditionally = function submitLeadConditionally() {
    if (allowLeadSubmission()) {
      window.DDC.userProfileController.sendLeadForm(formUrl);
    }
  };

  var openModalOrSubmitLead = function openModalOrSubmitLead() {
    try {
      handleClick();
    } catch (error) {
      throw new Error('Unable to handle click.');
    } finally {
      submitLeadConditionally();
    }
  };

  var nonModalLogIn = userLoggedIn && !isModalVisible;
  var dataHrefAttr = nonModalLogIn ? null : formUrl; // if the user is logged in, we don't want to trigger a dialog in mobile (slide-in) or desktop (modal)

  var dialogClass = nonModalLogIn ? 'slidein-disabled' : 'dialog';
  var buttonDisplayClass = isModalVisible ? 'd-none' : '';
  var modalDisplayClass = isModalVisible ? '' : 'd-none';
  var spinningGears = loadingUserProfile ? _react.default.createElement("i", {
    className: "mr-3 ddc-icon ddc-icon-loading ddc-icon-animate-spin"
  }) : null;
  var buttonAllClassNames = (0, _utility.setClassNames)('btn-block', 'btn', "btn-".concat(buttonStyle), 'instant-eprice', "".concat(dialogClass), "".concat(buttonDisplayClass));
  var pendingLabelClassNames = (0, _utility.setClassNames)('instanteprice-pending', 'font-weight-bold', 'text-success', 'text-center', "".concat(modalDisplayClass));

  var tooltip = _react.default.createElement(_reactBootstrap.Tooltip, {
    className: "tooltip",
    id: "tooltip",
    style: {
      color: 'red'
    }
  }, _react.default.createElement(_common.Common, {
    render: function render(_ref) {
      var labels = _ref.labels;
      return labels.get(_labels.INSTANT_EPRICE_DISABLED_POPOVER);
    }
  }));

  var disabledButton = _react.default.createElement("div", {
    className: "disabled"
  }, _react.default.createElement(_reactBootstrap.OverlayTrigger, {
    placement: "left",
    overlay: tooltip,
    trigger: ['hover', 'click']
  }, _react.default.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4 ".concat(buttonMobileClass)
  }, _react.default.createElement("button", {
    className: buttonAllClassNames,
    "data-width": "600px",
    "data-location": "vehicle-eprice-button",
    disabled: true
  }, buttonLabel))));

  var regularButton = _react.default.createElement("div", null, _react.default.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4 ".concat(buttonMobileClass)
  }, _react.default.createElement("button", {
    className: buttonAllClassNames,
    onClick: openModalOrSubmitLead,
    rel: "nofollow",
    "data-vehicle-uuid": vehicleId,
    "data-href": dataHrefAttr,
    "data-width": "600px",
    "data-location": "vehicle-eprice-button"
  }, spinningGears, buttonLabel), _react.default.createElement("div", {
    key: "label",
    className: pendingLabelClassNames
  }, pendingLabel)));

  return disabled ? disabledButton : regularButton;
};

InstantEPriceButton.propTypes = {
  isModalVisible: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  loadingUserProfile: _propTypes.default.bool.isRequired,
  userLoggedIn: _propTypes.default.bool.isRequired,
  buttonLabel: _propTypes.default.string.isRequired,
  pendingLabel: _propTypes.default.string.isRequired,
  handleClick: _propTypes.default.func.isRequired,
  vehicleId: _propTypes.default.string.isRequired,
  vehicleCategory: _propTypes.default.string.isRequired,
  pageAlias: _propTypes.default.string.isRequired,
  buttonStyle: _propTypes.default.string.isRequired,
  buttonMobileClass: _propTypes.default.string.isRequired,
  preventMultipleEpriceLeads: _propTypes.default.bool.isRequired
};
var _default = InstantEPriceButton;
exports.default = _default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoanLeaseModal = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactBootstrap = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LoanLeaseModal = function LoanLeaseModal(_ref) {
  var options = _extends({}, _ref);

  var showState = options.showState,
      closeMethod = options.closeMethod,
      title = options.title,
      body = options.body,
      isMobile = options.isMobile;
  return _react.default.createElement(_reactBootstrap.Modal, {
    show: showState,
    onHide: function onHide() {
      return closeMethod();
    },
    className: "m-1 ".concat(isMobile ? 'dock-right' : null),
    animation: !isMobile
  }, _react.default.createElement("div", {
    className: "m-1"
  }, _react.default.createElement(_reactBootstrap.Modal.Header, null, _react.default.createElement(_reactBootstrap.Modal.Title, {
    className: "text-center"
  }, _react.default.createElement("button", {
    type: "button",
    "aria-label": "Close",
    className: "close text-muted",
    onClick: function onClick() {
      return closeMethod();
    }
  }, _react.default.createElement("i", {
    className: "ddc-icon ddc-icon-close",
    "aria-hidden": "true"
  })), _react.default.createElement("h3", {
    className: "my-0 px-5"
  }, title))), _react.default.createElement(_reactBootstrap.Modal.Body, null, body)));
};

exports.LoanLeaseModal = LoanLeaseModal;
LoanLeaseModal.propTypes = {
  showState: _propTypes.default.bool.isRequired,
  closeMethod: _propTypes.default.func.isRequired,
  title: _propTypes.default.element.isRequired,
  body: _propTypes.default.element.isRequired
};
var _default = LoanLeaseModal;
exports.default = _default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaymentCalculatorButton = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _lodash = _interopRequireDefault(__webpack_require__(15));

var _constants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentCalculatorButton = function PaymentCalculatorButton(_ref) {
  var isLoanLeaseAvailable = _ref.isLoanLeaseAvailable,
      isScrollingSidebar = _ref.isScrollingSidebar,
      isMobile = _ref.isMobile,
      prefs = _ref.prefs,
      labels = _ref.labels;

  var handleButtonClick = function handleButtonClick() {
    if (isMobile) {
      var pubsub = (0, _lodash.default)(window, 'pubsub', undefined);

      if (pubsub) {
        pubsub.publish('openDRTools', 'payment');
        return;
      }
    }

    var headerSelector = document && document.querySelector('[data-widget-id="template-navigation1"]');
    var scrollToSelector = '[data-widget-id="digital-retailing-1"]';
    var pageHeaderHeight = headerSelector && headerSelector.clientHeight || 0;
    /* eslint no-undef: 0 */

    if (DDC && DDC.scrollToAnchor) {
      DDC.scrollToAnchor($(scrollToSelector), {
        heightAdj: pageHeaderHeight + _constants.OFFSET_INTEGRATED_DR_HEIGHT
      });
    }
  };

  var renderButton = function renderButton() {
    var paymentCalculatorButtonLabel = prefs.paymentCalculatorButtonLabel,
        paymentCalculatorButtonClasses = prefs.paymentCalculatorButtonClasses,
        paymentCalculatorButtonIcon = prefs.paymentCalculatorButtonIcon,
        paymentCalculatorButtonIconClasses = prefs.paymentCalculatorButtonIconClasses,
        paymentBoxBackground = prefs.paymentBoxBackground,
        paymentBoxPadding = prefs.paymentBoxPadding;
    var buttonWrapperClasses = ["py-".concat(paymentBoxPadding)];

    if (!isScrollingSidebar) {
      var applyBoxPadding;
      var applyBoxBackground;
      var bottomPaddingClasses = "pb-".concat(paymentBoxPadding);

      if (isLoanLeaseAvailable) {
        applyBoxPadding = "px-".concat(paymentBoxPadding);
        applyBoxBackground = paymentBoxBackground;
      }

      buttonWrapperClasses = ['payment-calculator-wrapper', applyBoxBackground, applyBoxPadding, bottomPaddingClasses];
    }

    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: buttonWrapperClasses.filter(Boolean).join(' ')
    }, _react.default.createElement("button", {
      className: "btn btn-".concat(paymentCalculatorButtonClasses, " w-100"),
      onClick: handleButtonClick
    }, _react.default.createElement("i", {
      className: "ddc-icon ddc-icon-".concat(paymentCalculatorButtonIcon, " ").concat(paymentCalculatorButtonIconClasses)
    }), labels.get(paymentCalculatorButtonLabel))));
  };

  return renderButton();
};

exports.PaymentCalculatorButton = PaymentCalculatorButton;
PaymentCalculatorButton.propTypes = {
  isLoanLeaseAvailable: _propTypes.default.bool.isRequired,
  isScrollingSidebar: _propTypes.default.bool.isRequired,
  isMobile: _propTypes.default.bool.isRequired,
  prefs: _propTypes.default.shape({
    paymentCalculatorButtonLabel: _propTypes.default.string,
    paymentCalculatorButtonClasses: _propTypes.default.string,
    paymentCalculatorButtonIcon: _propTypes.default.string,
    paymentCalculatorButtonIconClasses: _propTypes.default.string,
    paymentBoxBackground: _propTypes.default.string,
    paymentBoxPadding: _propTypes.default.string
  }).isRequired,
  labels: _propTypes.default.shape({
    get: _propTypes.default.func.isRequired
  }).isRequired
};
var _default = PaymentCalculatorButton;
exports.default = _default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(10));

var _utility = __webpack_require__(2);

var _CanadaDisclaimerContent = __webpack_require__(9);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingDetail =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingDetail, _React$Component);

  function PricingDetail() {
    _classCallCheck(this, PricingDetail);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingDetail).apply(this, arguments));
  }

  _createClass(PricingDetail, [{
    key: "linkToModal",
    value: function linkToModal(isIncentive, incentiveId) {
      return isIncentive ? this.props.showModal(this.props.incentiveData.find(function (incentive) {
        return incentive.key === incentiveId;
      })) : false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          detail = _this$props.detail,
          detailType = _this$props.detailType,
          _this$props$prefs = _this$props.prefs,
          priceDiscountColor = _this$props$prefs.priceDiscountColor,
          finalPriceSize = _this$props$prefs.finalPriceSize,
          finalPriceColor = _this$props$prefs.finalPriceColor,
          finalPriceFontWeight = _this$props$prefs.finalPriceFontWeight,
          finalPriceClasses = _this$props$prefs.finalPriceClasses,
          priceLabelClasses = _this$props$prefs.priceLabelClasses,
          alwaysShowFinalPriceSeparator = _this$props$prefs.alwaysShowFinalPriceSeparator,
          locale = _this$props.locale,
          dealerAddress = _this$props.dealerAddress,
          isFinalPriceFlagEnabled = _this$props.isFinalPriceFlagEnabled;
      var _this$props$widgetInf = this.props.widgetInfo,
          deviceType = _this$props$widgetInf.deviceType,
          vehicleType = _this$props$widgetInf.vehicleType;
      var isMobile = deviceType === 'MOBILE';
      var adjustmentDetected = false;
      var vehicleTypeClass = vehicleType ? "inv-type-".concat(vehicleType.toLowerCase()) : ''; // TODO: remove when VCDA is fixed
      // Hack to get around VCDA error where the final ePrice has _type="MIDDLE" instead of "TOTAL"

      var lastPriceType;
      return _react.default.createElement("dl", {
        className: (0, _utility.setClassNames)('pricing-detail', 'line-height-condensed', 'mb-4', vehicleTypeClass)
      }, detail.map(function (price, index) {
        var _type = price._type,
            incentiveId = price.incentiveId,
            formatted = price.formatted,
            isFinalPrice = price.isFinalPrice;
        var typeClass = price.typeClass;
        var formattedValue = formatted;
        var valueClass = '';

        if (formattedValue === _labels.PLEASE_CALL) {
          valueClass = 'no-value';
          formattedValue = _react.default.createElement(_common.Common, {
            render: function render(_ref) {
              var labels = _ref.labels;
              return labels.get(_labels.PLEASE_CALL);
            }
          });
        }

        var isStackedFinal = _type === 'SICF' || _type === 'SIF';
        var isPlusMinus = _type === '-' || _type === '+';
        var isSubtractedTypes = ['-', // Discount
        'EPRICE', // Now indicates "ePrice difference"
        'SICI', // Stack Itemized Cash Incentive
        'SICCI', // Stack Itemized Conditional Cash Incentive
        'SICNI', // Stack non-Itemized Cash Incentives
        'SICCNI', // Stack non-Itemized Conditional Cash Incentive
        'CCIC' // Conditional Category Incentive Cash
        ];
        var isSubtracted = isSubtractedTypes.includes(_type);
        var isTotal = _type === 'TOTAL' || // Represents the last price in the rule
        _type === 'SICF' || // Final price including conditional incentives
        _type === 'SIF' || // Final price including stack incentives
        isFinalPrice;
        var totalValueClass = isTotal ? finalPriceFontWeight : '';
        var isEpriceFinal; // Remove when removing flag

        if (isFinalPriceFlagEnabled) {
          // Keep the next line when removing flag and make isEpriceFinal a const
          isEpriceFinal = detailType === 'ePrice' && _type === 'TOTAL'; // TODO: remove when VCDA is fixed
          // Hack to get around VCDA error where the final ePrice has _type="MIDDLE" instead of "TOTAL"

          isEpriceFinal = isEpriceFinal || detailType === 'ePrice' && lastPriceType === 'EPRICE';
        } else {
          isEpriceFinal = detailType === 'ePrice' && isFinalPrice;
        }

        var isIncentive = !!incentiveId;

        var incentiveLinkMarkup = _react.default.createElement("button", {
          className: (0, _utility.setClassNames)('text-link', 'd-block', isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall')
        }, _react.default.createElement(_common.Common, {
          render: function render(_ref2) {
            var labels = _ref2.labels;
            return labels.get(_labels.DETAILS);
          }
        }));

        var lineBreakMarkup = _react.default.createElement("dd", {
          className: "pricing-divider my-3",
          key: "".concat(_type, "-divider")
        });

        var hasLineBreak = false;
        var subtractedValueClass = '';
        var ePriceClass = '';
        var formattedPrice = formattedValue;
        var canadaDisclaimerMarkup = null;

        if (isStackedFinal) {
          hasLineBreak = true;
        }

        if (isPlusMinus) {
          adjustmentDetected = true;
          hasLineBreak = false;
        } else {
          if (adjustmentDetected === true) {
            hasLineBreak = true;
          }

          adjustmentDetected = false;
        }

        if (isSubtracted) {
          if (formatted === _labels.PLEASE_CALL) {
            formattedPrice = formattedValue;
          } else {
            formattedPrice = isMobile ? "- ".concat(formattedValue) : "-".concat(formattedValue);
            subtractedValueClass = "".concat(priceDiscountColor);
          }
        }

        if (isEpriceFinal) {
          ePriceClass = 'eprice';
        }

        if (isFinalPrice) {
          typeClass = 'final-price';
          totalValueClass = (0, _utility.setClassNames)(totalValueClass, finalPriceColor, finalPriceClasses); // suppressing finalPriceSize for final pricing that contains PLEASE_CALL value

          if (formatted !== _labels.PLEASE_CALL) {
            totalValueClass = "".concat(totalValueClass, " ").concat(finalPriceSize);
            canadaDisclaimerMarkup = _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
              dealerAddress: dealerAddress
            });
          }

          if (alwaysShowFinalPriceSeparator === 'true' && index > 0) {
            hasLineBreak = true;
          }
        }

        var isStyleEditable = vehicleTypeClass !== '' && typeClass !== ''; // TODO: remove when VCDA is fixed
        // Hack to get around VCDA error where the final ePrice has _type="MIDDLE" instead of "TOTAL"

        lastPriceType = _type;
        return [hasLineBreak ? lineBreakMarkup : '', _react.default.createElement("dt", {
          "data-style-editor-price": isStyleEditable ? 'true' : null,
          className: (0, _utility.setClassNames)(isIncentive ? 'pointer' : '', isStyleEditable ? typeClass : '', priceLabelClasses),
          onClick: function onClick() {
            _this.linkToModal(isIncentive, incentiveId);
          },
          key: "".concat(_type, "-dt")
        }, _react.default.createElement(_common.Common, {
          render: function render(_ref3) {
            var prefs = _ref3.prefs,
                labels = _ref3.labels;
            var label = PricingDetail.getLabel({
              price: price,
              prefs: prefs,
              labels: labels,
              locale: locale
            });
            return _react.default.createElement(_LabelAsHTML.default, {
              label: label,
              isStyleEditable: isStyleEditable,
              typeClass: typeClass,
              vehicleTypeClass: vehicleTypeClass
            });
          }
        }), isIncentive ? incentiveLinkMarkup : ''), _react.default.createElement("dd", {
          "data-style-editor-price": isStyleEditable ? 'true' : null,
          onClick: function onClick() {
            _this.linkToModal(isIncentive, incentiveId);
          },
          className: (0, _utility.setClassNames)(subtractedValueClass, totalValueClass, ePriceClass, isIncentive ? 'pointer' : '', isStyleEditable ? typeClass : ''),
          key: "".concat(_type, "-dd")
        }, _react.default.createElement("span", {
          className: (0, _utility.setClassNames)('price-value', valueClass),
          "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-value") : null,
          "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-value") : null
        }, formattedPrice)), canadaDisclaimerMarkup];
      }));
    }
  }], [{
    key: "getLabel",
    value: function getLabel(_ref4) {
      var price = _ref4.price,
          prefs = _ref4.prefs,
          labels = _ref4.labels,
          locale = _ref4.locale;
      var title = price.title,
          shortTitle = price.shortTitle,
          typeClass = price.typeClass,
          isFinalPrice = price.isFinalPrice,
          incentiveId = price.incentiveId;
      var label = price.label; // Conditional final price label is coming from BE as a label ID and not a translated label.
      // TODO remove this logic once CONDITIONAL_FINAL_PRICE label is being properly translated from BE.

      if (label === 'CONDITIONAL_FINAL_PRICE') {
        label = labels.get('CONDITIONAL_FINAL_PRICE');
      }

      var titlePref = prefs.incentiveTitleDisplay;
      var incentiveLabel = label;

      if (incentiveId) {
        if (title && title[locale] && titlePref === 'regular') {
          incentiveLabel = title[locale];
        }

        if (shortTitle && shortTitle[locale] && titlePref === 'descriptive') {
          incentiveLabel = shortTitle[locale];
        }

        if (titlePref === 'custom' && typeClass === 'discount' && !isFinalPrice) {
          incentiveLabel = labels.get(prefs.incentiveTitleCustom);
        }
      }

      return incentiveLabel;
    }
  }]);

  return PricingDetail;
}(_react.default.Component);

exports.default = PricingDetail;
PricingDetail.propTypes = {
  detail: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    typeClass: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool,
    incentives: _propTypes.default.arrayOf(_propTypes.default.string)
  })).isRequired,
  detailType: _propTypes.default.string,
  incentiveData: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    error: _propTypes.default.string
  }).isRequired).isRequired,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string.isRequired,
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    vehicleType: _propTypes.default.string.isRequired
  }).isRequired,
  showModal: _propTypes.default.func.isRequired,
  prefs: _propTypes.default.shape({
    priceDiscountColor: _propTypes.default.string,
    finalPriceSize: _propTypes.default.string,
    finalPriceColor: _propTypes.default.string,
    finalPriceFontWeight: _propTypes.default.string,
    finalPriceClasses: _propTypes.default.string,
    priceLabelClasses: _propTypes.default.string,
    alwaysShowFinalPriceSeparator: _propTypes.default.string
  }).isRequired,
  locale: _propTypes.default.string,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isFinalPriceFlagEnabled: _propTypes.default.bool.isRequired
};
PricingDetail.defaultProps = {
  detailType: '',
  locale: 'en_US',
  dealerAddress: {}
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

var _LoanLeaseModal = __webpack_require__(20);

var _DisclaimerContent = _interopRequireDefault(__webpack_require__(13));

var _constants = __webpack_require__(6);

var _utility = __webpack_require__(2);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var PricingLoanLease =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingLoanLease, _React$Component);

  function PricingLoanLease() {
    var _this;

    _classCallCheck(this, PricingLoanLease);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingLoanLease).call(this));
    _this.state = {
      showDisclaimer: false,
      disclaimerTitle: _react.default.createElement("span", null),
      disclaimerContent: _react.default.createElement("span", null)
    };
    _this.renderLayout = _this.renderLayout.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getLoanLeaseModalOptions = _this.getLoanLeaseModalOptions.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.toggleDisclaimer = _this.toggleDisclaimer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderList = _this.renderList.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingLoanLease, [{
    key: "getLoanLeaseModalOptions",
    value: function getLoanLeaseModalOptions(isMobile) {
      var _this$state = this.state,
          showDisclaimer = _this$state.showDisclaimer,
          disclaimerTitle = _this$state.disclaimerTitle,
          disclaimerContent = _this$state.disclaimerContent;
      return {
        isMobile: isMobile,
        showState: showDisclaimer,
        closeMethod: this.toggleDisclaimer,
        title: disclaimerTitle,
        body: disclaimerContent
      };
    }
  }, {
    key: "toggleDisclaimer",
    value: function toggleDisclaimer() {
      var disclaimerTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.default.createElement("span", null);
      var disclaimerContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _react.default.createElement("span", null);
      this.setState({
        showDisclaimer: !this.state.showDisclaimer,
        disclaimerTitle: disclaimerTitle,
        disclaimerContent: disclaimerContent
      });
    }
  }, {
    key: "renderList",
    value: function renderList(item, index, listSize, labels, prefs) {
      var toggleDisclaimer = this.toggleDisclaimer;
      var _type = item._type,
          label = item.label,
          formatted = item.formatted,
          dealershipName = item.dealershipName;
      var paymentLabelColor = prefs.paymentLabelColor,
          paymentLabelFontSize = prefs.paymentLabelFontSize,
          paymentPriceFontWeight = prefs.paymentPriceFontWeight,
          paymentPriceFontSize = prefs.paymentPriceFontSize,
          paymentPriceColor = prefs.paymentPriceColor,
          paymentPriceClasses = prefs.paymentPriceClasses,
          hideButtonDecorationOnLoanLeaseHelpIcon = prefs.hideButtonDecorationOnLoanLeaseHelpIcon,
          pricingDetailLoanLeaseHelpIconColor = prefs.pricingDetailLoanLeaseHelpIconColor;
      var isLeasePayment = _type === _constants.LEASE;
      var SECOND_ITEM = 2;
      var disclaimer = isLeasePayment ? _labels.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE : _labels.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
      var disclaimerPlaceholder = (0, _utility.getDisclaimerPlaceholderObj)(item);
      var disclaimerTitle = isLeasePayment ? _labels.EST_LEASE_DISCLAIMER_HEADING : _labels.EST_FINANCE_DISCLAIMER_HEADING;
      var listPosition = listSize === SECOND_ITEM ? 'two-item' : 'one-item';
      var border = index === SECOND_ITEM ? 'border-left' : null;
      var listClass = [listPosition, border];

      var DynamicDisclaimerContent = _react.default.createElement(_DisclaimerContent.default, {
        placeholderValuesObj: disclaimerPlaceholder,
        disclaimerLabel: disclaimer,
        dealershipName: dealershipName
      });

      var iconHtml = _react.default.createElement("i", {
        className: (0, _utility.setClassNames)('ddc-icon', 'ddc-icon-help-circle', 'ddc-icon-size-small', 'd-inline-block', 'pl-1', pricingDetailLoanLeaseHelpIconColor),
        "aria-hidden": "true"
      });

      var decorationClass = hideButtonDecorationOnLoanLeaseHelpIcon === 'true' ? 'btn-no-decoration' : '';

      var labelHtml = _react.default.createElement("span", {
        className: (0, _utility.setClassNames)('d-block', 'text-nowrap', paymentLabelColor, paymentLabelFontSize)
      }, labels.get(label), _react.default.createElement("button", {
        className: (0, _utility.setClassNames)('btn-link', 'p-0', decorationClass),
        onClick: function onClick() {
          return toggleDisclaimer(labels.get(disclaimerTitle), DynamicDisclaimerContent);
        },
        "aria-label": labels.get(_labels.CLICK_TO_VIEW_DISCLAIMER)
      }, iconHtml));

      var priceHtml = _react.default.createElement("strong", {
        className: (0, _utility.setClassNames)('line-height-reset', paymentPriceFontWeight, paymentPriceFontSize, paymentPriceColor, paymentPriceClasses)
      }, formatted);

      var termHtml = _react.default.createElement("span", {
        className: "ddc-font-size-small text-muted"
      }, labels.get('SLASH_MO'));

      return _react.default.createElement("li", {
        className: "".concat(listClass.filter(Boolean).join(' ')),
        key: "".concat(label)
      }, labelHtml, _react.default.createElement("span", null, priceHtml, termHtml));
    }
  }, {
    key: "renderLayout",
    value: function renderLayout(_ref) {
      var labels = _ref.labels,
          prefs = _ref.prefs;
      var summary = this.props.summary;
      var renderList = this.renderList;
      var paymentBoxPadding = prefs.paymentBoxPadding,
          paymentBoxBackground = prefs.paymentBoxBackground;
      var layoutClasses = 'pricing-loan-lease list-unstyled d-flex mb-0';
      var paddingClasses = "px-".concat(paymentBoxPadding, " py-").concat(paymentBoxPadding);
      var componentClasses = [layoutClasses, paddingClasses, paymentBoxBackground];
      return _react.default.createElement("ul", {
        className: componentClasses.join(' ')
      }, summary.map(function (item, index) {
        return renderList(item, index + 1, summary.length, labels, prefs);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isMobile = _this$props.isMobile,
          isScrollingSidebar = _this$props.isScrollingSidebar;
      var renderLoanLease = null;

      if (!isScrollingSidebar) {
        /* props for the LoanLeaseModal component */
        var options = this.getLoanLeaseModalOptions(isMobile);
        renderLoanLease = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_common.Common, {
          render: this.renderLayout
        }), _react.default.createElement(_LoanLeaseModal.LoanLeaseModal, options));
      }

      return renderLoanLease;
    }
  }]);

  return PricingLoanLease;
}(_react.default.Component);

PricingLoanLease.propTypes = {
  isMobile: _propTypes.default.bool.isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    key: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  isScrollingSidebar: _propTypes.default.bool.isRequired
};
var _default = PricingLoanLease;
exports.default = _default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _PricingSummary = _interopRequireDefault(__webpack_require__(14));

var _PricingSummaryPortal = _interopRequireDefault(__webpack_require__(30));

var _PricingSummaryFooterPortal = _interopRequireDefault(__webpack_require__(27));

var _analytics = __webpack_require__(11);

var _constants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isBrowser = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object';

var PricingSummaryContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryContainer, _React$Component);

  function PricingSummaryContainer(props) {
    var _this;

    _classCallCheck(this, PricingSummaryContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryContainer).call(this, props));
    _this.viewPriceDetail = _this.viewPriceDetail.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.scrollToAnchor = _this.scrollToAnchor.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingSummaryContainer, [{
    key: "viewPriceDetail",
    value: function viewPriceDetail() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      (0, _analytics.priceDetailsScrollEvent)(widgetName, windowId);
      this.scrollToAnchor();
    }
  }, {
    key: "scrollToAnchor",
    value: function scrollToAnchor() {
      var deviceType = this.props.widgetInfo.deviceType;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';
      var headerSelector = document && document.querySelector('[data-widget-id="template-navigation1"]');
      var scrollToSelector = '[data-widget-id="vehicle-title1"]';

      if (isMobile) {
        headerSelector = document && document.querySelector('[data-widget-id="template-navbar1"]');
        scrollToSelector = '[data-widget-id="detailed-pricing1"]';
      }

      var pageHeaderHeight = headerSelector && headerSelector.clientHeight || 0;

      if (DDC && DDC.scrollToAnchor) {
        /* eslint no-undef: 0 */
        DDC.scrollToAnchor($(scrollToSelector), {
          heightAdj: pageHeaderHeight + _constants.OFFSET_HEIGHT
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var deviceType = this.props.widgetInfo.deviceType;
      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          prefs = _this$props.prefs,
          summary = _this$props.summary,
          widgetInfo = _this$props.widgetInfo;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';

      if (isMobile) {
        if (isBrowser) {
          return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_PricingSummaryPortal.default, {
            prefs: prefs,
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            widgetInfo: widgetInfo,
            dealerAddress: dealerAddress,
            isMobile: isMobile
          }), _react.default.createElement(_PricingSummaryFooterPortal.default, {
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            dealerAddress: dealerAddress
          }));
        }

        return null;
      }

      return _react.default.createElement(_PricingSummary.default, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: this.viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      });
    }
  }]);

  return PricingSummaryContainer;
}(_react.default.Component);

exports.default = PricingSummaryContainer;
PricingSummaryContainer.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  })
};
PricingSummaryContainer.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(10));

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryFinalPrice = function PricingSummaryFinalPrice(_ref) {
  var price = _ref.price,
      buttonResetClasses = _ref.buttonResetClasses,
      viewPriceDetail = _ref.viewPriceDetail,
      finalLabelSize = _ref.finalLabelSize,
      finalPrice = _ref.finalPrice,
      finalPriceSize = _ref.finalPriceSize;

  if (price && price.isFinalPrice && finalPrice && viewPriceDetail) {
    return _react.default.createElement("button", {
      className: "".concat(buttonResetClasses, " w-100"),
      onClick: viewPriceDetail
    }, _react.default.createElement("span", {
      className: (0, _utility.setClassNames)('text-muted', 'd-block', finalLabelSize)
    }, _react.default.createElement(_LabelAsHTML.default, {
      label: price.label
    }), ' '), _react.default.createElement("strong", {
      className: (0, _utility.setClassNames)('line-height-reset', finalPriceSize)
    }, finalPrice));
  }

  return null;
};

PricingSummaryFinalPrice.propTypes = {
  price: _propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool.isRequired
  }).isRequired,
  buttonResetClasses: _propTypes.default.string,
  viewPriceDetail: _propTypes.default.func.isRequired,
  finalLabelSize: _propTypes.default.string,
  finalPrice: _propTypes.default.string.isRequired,
  finalPriceSize: _propTypes.default.string
};
PricingSummaryFinalPrice.defaultProps = {
  buttonResetClasses: '',
  finalLabelSize: '',
  finalPriceSize: ''
};
var _default = PricingSummaryFinalPrice;
exports.default = _default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(2);

__webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryFooter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooter, _React$Component);

  function PricingSummaryFooter() {
    _classCallCheck(this, PricingSummaryFooter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooter).apply(this, arguments));
  }

  _createClass(PricingSummaryFooter, [{
    key: "render",
    value: function render() {
      var _this = this;

      var summary = this.props.summary;
      var displayPrice = summary.find(function (price) {
        return price.isFinalPrice;
      });

      if (!displayPrice) {
        return null;
      }

      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var labels = _ref.labels;
          var dealershipNamePriceText = (0, _utility.replacePlaceholders)(labels.get(_labels.DEALERSHIP_NAME_PRICE), {
            '<%=dealershipName%>': displayPrice.dealershipName
          });
          var formattedValue = displayPrice.formatted;

          if (formattedValue === _labels.PLEASE_CALL) {
            formattedValue = labels.get(_labels.PLEASE_CALL);
          }

          return (// using aria-hidden based on conversation with Rachael Arnold
            // and Jon Ferry. The data in the footer section is redundant
            // and comes after the detailed pricing data in the DOM
            _react.default.createElement("div", {
              onClick: _this.props.viewPriceDetail,
              role: "button",
              "aria-hidden": true
            }, _react.default.createElement("ul", {
              className: "pricing-summary list-unstyled line-height-condensed mb-2"
            }, _react.default.createElement("li", {
              className: "text-muted"
            }, _react.default.createElement("span", {
              className: "d-block text-truncate"
            }, dealershipNamePriceText)), _react.default.createElement("li", null, _react.default.createElement("strong", {
              className: "pr-3"
            }, formattedValue), _react.default.createElement("span", {
              className: "text-link"
            }, labels.get(_labels.DETAILS)))))
          );
        }
      });
    }
  }]);

  return PricingSummaryFooter;
}(_react.default.Component);

exports.default = PricingSummaryFooter;
PricingSummaryFooter.propTypes = {
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(8));

var _PricingSummaryFooter = _interopRequireDefault(__webpack_require__(26));

var _utility = __webpack_require__(2);

var _CanadaDisclaimerContent = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryFooterPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooterPortal, _React$Component);

  function PricingSummaryFooterPortal(props) {
    var _this;

    _classCallCheck(this, PricingSummaryFooterPortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooterPortal).call(this, props));
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(PricingSummaryFooterPortal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.containerEl) {
        this.containerEl.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.containerEl = (0, _utility.getDOMContainer)(document, '.ddc-detailed-pricing-footer');

      if (this.containerEl) {
        this.containerEl.appendChild(this.el);
      }

      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary;

      var summaryComp = _react.default.createElement("div", null, _react.default.createElement(_PricingSummaryFooter.default, {
        summary: summary,
        viewPriceDetail: viewPriceDetail
      }), _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
        dealerAddress: dealerAddress,
        isFooter: true
      })); // if there is a pricing footer, render in portal


      if (this.containerEl) {
        return _reactDom.default.createPortal(summaryComp, this.el);
      }

      return summaryComp;
    }
  }]);

  return PricingSummaryFooterPortal;
}(_react.default.Component);

exports.default = PricingSummaryFooterPortal;
PricingSummaryFooterPortal.propTypes = {
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  viewPriceDetail: _propTypes.default.func.isRequired
};
PricingSummaryFooterPortal.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryLink = function PricingSummaryLink(_ref) {
  var label = _ref.label,
      labelFontSize = _ref.labelFontSize,
      isCalculatePayment = _ref.isCalculatePayment,
      viewPriceDetail = _ref.viewPriceDetail;
  var calcPaymentClasses = isCalculatePayment ? ['calculate-payment-integrated', 'calculate-payment-scroll-up'] : [];

  if (label) {
    return _react.default.createElement("button", {
      onClick: !isCalculatePayment ? viewPriceDetail : null,
      className: _utility.setClassNames.apply(void 0, ['text-link', 'text-left', 'd-block', 'line-height-reset', labelFontSize].concat(calcPaymentClasses))
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(label);
      }
    }));
  }

  return null;
};

PricingSummaryLink.propTypes = {
  label: _propTypes.default.string.isRequired,
  labelFontSize: _propTypes.default.string,
  isCalculatePayment: _propTypes.default.bool,
  viewPriceDetail: _propTypes.default.func
};
PricingSummaryLink.defaultProps = {
  labelFontSize: '',
  isCalculatePayment: false,
  viewPriceDetail: function viewPriceDetail() {}
};
var _default = PricingSummaryLink;
exports.default = _default;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(10));

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryPayments = function PricingSummaryPayments(_ref) {
  var price = _ref.price,
      paymentLabelSize = _ref.paymentLabelSize,
      paymentPrice = _ref.paymentPrice,
      paymentPriceSize = _ref.paymentPriceSize,
      handleHelpCircleIcon = _ref.handleHelpCircleIcon,
      pricingSummaryPaymentIntervalColor = _ref.pricingSummaryPaymentIntervalColor,
      pricingSummaryLoanLeaseHelpIconColor = _ref.pricingSummaryLoanLeaseHelpIconColor;

  if (price && !price.isFinalPrice && paymentPrice) {
    return _react.default.createElement("span", {
      className: "flex-grow-1"
    }, _react.default.createElement("span", {
      className: (0, _utility.setClassNames)('text-muted', 'text-nowrap', 'd-block', paymentLabelSize)
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return _react.default.createElement(_LabelAsHTML.default, {
          label: labels.get(price.label)
        });
      }
    }), _react.default.createElement("button", {
      className: "text-link line-height-reset help-icon",
      onClick: handleHelpCircleIcon
    }, _react.default.createElement("i", {
      className: (0, _utility.setClassNames)('ddc-icon', 'ddc-icon-help-circle', 'd-inline-block', 'pl-1', pricingSummaryLoanLeaseHelpIconColor),
      "aria-hidden": "true"
    }), _react.default.createElement(_common.Common, {
      render: function render(_ref3) {
        var labels = _ref3.labels;
        return _react.default.createElement("span", {
          className: "sr-only"
        }, labels.get(_labels.CLICK_TO_VIEW_DISCLAIMER));
      }
    }))), _react.default.createElement("strong", {
      className: (0, _utility.setClassNames)('line-height-reset', paymentPriceSize)
    }, paymentPrice), _react.default.createElement("span", {
      className: (0, _utility.setClassNames)('ddc-font-size-small', 'd-inline', 'line-height-reset', pricingSummaryPaymentIntervalColor)
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref4) {
        var labels = _ref4.labels;
        return labels.get(_labels.SLASH_MO);
      }
    })));
  }

  return null;
};

PricingSummaryPayments.propTypes = {
  price: _propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool.isRequired
  }).isRequired,
  paymentLabelSize: _propTypes.default.string,
  paymentPrice: _propTypes.default.string.isRequired,
  paymentPriceSize: _propTypes.default.string,
  handleHelpCircleIcon: _propTypes.default.func.isRequired,
  pricingSummaryPaymentIntervalColor: _propTypes.default.string,
  pricingSummaryLoanLeaseHelpIconColor: _propTypes.default.string
};
PricingSummaryPayments.defaultProps = {
  paymentLabelSize: '',
  paymentPriceSize: '',
  pricingSummaryPaymentIntervalColor: '',
  pricingSummaryLoanLeaseHelpIconColor: ''
};
var _default = PricingSummaryPayments;
exports.default = _default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(8));

var _PricingSummary = _interopRequireDefault(__webpack_require__(14));

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryPortal, _React$Component);

  function PricingSummaryPortal() {
    _classCallCheck(this, PricingSummaryPortal);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryPortal).apply(this, arguments));
  }

  _createClass(PricingSummaryPortal, [{
    key: "render",
    value: function render() {
      this.containerEl = (0, _utility.getDOMContainer)(document, '.ddc-vehicle-pricing-summary');
      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary,
          prefs = _this$props.prefs,
          widgetInfo = _this$props.widgetInfo,
          isMobile = _this$props.isMobile;

      var summaryComp = _react.default.createElement(_PricingSummary.default, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      }); // if there is a pricing summary, render in portal


      if (this.containerEl) {
        return _reactDom.default.createPortal(summaryComp, this.containerEl);
      }

      return null;
    }
  }]);

  return PricingSummaryPortal;
}(_react.default.Component);

exports.default = PricingSummaryPortal;
PricingSummaryPortal.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isMobile: _propTypes.default.bool.isRequired
};
PricingSummaryPortal.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _lodash = _interopRequireDefault(__webpack_require__(15));

var _melankeWatchjs = _interopRequireDefault(__webpack_require__(57));

var _InstantEPriceButton = _interopRequireDefault(__webpack_require__(19));

var _utility = __webpack_require__(2);

var _analytics = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var InstantEPriceContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InstantEPriceContainer, _React$Component);

  function InstantEPriceContainer(props) {
    var _this;

    _classCallCheck(this, InstantEPriceContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InstantEPriceContainer).call(this, props));
    _this.state = {
      isModalVisible: false,
      loadingUserProfile: true,
      userLoggedIn: false
    };
    _this.modalOpen = _this.modalOpen.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.modalClose = _this.modalClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.internalShowEprice = _this.internalShowEprice.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.checkUserProfile = _this.checkUserProfile.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(InstantEPriceContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _window = window,
          pubsub = _window.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.complete', function () {
          _this2.internalShowEprice();
        });
      } // if userProfile is loaded (!== undefined)


      if (window.DDC && window.DDC.userProfile) {
        this.checkUserProfile();
      } // if userProfile is not loaded yet (=== undefined) OR userProfile change its value


      _melankeWatchjs.default.watch(window.DDC, 'userProfile', this.checkUserProfile); // required to make instant eprice work on mobile


      var ddcSlideIn = (0, _lodash.default)(window, 'DDC.mobile.slidein', undefined);

      if (this.props.isMobile && ddcSlideIn) {
        ddcSlideIn.init();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _melankeWatchjs.default.noMore = true;
    }
  }, {
    key: "checkUserProfile",
    value: function checkUserProfile() {
      var _this3 = this;

      var userProfile = (0, _lodash.default)(window, 'DDC.userProfile', undefined);

      if (userProfile) {
        this.setState({
          loadingUserProfile: false
        });

        if (this.props.instantEpriceShowAllAfterLeadSubmit === 'true' && userProfile && Object.entries(userProfile).length !== 0 && !this.state.isModalVisible) {
          this.internalShowEprice();
        } else {
          var ePriceVehicles = userProfile.ePriceVehicles;

          if (ePriceVehicles) {
            var found = ePriceVehicles.find(function (vehicle) {
              return vehicle.itemUUID === _this3.props.widgetInfo.vehicleId;
            }); // when user has the vehicle in their profile

            if (found && !this.state.isModalVisible) {
              this.internalShowEprice();
            } // when user does not have the vehicle in their profile but logs into MyCars
            else if (userProfile.profileId) {
                this.setState({
                  userLoggedIn: true
                });
              }
          }
        }
      }
    }
  }, {
    key: "internalShowEprice",
    value: function internalShowEprice(e) {
      var _window2 = window,
          pubsub = _window2.pubsub;
      var ePriceDetail = this.props.ePriceDetail; // vcda does not always return an eprice detail

      if (ePriceDetail && pubsub) {
        var _extractEPriceData = (0, _utility.extractEPriceData)(ePriceDetail),
            ePriceValue = _extractEPriceData.ePriceValue,
            ePriceDifference = _extractEPriceData.ePriceDifference;

        pubsub.publish('instant-eprice.show', {
          ePriceDifference: ePriceDifference,
          yourEPrice: ePriceValue
        });
      }

      this.props.showEPrice();
      _melankeWatchjs.default.noMore = true;

      if (e) {
        (0, _analytics.ePriceButtonTrackEvent)(this.props.buttonLabel, this.props.widgetInfo.widgetName, this.props.widgetInfo.windowId, false);
      }
    }
  }, {
    key: "modalClose",
    value: function modalClose() {
      this.setState({
        isModalVisible: false
      });
      var _window3 = window,
          pubsub = _window3.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.open', this.modalOpen);
      }
    }
  }, {
    key: "modalOpen",
    value: function modalOpen() {
      this.setState({
        isModalVisible: true
      });
      var _window4 = window,
          pubsub = _window4.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.cancel', this.modalClose);
      }

      (0, _analytics.ePriceButtonTrackEvent)(this.props.buttonLabel, this.props.widgetInfo.widgetName, this.props.widgetInfo.windowId, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isDisplayingEprice = _this$props.isDisplayingEprice,
          buttonLabel = _this$props.buttonLabel,
          pendingLabel = _this$props.pendingLabel,
          _this$props$widgetInf = _this$props.widgetInfo,
          vehicleId = _this$props$widgetInf.vehicleId,
          vehicleCategory = _this$props$widgetInf.vehicleCategory,
          pageAlias = _this$props$widgetInf.pageAlias,
          buttonStyle = _this$props.buttonStyle,
          buttonMobileClass = _this$props.buttonMobileClass,
          disabled = _this$props.disabled,
          preventMultipleEpriceLeads = _this$props.preventMultipleEpriceLeads;
      var clickAction = this.modalOpen;

      if (isDisplayingEprice) {
        return null;
      }

      if (this.state.userLoggedIn) {
        clickAction = this.internalShowEprice;
      }

      return _react.default.createElement(_InstantEPriceButton.default, {
        key: "button",
        userLoggedIn: this.state.userLoggedIn,
        loadingUserProfile: this.state.loadingUserProfile,
        isModalVisible: this.state.isModalVisible,
        buttonLabel: buttonLabel,
        pendingLabel: pendingLabel,
        handleClick: clickAction,
        vehicleId: vehicleId,
        vehicleCategory: vehicleCategory,
        pageAlias: pageAlias,
        buttonStyle: buttonStyle,
        buttonMobileClass: buttonMobileClass,
        disabled: disabled,
        preventMultipleEpriceLeads: preventMultipleEpriceLeads
      });
    }
  }]);

  return InstantEPriceContainer;
}(_react.default.Component);

InstantEPriceContainer.propTypes = {
  showEPrice: _propTypes.default.func.isRequired,
  isDisplayingEprice: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  ePriceDetail: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    key: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool,
    incentives: _propTypes.default.arrayOf(_propTypes.default.string)
  })),
  buttonLabel: _propTypes.default.string.isRequired,
  pendingLabel: _propTypes.default.string.isRequired,
  widgetInfo: _propTypes.default.shape({
    vehicleId: _propTypes.default.string.isRequired,
    vehicleCategory: _propTypes.default.string.isRequired,
    pageAlias: _propTypes.default.string.isRequired,
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired
  }).isRequired,
  buttonStyle: _propTypes.default.string,
  buttonMobileClass: _propTypes.default.string.isRequired,
  instantEpriceShowAllAfterLeadSubmit: _propTypes.default.string,
  isMobile: _propTypes.default.bool.isRequired,
  preventMultipleEpriceLeads: _propTypes.default.bool.isRequired
};
InstantEPriceContainer.defaultProps = {
  ePriceDetail: [],
  buttonStyle: 'primary',
  instantEpriceShowAllAfterLeadSubmit: 'false'
};
var _default = InstantEPriceContainer;
exports.default = _default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WidgetContainer = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(12);

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _wsmIncentiveModal = __webpack_require__(61);

var _wsmPricingDisplay = _interopRequireDefault(__webpack_require__(62));

var _utility = __webpack_require__(2);

var _PricingDetail = _interopRequireDefault(__webpack_require__(22));

var _PricingLoanLease = _interopRequireDefault(__webpack_require__(23));

var _PricingSummaryContainer = _interopRequireDefault(__webpack_require__(24));

var _InstantEPrice = _interopRequireDefault(__webpack_require__(31));

var _PaymentCalculatorButton = __webpack_require__(21);

var _labels = __webpack_require__(4);

var _constants = __webpack_require__(6);

__webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer(props) {
    var _this;

    _classCallCheck(this, WidgetContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).call(this, props));
    _this.state = {
      incentive: {},
      isModalVisible: false,
      isDisplayingEprice: false,
      isScrollingSidebar: false,
      layout: _constants.SRP
    };
    _this.showEPrice = _this.showEPrice.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.trackScrollingSidebar = _this.trackScrollingSidebar.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.showModal = _this.showModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.hideModal = _this.hideModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.setLayoutType = _this.setLayoutType.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.deviceType === 'DESKTOP') {
        window.addEventListener('scroll', this.trackScrollingSidebar);
      }

      if (window && window.document && window.document.getElementsByTagName('html')[0].className.includes(_constants.VDP.toLowerCase())) {
        this.setLayoutType(_constants.VDP);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.deviceType === 'DESKTOP') {
        window.removeEventListener('scroll', this.trackScrollingSidebar);
      }
    }
  }, {
    key: "setLayoutType",
    value: function setLayoutType(layout) {
      this.setState({
        layout: layout
      });
    }
  }, {
    key: "showModal",
    value: function showModal(incentive) {
      this.setState({
        incentive: incentive,
        isModalVisible: true
      });
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      // deliberately do not reset the incentive so that
      // that data doesn't disappear as it slides off the screen,
      // esp. for mobile modal
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "showEPrice",
    value: function showEPrice() {
      this.setState({
        isDisplayingEprice: true
      });
    }
  }, {
    key: "trackScrollingSidebar",
    value: function trackScrollingSidebar() {
      // Tracks whether the sidebar is scrolling or not based on the height set
      this.setState({
        isScrollingSidebar: document.querySelector('.vdp-sidebar').style.top.length > 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          pricing = _this$props.pricing,
          _this$props$widgetInf = _this$props.widgetInfo,
          widgetInfo = _this$props$widgetInf === void 0 ? {
        windowId: ''
      } : _this$props$widgetInf,
          incentiveData = _this$props.incentiveData,
          windowId = _this$props.windowId,
          widgetName = _this$props.widgetName,
          deviceType = _this$props.deviceType,
          dealerAddress = _this$props.dealerAddress,
          locale = _this$props.locale,
          _this$props$account = _this$props.account,
          account = _this$props$account === void 0 ? {
        name: ''
      } : _this$props$account,
          _this$props$pricingMo = _this$props.pricingModuleData,
          pricingModuleData = _this$props$pricingMo === void 0 ? {} : _this$props$pricingMo;
      var accountId = widgetInfo.accountId,
          vehicleAccountId = widgetInfo.vehicleAccountId,
          vehicleType = widgetInfo.vehicleType;
      var isMobile = deviceType === 'MOBILE';
      var rootComponent = null;

      if (pricing) {
        var _pricingModuleData$us = pricingModuleData.useModule,
            useModule = _pricingModuleData$us === void 0 ? false : _pricingModuleData$us;

        if (useModule) {
          var _pricingModuleData$in = pricingModuleData.incentives,
              incentives = _pricingModuleData$in === void 0 ? {} : _pricingModuleData$in,
              condition = pricingModuleData.condition,
              vehicleId = pricingModuleData.vehicleId,
              inventoryData = pricingModuleData.inventoryData; // reform incentives

          var incentivesObj = {};
          incentives.forEach(function (incentive) {
            incentivesObj["[".concat(incentive.uniqueId, "]")] = incentive;
          });
          var dprice = inventoryData.dprice,
              eprice = inventoryData.eprice,
              loan = inventoryData.loan,
              lease = inventoryData.lease,
              retailPrice = inventoryData.retailPrice,
              ePriceStatus = inventoryData.ePriceStatus,
              ePriceButtonLabel = inventoryData.ePriceButtonLabel;
          var componentPricing = {
            dPrice: dprice,
            ePrice: eprice,
            loan: loan,
            lease: lease,
            retailPrice: retailPrice,
            ePriceStatus: ePriceStatus,
            ePriceButtonLabel: ePriceButtonLabel
          }; // New Pricing Module

          rootComponent = _react.default.createElement(_wsmPricingDisplay.default, {
            pricing: componentPricing,
            incentives: incentivesObj,
            accountInfo: account,
            condition: condition,
            vehicleId: vehicleId,
            layout: this.state.layout
          });
        } else {
          var _ePriceStatus = pricing.ePriceStatus;
          var disableInstantEpriceButton = false; // {epriceStatus : { status : <<enum>> }} where <<enum>> is one of the values below
          // ENABLED -> E-price is enabled/avaialble for the account, uuid combination.
          // DISABLED -> E-price is disabled/not available for the account, uuid combination. Reason for non availabilty is given in the reason string
          // NON_APPLICABLE -> E-price is not applicable for the account and uuid combination.

          if (_ePriceStatus && _ePriceStatus === 'DISABLED') {
            disableInstantEpriceButton = true;
          } // TODO: remove after VCDA release
          else if (!_ePriceStatus && pricing.summary) {
              var _eprice = pricing.summary.filter(function (x) {
                return x.priceType === 'EPRICE';
              })[0];
              var _dprice = pricing.summary.filter(function (x) {
                return x.priceType === 'DPRICE';
              })[0];

              if (_eprice && _dprice) {
                disableInstantEpriceButton = !(_eprice.value < _dprice.value);
              }
            }

          var detailType = pricing.detail.ePrice && this.state.isDisplayingEprice ? 'ePrice' : 'dPrice';
          var summary = (0, _utility.filterSummary)(pricing.summary, detailType);
          var loanLeaseSummary = (0, _utility.filterLoanLease)(pricing.summary);
          var incentiveModal;

          if (Object.keys(incentiveData).length) {
            incentiveModal = _react.default.createElement(_common.Common, {
              render: function render(_ref) {
                var prefs = _ref.prefs,
                    sitemap = _ref.sitemap;
                return _react.default.createElement(_wsmIncentiveModal.IncentiveModal, {
                  incentive: _this2.state.incentive,
                  isOpen: _this2.state.isModalVisible,
                  isMobile: isMobile,
                  onModalClose: _this2.hideModal,
                  widgetInfo: {
                    windowId: windowId,
                    widgetName: widgetName,
                    deviceType: deviceType
                  },
                  account: {
                    name: account.name,
                    id: account.id
                  },
                  newListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_NEW'),
                  usedListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_USED') // remove locale when when <Common /> is added to module
                  ,
                  locale: locale,
                  prefs: prefs
                });
              }
            });
          }

          rootComponent = _react.default.createElement(_common.Common, {
            render: function render(_ref2) {
              var flags = _ref2.flags,
                  prefs = _ref2.prefs,
                  labels = _ref2.labels;
              var ePricePendingLabel = labels.get(_labels.EPRICE_PENDING);
              var buttonMobileClass = prefs.showLoanLeasePricing === 'true' ? 'mb-4' : 'mb-0';
              var instantEpricePreventMultipleEpriceLeads = prefs.instantEpricePreventMultipleEpriceLeads === 'true';
              var instantEPriceContainer = (pricing.detail.ePrice || // TODO: remove once vcda flag for epricestatus is removed
              // and undefined ePriceStatus may denote that IEP is enabled but not configured
              // this check is the one place we can prevent the unconfigured IEP button from showing
              _ePriceStatus && _ePriceStatus !== 'NON_APPLICABLE') && ( // compare request account and vehicle account equality to determine
              // whether a vehicle is off-site
              prefs.showInstantEpriceForSharedInventory !== 'false' || accountId === vehicleAccountId) ? _react.default.createElement(_InstantEPrice.default, {
                showEPrice: _this2.showEPrice,
                isDisplayingEprice: _this2.state.isDisplayingEprice,
                instantEpriceShowAllAfterLeadSubmit: prefs.instantEpriceShowAllAfterLeadSubmit,
                ePriceDetail: pricing.detail.ePrice,
                buttonLabel: pricing.ePriceButtonLabel,
                pendingLabel: ePricePendingLabel,
                widgetInfo: _objectSpread({}, widgetInfo, {
                  windowId: windowId,
                  widgetName: widgetName
                }),
                buttonStyle: prefs.buttonStyleEPrice,
                buttonMobileClass: buttonMobileClass,
                preventMultipleEpriceLeads: instantEpricePreventMultipleEpriceLeads,
                isMobile: isMobile,
                disabled: disableInstantEpriceButton
              }) : null;
              var isFinalPriceFlagEnabled = flags['ws-detailed-pricing.use-final-price-for-instant-eprice'] === true;
              var DDCExists = typeof window !== 'undefined' && typeof window.DDC !== 'undefined';
              var drEnable = false;
              /* eslint no-undef: 0 */

              if (DDCExists && DDC.getSiteProperty) {
                drEnable = DDC.getSiteProperty(prefs.paymentCalculatorButtonDisplayCondition);
              }

              return _react.default.createElement("div", null, _react.default.createElement(_PricingDetail.default, {
                detail: pricing.detail[detailType],
                detailType: detailType,
                widgetInfo: {
                  windowId: windowId,
                  widgetName: widgetName,
                  deviceType: deviceType,
                  vehicleType: vehicleType
                },
                prefs: prefs,
                showModal: _this2.showModal,
                incentiveData: incentiveData,
                locale: locale,
                dealerAddress: dealerAddress,
                isFinalPriceFlagEnabled: isFinalPriceFlagEnabled
              }), _react.default.createElement(_PricingSummaryContainer.default, {
                summary: summary,
                prefs: prefs,
                dealerAddress: dealerAddress,
                widgetInfo: {
                  windowId: windowId,
                  widgetName: widgetName,
                  deviceType: deviceType
                }
              }), instantEPriceContainer, loanLeaseSummary.length > 0 && prefs.showLoanLeasePricing === 'true' && _react.default.createElement(_PricingLoanLease.default, {
                summary: loanLeaseSummary,
                isMobile: isMobile,
                isScrollingSidebar: _this2.state.isScrollingSidebar
              }), drEnable && _react.default.createElement(_PaymentCalculatorButton.PaymentCalculatorButton, {
                isLoanLeaseAvailable: loanLeaseSummary.length > 0 && prefs.showLoanLeasePricing === 'true',
                isScrollingSidebar: _this2.state.isScrollingSidebar,
                isMobile: isMobile,
                prefs: prefs,
                labels: labels
              }), incentiveModal);
            }
          }) // Common
          ;
        }
      }

      return rootComponent;
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

exports.WidgetContainer = WidgetContainer;
WidgetContainer.propTypes = {
  pricing: _propTypes.default.shape({
    detail: _propTypes.default.shape({
      dPrice: _propTypes.default.arrayOf(_propTypes.default.shape({
        _type: _propTypes.default.string.isRequired,
        formatted: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        value: _propTypes.default.number.isRequired,
        incentives: _propTypes.default.arrayOf(_propTypes.default.string)
      })).isRequired,
      ePrice: _propTypes.default.arrayOf(_propTypes.default.shape({
        _type: _propTypes.default.string.isRequired,
        formatted: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        value: _propTypes.default.number.isRequired,
        incentives: _propTypes.default.arrayOf(_propTypes.default.string)
      }))
    }),
    summary: _propTypes.default.arrayOf(_propTypes.default.shape({
      _type: _propTypes.default.string.isRequired,
      formatted: _propTypes.default.string.isRequired,
      label: _propTypes.default.string.isRequired,
      value: _propTypes.default.number.isRequired
    })),
    ePriceButtonLabel: _propTypes.default.string.isRequired,
    ePriceStatus: _propTypes.default.string
  }),
  incentiveData: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    disclaimer: _propTypes.default.string,
    make: _propTypes.default.string,
    condition: _propTypes.default.string,
    manufacturerOffer: _propTypes.default.bool,
    specific: _propTypes.default.object,
    error: _propTypes.default.string
  }).isRequired).isRequired,
  widgetInfo: _propTypes.default.shape({
    vehicleId: _propTypes.default.string.isRequired,
    vehicleCategory: _propTypes.default.string.isRequired,
    vehicleType: _propTypes.default.string.isRequired,
    pageAlias: _propTypes.default.string.isRequired,
    accountId: _propTypes.default.string.isRequired,
    vehicleAccountId: _propTypes.default.string.isRequired
  }).isRequired,
  windowId: _propTypes.default.string.isRequired,
  widgetName: _propTypes.default.string.isRequired,
  deviceType: _propTypes.default.string.isRequired,
  locale: _propTypes.default.string,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  account: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string
  }).isRequired,
  // Eventually all data will be only what pricingModule requires.
  // For now we have an LD feature flag that swaps between old ws-detailed-pricing and using pricing module
  pricingModuleData: _propTypes.default.shape({
    useModule: _propTypes.default.bool.isRequired,
    condition: _propTypes.default.string.isRequired,
    vehicleId: _propTypes.default.string.isRequired,
    incentives: _propTypes.default.array.isRequired,
    inventoryData: _propTypes.default.shape({
      dprice: _propTypes.default.arrayOf(_propTypes.default.shape({
        value: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        type: _propTypes.default.string.isRequired
      })),
      loan: _propTypes.default.shape({
        value: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        type: _propTypes.default.string.isRequired
      }),
      lease: _propTypes.default.shape({
        value: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        type: _propTypes.default.string.isRequired
      })
    }).isRequired
  })
};
WidgetContainer.defaultProps = {
  pricing: [],
  locale: 'en_US',
  dealerAddress: {},
  pricingModuleData: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    pricing: state.pricing,
    widgetInfo: state.widgetInfo,
    incentiveData: state.incentive.incentiveData,
    windowId: state.requestData.windowId,
    widgetName: state.requestData.widgetName,
    deviceType: state.requestData.deviceType,
    locale: state.requestData.locale,
    dealerAddress: state.dealerAddress,
    account: state.account,
    pricingModuleData: state.pricingModuleData
  };
};

var mapDispatchToProps = function mapDispatchToProps(_dispatch) {
  return {};
};

var Widget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);
var _default = Widget;
exports.default = _default;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = account;

var _types = __webpack_require__(5);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  name: ''
};

function account() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_ACCOUNT:
        return _objectSpread({}, state, action.payload);

      default:
    }
  }

  return state;
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dealerAddress;

var _types = __webpack_require__(5);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  address1: '',
  address2: '',
  address3: '',
  city: '',
  state: '',
  postalCode: '',
  country: ''
};

function dealerAddress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_DEALER_ADDRESS:
        return _objectSpread({}, state, action.payload);

      default:
    }
  }

  return state;
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = incentive;

var _types = __webpack_require__(5);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  incentiveData: [{
    key: '',
    title: '',
    shortTitle: '',
    label: '',
    offerDetails: '',
    effectiveDate: '',
    expirationDate: '',
    conditional: false,
    disclaimer: '',
    make: '',
    condition: '',
    manufacturerOffer: false,
    specific: {},
    error: ''
  }]
};

function incentive() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error) {
    switch (action.type) {
      case _types.SET_INCENTIVE:
        return _objectSpread({}, state, {
          incentiveData: _toConsumableArray(state.incentiveData).concat(_toConsumableArray(action.payload))
        });

      default:
    }
  }

  return state;
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dealerAddress = _interopRequireDefault(__webpack_require__(35));

var _pricing = _interopRequireDefault(__webpack_require__(39));

var _incentive = _interopRequireDefault(__webpack_require__(36));

var _modal = _interopRequireDefault(__webpack_require__(38));

var _widgetInfo = _interopRequireDefault(__webpack_require__(41));

var _account = _interopRequireDefault(__webpack_require__(34));

var _pricingModule = _interopRequireDefault(__webpack_require__(40));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  dealerAddress: _dealerAddress.default,
  pricing: _pricing.default,
  incentive: _incentive.default,
  modal: _modal.default,
  widgetInfo: _widgetInfo.default,
  account: _account.default,
  pricingModuleData: _pricingModule.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modal;

var _types = __webpack_require__(5);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialModalState = {
  show: false,
  incentiveKey: ' '
};

function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialModalState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_MODAL:
        return _objectSpread({}, state, {
          show: action.payload.show,
          incentiveKey: action.payload.incentiveKey
        });

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pricing;

var _types = __webpack_require__(5);

function pricing() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_PRICING:
        return action.payload;

      default:
    }
  }

  return state;
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pricingModuleData;

var _types = __webpack_require__(5);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  useModule: false
};

function pricingModuleData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_PRICING_MODULE:
        return _objectSpread({}, state, action.payload);

      default:
    }
  }

  return state;
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetInfo;

var _types = __webpack_require__(5);

function widgetInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    if (action.type && action.type === _types.SET_WIDGET_INFO) {
      var _action$payload = action.payload,
          accountId = _action$payload.accountId,
          pageAlias = _action$payload.pageAlias,
          vehicleAccountId = _action$payload.vehicleAccountId,
          vehicleCategory = _action$payload.vehicleCategory,
          vehicleType = _action$payload.vehicleType,
          vehicleId = _action$payload.vehicleId;
      return {
        accountId: accountId,
        pageAlias: pageAlias,
        vehicleAccountId: vehicleAccountId,
        vehicleCategory: vehicleCategory,
        vehicleType: vehicleType,
        vehicleId: vehicleId
      };
    }
  }

  return state;
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _root = __webpack_require__(58);

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(12);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(43));

var _Collapse = _interopRequireDefault(__webpack_require__(42));

var _Widget = _interopRequireDefault(__webpack_require__(32));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: The eslint-disable-line is needed because this file won't lint
// when it's in the ws-scripts repo because the file only exists in the
// widget. It's safe because the entire application won't work if the
// file wasn't really resolved. It would be really apparent quickly.
// eslint-disable-line import/no-unresolved
var getWidgetClasses = function getWidgetClasses(widgetClasses, widgetName, toggleCollapse) {
  var classes = ['ddc-content', widgetName];

  if (widgetClasses) {
    classes.push(widgetClasses);
  }

  if (toggleCollapse) {
    classes.push('collapse-container');
  }

  return classes;
};

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var WidgetWrapper = function WidgetWrapper(_ref) {
  var outputWrapperDiv = _ref.outputWrapperDiv,
      store = _ref.store,
      widgetId = _ref.widgetId,
      widgetName = _ref.widgetName;
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;

  var wrapping = _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(_Widget.default, null)));

  if (outputWrapperDiv) {
    if (!widgetName) {
      throw new Error('widgetName is required if outputWrapperDiv is true.');
    }

    return _react.default.createElement("div", {
      id: "".concat(widgetId, "-app-root"),
      className: getWidgetClasses(prefs.widgetClasses, widgetName, toggleCollapse).join(' '),
      "data-widget-name": widgetName,
      "data-widget-id": widgetId
    }, wrapping);
  }

  return wrapping;
};

WidgetWrapper.propTypes = {
  outputWrapperDiv: _propTypes.default.bool.isRequired,
  store: _propTypes.default.shape({
    getState: _propTypes.default.func.isRequired
  }).isRequired,
  widgetId: _propTypes.default.string.isRequired,
  widgetName: _propTypes.default.string
};
var _default = WidgetWrapper;
exports.default = _default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(63);

var _reduxThunk = _interopRequireDefault(__webpack_require__(64));

var _reducers = _interopRequireDefault(__webpack_require__(37));

var _requestData = _interopRequireDefault(__webpack_require__(48));

var _prefs = _interopRequireDefault(__webpack_require__(47));

var _labels = _interopRequireDefault(__webpack_require__(46));

var _sitemap = _interopRequireDefault(__webpack_require__(49));

var _flags = _interopRequireDefault(__webpack_require__(45));

var _middleware = _interopRequireDefault(__webpack_require__(33));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-detailed-pricing - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(59),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * lodash 3.7.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseGet;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.8.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(56);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

module.exports = toPath;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * DEVELOPED BY
 * GIL LOPES BUENO
 * gilbueno.mail@gmail.com
 *
 * WORKS WITH:
 * IE8*, IE 9+, FF 4+, SF 5+, WebKit, CH 7+, OP 12+, BESEN, Rhino 1.7+
 * For IE8 (and other legacy browsers) WatchJS will use dirty checking  
 *
 * FORK:
 * https://github.com/melanke/Watch.JS
 *
 * LICENSE: MIT
 */


(function (factory) {
    if (true) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else {
        // Browser globals
        window.WatchJS = factory();
        window.watch = window.WatchJS.watch;
        window.unwatch = window.WatchJS.unwatch;
        window.callWatchers = window.WatchJS.callWatchers;
    }
}(function () {

    var WatchJS = {
        noMore: false,        // use WatchJS.suspend(obj) instead
        useDirtyCheck: false, // use only dirty checking to track changes.
        preserveExistingSetters: false
    },
    lengthsubjects = [];
    
    var dirtyChecklist = [];
    var pendingChanges = []; // used coalesce changes from defineProperty and __defineSetter__
    
    var supportDefineProperty = false;
    try {
        supportDefineProperty = Object.defineProperty && Object.defineProperty({},'x', {});
    } catch(ex) {  /* not supported */  }

    var isFunction = function (functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) == '[object Function]';
    };

    var isInt = function (x) {
        return x % 1 === 0;
    };

    var isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };

    var isObject = function(obj) {
        return {}.toString.apply(obj) === '[object Object]';
    };
    
    var getObjDiff = function(a, b){
        var aplus = [],
        bplus = [];

        if(!(typeof a == "string") && !(typeof b == "string")){

            if (isArray(a) && b) {
                for (var i=0; i<a.length; i++) {
                    if (b[i] === undefined) aplus.push(i);
                }
            } else {
                for(var i in a){
                    if (a.hasOwnProperty(i)) {
                        if(b && !b.hasOwnProperty(i)) {
                            aplus.push(i);
                        }
                    }
                }
            }

            if (isArray(b) && a) {
                for (var j=0; j<b.length; j++) {
                    if (a[j] === undefined) bplus.push(j);
                }
            } else {
                for(var j in b){
                    if (b.hasOwnProperty(j)) {
                        if(a && !a.hasOwnProperty(j)) {
                            bplus.push(j);
                        }
                    }
                }
            }
        }

        return {
            added: aplus,
            removed: bplus
        }
    };

    var clone = function(obj){

        if (null == obj || "object" != typeof obj) {
            return obj;
        }

        var copy = obj.constructor();

        for (var attr in obj) {
            copy[attr] = obj[attr];
        }

        return copy;        

    }

    var getExistingSetter = function (obj, propName) {
        if (WatchJS.preserveExistingSetters) {
            var existing = Object.getOwnPropertyDescriptor(obj, propName);
            return existing.set;
        }

        return undefined;
    }

    var defineGetAndSet = function (obj, propName, getter, setter) {
        try {
            var existingSetter = getExistingSetter(obj, propName);
            Object.defineProperty(obj, propName, {
                get: getter,
                set: function(value) {
                    setter.call(this, value, true); // coalesce changes
                    if (existingSetter) {
                        existingSetter(value);
                    }
                },
                enumerable: true,
                configurable: true
            });
        }
        catch(e1) {
            try{
                Object.prototype.__defineGetter__.call(obj, propName, getter);
                Object.prototype.__defineSetter__.call(obj, propName, function(value) {
                    setter.call(this,value,true); // coalesce changes
                });
            }
            catch(e2) {
                observeDirtyChanges(obj,propName,setter);
                //throw new Error("watchJS error: browser not supported :/")
            }
        }

    };

    var defineProp = function (obj, propName, value) {
        try {
            Object.defineProperty(obj, propName, {
                enumerable: false,
                configurable: true,
                writable: false,
                value: value
            });
        } catch(error) {
            obj[propName] = value;
        }
    };

    var observeDirtyChanges = function(obj,propName,setter) {
        dirtyChecklist[dirtyChecklist.length] = {
            prop:       propName,
            object:     obj,
            orig:       clone(obj[propName]),
            callback:   setter
        }        
    }
    
    var watch = function () {

        if (isFunction(arguments[1])) {
            watchAll.apply(this, arguments);
        } else if (isArray(arguments[1])) {
            watchMany.apply(this, arguments);
        } else {
            watchOne.apply(this, arguments);
        }

    };


    var watchAll = function (obj, watcher, level, addNRemove) {

        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if(isArray(obj)) {
            defineWatcher(obj, "__watchall__", watcher, level); // watch all changes on the array
            if (level===undefined||level > 0) {
                for (var prop = 0; prop < obj.length; prop++) { // watch objects in array
                   watchAll(obj[prop],watcher,level, addNRemove);
                }
            }
        } 
        else {
            var prop,props = [];
            for (prop in obj) { //for each attribute if obj is an object
                if (prop == "$val" || (!supportDefineProperty && prop === 'watchers')) {
                    continue;
                }

                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    props.push(prop); //put in the props
                }
            }
            watchMany(obj, props, watcher, level, addNRemove); //watch all items of the props
        }


        if (addNRemove) {
            pushToLengthSubjects(obj, "$$watchlengthsubjectroot", watcher, level);
        }
    };


    var watchMany = function (obj, props, watcher, level, addNRemove) {

        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        for (var i=0; i<props.length; i++) { //watch each property
            var prop = props[i];
            watchOne(obj, prop, watcher, level, addNRemove);
        }

    };

    var watchOne = function (obj, prop, watcher, level, addNRemove) {
        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if(isFunction(obj[prop])) { //dont watch if it is a function
            return;
        }
        if(obj[prop] != null && (level === undefined || level > 0)){
            watchAll(obj[prop], watcher, level!==undefined? level-1 : level); //recursively watch all attributes of this
        }

        defineWatcher(obj, prop, watcher, level);

        if(addNRemove && (level === undefined || level > 0)){
            pushToLengthSubjects(obj, prop, watcher, level);
        }

    };

    var unwatch = function () {

        if (isFunction(arguments[1])) {
            unwatchAll.apply(this, arguments);
        } else if (isArray(arguments[1])) {
            unwatchMany.apply(this, arguments);
        } else {
            unwatchOne.apply(this, arguments);
        }

    };

    var unwatchAll = function (obj, watcher) {

        if (obj instanceof String || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if (isArray(obj)) {
            var props = ['__watchall__'];
            for (var prop = 0; prop < obj.length; prop++) { //for each item if obj is an array
                props.push(prop); //put in the props
            }
            unwatchMany(obj, props, watcher); //watch all itens of the props
        } else {
            var unwatchPropsInObject = function (obj2) {
                var props = [];
                for (var prop2 in obj2) { //for each attribute if obj is an object
                    if (obj2.hasOwnProperty(prop2)) {
                        if (obj2[prop2] instanceof Object) {
                            unwatchPropsInObject(obj2[prop2]); //recurs into object props
                        } else {
                            props.push(prop2); //put in the props
                        }
                    }
                }
                unwatchMany(obj2, props, watcher); //unwatch all of the props
            };
            unwatchPropsInObject(obj);
        }
    };


    var unwatchMany = function (obj, props, watcher) {

        for (var prop2 in props) { //watch each attribute of "props" if is an object
            if (props.hasOwnProperty(prop2)) {
                unwatchOne(obj, props[prop2], watcher);
            }
        }
    };

    var timeouts = [],
        timerID = null;
    function clearTimerID() {
        timerID = null;
        for(var i=0; i< timeouts.length; i++) {
            timeouts[i]();
        }
        timeouts.length = 0;
    }
    var getTimerID= function () {
        if (!timerID)  {
            timerID = setTimeout(clearTimerID);
        }
        return timerID;
    }
    var registerTimeout = function(fn) { // register function to be called on timeout
        if (timerID==null) getTimerID();
        timeouts[timeouts.length] = fn;
    }
    
    // Track changes made to an array, object or an object's property 
    // and invoke callback with a single change object containing type, value, oldvalue and array splices
    // Syntax: 
    //      trackChange(obj, callback, recursive, addNRemove)
    //      trackChange(obj, prop, callback, recursive, addNRemove)
    var trackChange = function() {
        var fn = (isFunction(arguments[2])) ? trackProperty : trackObject ;
        fn.apply(this,arguments);
    }

    // track changes made to an object and invoke callback with a single change object containing type, value and array splices
    var trackObject= function(obj, callback, recursive, addNRemove) {
        var change = null,lastTimerID = -1;
        var isArr = isArray(obj);
        var level,fn = function(prop, action, newValue, oldValue) {
            var timerID = getTimerID();
            if (lastTimerID!==timerID) { // check if timer has changed since last update
                lastTimerID = timerID;
                change = {
                    type: 'update'
                }
                change['value'] = obj;
                change['splices'] = null;
                registerTimeout(function() {
                    callback.call(this,change);
                    change = null;
                });
            }
            // create splices for array changes
            if (isArr && obj === this && change !== null)  {                
                if (action==='pop'||action==='shift') {
                    newValue = [];
                    oldValue = [oldValue];
                }
                else if (action==='push'||action==='unshift') {
                    newValue = [newValue];
                    oldValue = [];
                }
                else if (action!=='splice') { 
                    return; // return here - for reverse and sort operations we don't need to return splices. a simple update will do
                }
                if (!change.splices) change.splices = [];
                change.splices[change.splices.length] = {
                    index: prop,
                    deleteCount: oldValue ? oldValue.length : 0,
                    addedCount: newValue ? newValue.length : 0,
                    added: newValue,
                    deleted: oldValue
                };
            }

        }  
        level = (recursive==true) ? undefined : 0;        
        watchAll(obj,fn, level, addNRemove);
    }
    
    // track changes made to the property of an object and invoke callback with a single change object containing type, value, oldvalue and splices
    var trackProperty = function(obj,prop,callback,recursive, addNRemove) { 
        if (obj && prop) {
            watchOne(obj,prop,function(prop, action, newvalue, oldvalue) {
                var change = {
                    type: 'update'
                }
                change['value'] = newvalue;
                change['oldvalue'] = oldvalue;
                if (recursive && isObject(newvalue)||isArray(newvalue)) {
                    trackObject(newvalue,callback,recursive, addNRemove);
                }               
                callback.call(this,change);
            },0)
            
            if (recursive && isObject(obj[prop])||isArray(obj[prop])) {
                trackObject(obj[prop],callback,recursive, addNRemove);
            }                           
        }
    }
    
    
    var defineWatcher = function (obj, prop, watcher, level) {
        var newWatcher = false;
        var isArr = isArray(obj);
        
        if (!obj.watchers) {
            defineProp(obj, "watchers", {});
            if (isArr) {
                // watch array functions
                watchFunctions(obj, function(index,action,newValue, oldValue) {
                    addPendingChange(obj, index, action,newValue, oldValue);
                    if (level !== 0 && newValue && (isObject(newValue) || isArray(newValue))) {
                        var i,n, ln, wAll, watchList = obj.watchers[prop];
                        if ((wAll = obj.watchers['__watchall__'])) {
                            watchList = watchList ? watchList.concat(wAll) : wAll;
                        }
                        ln = watchList ?  watchList.length : 0;
                        for (i = 0; i<ln; i++) {
                            if (action!=='splice') {
                                watchAll(newValue, watchList[i], (level===undefined)?level:level-1);
                            }
                            else {
                                // watch spliced values
                                for(n=0; n < newValue.length; n++) {
                                    watchAll(newValue[n], watchList[i], (level===undefined)?level:level-1);
                                }
                            }
                        }
                    }
                });
            }
        }

        if (!obj.watchers[prop]) {
            obj.watchers[prop] = [];
            if (!isArr) newWatcher = true;
        }

        for (var i=0; i<obj.watchers[prop].length; i++) {
            if(obj.watchers[prop][i] === watcher){
                return;
            }
        }

        obj.watchers[prop].push(watcher); //add the new watcher to the watchers array

        if (newWatcher) {
            var val = obj[prop];            
            var getter = function () {
                return val;                        
            };

            var setter = function (newval, delayWatcher) {
                var oldval = val;
                val = newval;                
                if (level !== 0 
                    && obj[prop] && (isObject(obj[prop]) || isArray(obj[prop]))
                    && !obj[prop].watchers) {
                    // watch sub properties
                    var i,ln = obj.watchers[prop].length; 
                    for(i=0; i<ln; i++) {
                        watchAll(obj[prop], obj.watchers[prop][i], (level===undefined)?level:level-1);
                    }
                }

                //watchFunctions(obj, prop);
                
                if (isSuspended(obj, prop)) {
                    resume(obj, prop);
                    return;
                }

                if (!WatchJS.noMore){ // this does not work with Object.observe
                    //if (JSON.stringify(oldval) !== JSON.stringify(newval)) {
                    if (oldval !== newval) {
                        if (!delayWatcher) {
                            callWatchers(obj, prop, "set", newval, oldval);
                        }
                        else {
                            addPendingChange(obj, prop, "set", newval, oldval);
                        }
                        WatchJS.noMore = false;
                    }
                }
            };

            if (WatchJS.useDirtyCheck) {
                observeDirtyChanges(obj,prop,setter);
            }
            else {
                defineGetAndSet(obj, prop, getter, setter);
            }
        }

    };

    var callWatchers = function (obj, prop, action, newval, oldval) {
        if (prop !== undefined) {
            var ln, wl, watchList = obj.watchers[prop];
            if ((wl = obj.watchers['__watchall__'])) {
                watchList = watchList ? watchList.concat(wl) : wl;
            }
            ln = watchList ? watchList.length : 0;
            for (var wr=0; wr< ln; wr++) {
                watchList[wr].call(obj, prop, action, newval, oldval);
            }
        } else {
            for (var prop in obj) {//call all
                if (obj.hasOwnProperty(prop)) {
                    callWatchers(obj, prop, action, newval, oldval);
                }
            }
        }
    };

    var methodNames = ['pop', 'push', 'reverse', 'shift', 'sort', 'slice', 'unshift', 'splice'];
    var defineArrayMethodWatcher = function (obj, original, methodName, callback) {
        defineProp(obj, methodName, function () {
            var index = 0;
            var i,newValue, oldValue, response;                        
            // get values before splicing array 
            if (methodName === 'splice') {
               var start = arguments[0];
               var end = start + arguments[1];
               oldValue = obj.slice(start,end);
               newValue = [];
               for(i=2;i<arguments.length;i++) {
                   newValue[i-2] = arguments[i];
               }
               index = start;
            } 
            else {
                newValue = arguments.length > 0 ? arguments[0] : undefined;
            } 

            response = original.apply(obj, arguments);
            if (methodName !== 'slice') {
                if (methodName === 'pop') {
                    oldValue = response;
                    index = obj.length;
                }
                else if (methodName === 'push') {
                    index = obj.length-1;
                }
                else if (methodName === 'shift') {
                    oldValue = response;
                }
                else if (methodName !== 'unshift' && newValue===undefined) {
                    newValue = response;
                }
                callback.call(obj, index, methodName,newValue, oldValue)
            }
            return response;
        });
    };

    var watchFunctions = function(obj, callback) {

        if (!isFunction(callback) || !obj || (obj instanceof String) || (!isArray(obj))) {
            return;
        }

        for (var i = methodNames.length, methodName; i--;) {
            methodName = methodNames[i];
            defineArrayMethodWatcher(obj, obj[methodName], methodName, callback);
        }

    };

    var unwatchOne = function (obj, prop, watcher) {
        if (prop) {
            if (obj.watchers && obj.watchers[prop]) {
                if (watcher === undefined) {
                    delete obj.watchers[prop]; // remove all property watchers
                }
                else {
                    for (var i = 0; i < obj.watchers[prop].length; i++) {
                        var w = obj.watchers[prop][i];
                        if (w == watcher) {
                            obj.watchers[prop].splice(i, 1);
                        }
                    }
                }
            }
        } else {
            delete obj.watchers;
        }

        removeFromLengthSubjects(obj, prop, watcher);
        removeFromDirtyChecklist(obj, prop);
    };
    
    // suspend watchers until next update cycle
    var suspend = function(obj, prop) {
        if (obj.watchers) {
            var name = '__wjs_suspend__'+(prop!==undefined ? prop : '');
            obj.watchers[name] = true;
        }
    }
    
    var isSuspended = function(obj, prop) {
        return obj.watchers 
               && (obj.watchers['__wjs_suspend__'] || 
                   obj.watchers['__wjs_suspend__'+prop]);
    }
    
    // resumes preivously suspended watchers
    var resume = function(obj, prop) {
        registerTimeout(function() {
            delete obj.watchers['__wjs_suspend__'];
            delete obj.watchers['__wjs_suspend__'+prop];
        })
    }

    var pendingTimerID = null;
    var addPendingChange = function(obj,prop, mode, newval, oldval) {
        pendingChanges[pendingChanges.length] = {
            obj:obj,
            prop: prop,
            mode: mode,
            newval: newval,
            oldval: oldval
        };
        if (pendingTimerID===null) {
            pendingTimerID = setTimeout(applyPendingChanges);
        }
    };
    
    
    var applyPendingChanges = function()  {
        // apply pending changes
        var change = null;
        pendingTimerID = null;
        for(var i=0;i < pendingChanges.length;i++) {
            change = pendingChanges[i];
            callWatchers(change.obj, change.prop, change.mode, change.newval, change.oldval);
        }
        if (change) {
            pendingChanges = [];
            change = null;
        }        
    }

    var loop = function(){

        // check for new or deleted props
        for(var i=0; i<lengthsubjects.length; i++) {

            var subj = lengthsubjects[i];

            if (subj.prop === "$$watchlengthsubjectroot") {

                var difference = getObjDiff(subj.obj, subj.actual);

                if(difference.added.length || difference.removed.length){
                    if(difference.added.length){
                        watchMany(subj.obj, difference.added, subj.watcher, subj.level - 1, true);
                    }

                    subj.watcher.call(subj.obj, "root", "differentattr", difference, subj.actual);
                }
                subj.actual = clone(subj.obj);


            } else {

                var difference = getObjDiff(subj.obj[subj.prop], subj.actual);

                if(difference.added.length || difference.removed.length){
                    if(difference.added.length){
                        for (var j=0; j<subj.obj.watchers[subj.prop].length; j++) {
                            watchMany(subj.obj[subj.prop], difference.added, subj.obj.watchers[subj.prop][j], subj.level - 1, true);
                        }
                    }

                    callWatchers(subj.obj, subj.prop, "differentattr", difference, subj.actual);
                }

                subj.actual = clone(subj.obj[subj.prop]);

            }

        }
        
        // start dirty check
        var n, value;
        if (dirtyChecklist.length > 0) {
            for (var i = 0; i < dirtyChecklist.length; i++) {
                n = dirtyChecklist[i];
                value = n.object[n.prop];
                if (!compareValues(n.orig, value)) {
                    n.orig = clone(value);
                    n.callback(value);
                }
            }
        }

    };

    var compareValues =  function(a,b) {
        var i, state = true;
        if (a!==b)  {
            if (isObject(a)) {
                for(i in a) {
                    if (!supportDefineProperty && i==='watchers') continue;
                    if (a[i]!==b[i]) {
                        state = false;
                        break;
                    };
                }
            }
            else {
                state = false;
            }
        }
        return state;
    }
    
    var pushToLengthSubjects = function(obj, prop, watcher, level){

        var actual;

        if (prop === "$$watchlengthsubjectroot") {
            actual =  clone(obj);
        } else {
            actual = clone(obj[prop]);
        }

        lengthsubjects.push({
            obj: obj,
            prop: prop,
            actual: actual,
            watcher: watcher,
            level: level
        });
    };

    var removeFromLengthSubjects = function(obj, prop, watcher){
        for (var i=0; i<lengthsubjects.length; i++) {
            var subj = lengthsubjects[i];

            if (subj.obj == obj) {
                if (!prop || subj.prop == prop) {
                    if (!watcher || subj.watcher == watcher) {
                        // if we splice off one item at position i
                        // we need to decrement i as the array is one item shorter
                        // so when we increment i in the loop statement we
                        // will land at the correct index.
                        // if it's not decremented, you won't delete all length subjects
                        lengthsubjects.splice(i--, 1);
                    }
                }
            }
        }

    };
    
    var removeFromDirtyChecklist = function(obj, prop){
        var notInUse;
        for (var i=0; i<dirtyChecklist.length; i++) {
            var n = dirtyChecklist[i];
            var watchers = n.object.watchers;
            notInUse = (
                n.object == obj 
                && (!prop || n.prop == prop)
                && watchers
                && (!prop || !watchers[prop] || watchers[prop].length == 0 )
            );
            if (notInUse)  {
                // we use the same syntax as in removeFromLengthSubjects
                dirtyChecklist.splice(i--, 1);
            }
        }

    };    

    setInterval(loop, 50);

    WatchJS.watch = watch;
    WatchJS.unwatch = unwatch;
    WatchJS.callWatchers = callWatchers;
    WatchJS.suspend = suspend; // suspend watchers    
    WatchJS.onChange = trackChange;  // track changes made to object or  it's property and return a single change object

    return WatchJS;

}));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

if (false) {
  var hot = require('./index').hot;
  if (module.hot) {
    var cache = require.cache;

    if (!module.parents || module.parents.length === 0) {
      throw new Error(
        'React-Hot-Loader: `react-hot-loader/root` is not supported on your system. ' +
        'Please use `import {hot} from "react-hot-loader"` instead'
      );
    }
    // access parent
    var parent = cache[module.parents[0]];
    if (!parent) {
      throw new Error(
        'React-Hot-Loader: `react-hot-loader/root` is not supported on your system. ' +
        'Please use `import {hot} from "react-hot-loader"` instead'
      );
    }
    // remove self from a cache
    delete cache[module.id];
  }
  // setup hot for caller
  exports.hot = hot(parent);
} else {
  // prod mode
  exports.hot = function (a) {
    return a;
  };
}


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 60 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IncentiveModal", function() { return IncentiveModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__);




function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var AND = 'AND';
var OR = 'OR';
var DETAILS = 'DETAILS';
var DISCLAIMER = 'DISCLAIMER';
var PERCENT_APR_FOR = 'PERCENT_APR_FOR';
var PER_MONTH = 'PER_MONTH';
var MONTHS = 'MONTHS';
var CASH_BACK = 'CASH_BACK';
var CASH_DUE_AT_SIGNING = 'CASH_DUE_AT_SIGNING';
var VIEW_APPLICABLE_VEHICLES = 'VIEW_APPLICABLE_VEHICLES';
var CASH_OFFER_FROM = 'CASH_OFFER_FROM';
var FINANCE_AND_CASH_OFFER_FROM = 'FINANCE_AND_CASH_OFFER_FROM';
var FINANCE_OR_CASH_OFFER_FROM = 'FINANCE_OR_CASH_OFFER_FROM';
var FINANCE_OFFER_FROM = 'FINANCE_OFFER_FROM';
var LEASE_OFFER_FROM = 'LEASE_OFFER_FROM';
var PROMOTION_FROM = 'PROMOTION_FROM';

// Temporary list of labels and the "labelObj" class to replicate labels.get() from ws-scripts
// Needed until <Common/> is broken out of ws-scripts for use in modules
var labels = {
  AND: {
    en: 'and',
    es: 'y',
    fr: 'et'
  },
  OR: {
    en: 'or',
    es: 'o',
    fr: 'ou'
  },
  DETAILS: {
    en: 'Details',
    es: 'Detalles',
    fr: 'Détails'
  },
  DISCLAIMER: {
    en: 'Disclaimer',
    es: 'Exención de responsabilidad',
    fr: 'Avertissement'
  },
  EFFECTIVE_THROUGH_X: {
    en: 'Effective through {{END_DATE}}',
    es: 'En vigencia hasta el {{END_DATE}}',
    fr: 'Efficace jusqu\'au {{END_DATE}}'
  },
  EFFECTIVE_X_THROUGH_X: {
    en: 'Effective {{START_DATE}} through {{END_DATE}}',
    es: 'Efectivo desde el {{START_DATE}} hasta el {{END_DATE}}',
    fr: 'En vigueur {{START_DATE}} à {{END_DATE}}'
  },
  PERCENT_APR_FOR: {
    en: '% APR for',
    es: '% tasa de porcentaje anual',
    fr: "% taux d'intérêt annuel"
  },
  PER_MONTH: {
    en: 'per month',
    es: 'por mes',
    fr: 'par mois'
  },
  MONTHS: {
    en: 'months',
    es: 'meses',
    fr: 'mois'
  },
  CASH_BACK: {
    en: 'cash back',
    es: 'reembolso',
    fr: 'argent en remise'
  },
  CASH_DUE_AT_SIGNING: {
    en: 'cash due at signing',
    es: 'pago en efectivo al firmar',
    fr: 'argent dû au moment de la signature'
  },
  VIEW_APPLICABLE_VEHICLES: {
    en: 'view applicable vehicles',
    es: 'ver vehículos aplicables',
    fr: 'voir les véhicules applicables'
  },
  CASH_OFFER_FROM: {
    en: 'Cash Offer from',
    es: 'Oferta en Efectivo de',
    fr: 'Offre en Espèces de'
  },
  FINANCE_AND_CASH_OFFER_FROM: {
    en: 'APR Finance and Cash Offer from',
    es: 'APR Finance y Oferta en Efectivo de',
    fr: 'APR Offre de Financement et en Espèces de'
  },
  FINANCE_OR_CASH_OFFER_FROM: {
    en: 'APR Finance or Cash Offer from',
    es: 'APR Finance o Oferta en Efectivo de',
    fr: 'APR Offre de Financement ou en Espèces de'
  },
  FINANCE_OFFER_FROM: {
    en: 'APR Finance Offer from',
    es: 'APR Finance Offer de',
    fr: 'APR Finance Offre de'
  },
  LEASE_OFFER_FROM: {
    en: 'Lease Offer from',
    es: 'Oferta de arrendamiento de',
    fr: 'Offre de location de'
  },
  PROMOTION_FROM: {
    en: 'Promotion from',
    es: 'Promoción desde',
    fr: 'Promotion à partir de'
  }
};

var LabelObj = function LabelObj() {
  var _this = this;

  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en_US';

  _classCallCheck(this, LabelObj);

  this.locale = locale;

  this.get = function () {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    // Return untranslated label by default
    var translatedLabel = label;

    var language = _this.locale.split('_')[0];

    if (labels[label]) {
      if (labels[label][language]) {
        // Label exists for this language
        translatedLabel = labels[label][language];
      } else if (labels[label].en) {
        // Default to English
        translatedLabel = labels[label].en;
      }
    }

    return translatedLabel;
  };
};

var ListingLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListingLink, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function ListingLink(props) {
    var _this;

    _classCallCheck(this, ListingLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListingLink).call(this, props));
    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(ListingLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentiveId = _this$props.incentiveId,
          incentiveAccountId = _this$props.incentiveAccountId,
          incentiveName = _this$props.incentiveName,
          condition = _this$props.condition,
          newListingPath = _this$props.newListingPath,
          usedListingPath = _this$props.usedListingPath;
      var url = '';

      if (condition === 'NEW') {
        url = newListingPath;
      } else {
        url = usedListingPath;
      }

      if (url) {
        url = "".concat(url, "?incentiveId=").concat(encodeURIComponent(incentiveId), "&incentiveAccountId=").concat(encodeURIComponent(incentiveAccountId));

        if (condition === 'CERTIFIED') {
          url = "".concat(url, "&compositeType=certified");
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          className: "small text-capitalize",
          href: url,
          "data-ga-event": "incentives|click|view inventory",
          "data-incentive-id": incentiveId,
          "data-incentive-name": incentiveName
        }, this.labels.get(VIEW_APPLICABLE_VEHICLES));
      } else {
        return null;
      }
    }
  }]);

  return ListingLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
ListingLink.propTypes = {
  incentiveId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  incentiveAccountId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  incentiveName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  newListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  usedListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
ListingLink.defaultProps = {
  incentiveName: '',
  condition: 'NEW',
  newListingPath: null,
  usedListingPath: null
};

function parseIncentiveKey(key) {
  var incentiveInfo = {
    incentiveAccountId: '',
    incentiveId: ''
  };

  if (typeof key === 'string') {
    var keyParsed = key.split('_');

    if (keyParsed.length > 1) {
      incentiveInfo = {
        incentiveAccountId: keyParsed[0],
        incentiveId: keyParsed[1]
      };
    }
  }

  return incentiveInfo;
}
function formatNumber(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';

  if (typeof num !== 'number') {
    return '';
  }

  return new Intl.NumberFormat(locale.replace('_', '-')).format(num);
}
function formatCurrency(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var showFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = {
    style: 'currency',
    currency: locale.length && locale.indexOf('CA') > -1 ? 'CAD' : 'USD'
  };
  var currencyValue;

  if (typeof num !== 'number') {
    return '';
  }

  if (showFractionDigits) {
    // two fraction digits (aka decimal places) by default
    currencyValue = num;
  } else {
    currencyValue = Math.round(num);
    options.minimumFractionDigits = 0;
  }

  return new Intl.NumberFormat(locale.replace('_', '-'), options).format(currencyValue);
}

var TermsList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TermsList, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function TermsList(props) {
    var _this;

    _classCallCheck(this, TermsList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TermsList).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(TermsList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          incentiveTerms = _this$props.incentiveTerms,
          locale = _this$props.locale;
      var termsList = null;

      if (incentiveTerms && incentiveTerms.length) {
        var terms;
        incentiveTerms.forEach(function (item) {
          terms = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, terms, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
            className: "list-group-item p-0 pb-1"
          }, "".concat(formatNumber(item.value, locale)).concat(_this2.labels.get(PERCENT_APR_FOR), " ").concat(item.term, " ").concat(_this2.labels.get(MONTHS))));
        });
        termsList = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
          className: "list-group list-group-flush mt-4"
        }, terms);
      }

      return termsList;
    }
  }]);

  return TermsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
TermsList.propTypes = {
  incentiveTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    term: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })),
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
TermsList.defaultProps = {
  incentiveTerms: []
};

var SpecificDetails =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SpecificDetails, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function SpecificDetails(props) {
    var _this;

    _classCallCheck(this, SpecificDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpecificDetails).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(SpecificDetails, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          locale = _this$props.locale,
          showEffectiveStartDate = _this$props.prefs.showEffectiveStartDate;
      var details = null;

      if (incentive && incentive.specific) {
        var effectiveDate = incentive.effectiveDate,
            expirationDate = incentive.expirationDate,
            specific = incentive.specific;
        var effectiveDates = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, showEffectiveStartDate.toLowerCase() === 'true' ? "".concat(this.labels.get('EFFECTIVE_X_THROUGH_X').replace(/({{\w+_?}})/gm, function (word) {
          if (word === '{{START_DATE}}') return effectiveDate;
          if (word === '{{END_DATE}}') return expirationDate;
        })) : "".concat(this.labels.get('EFFECTIVE_THROUGH_X').replace('{{END_DATE}}', expirationDate)));
        var cashBack = specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null;
        var cashDue = specific.cashDue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.cashDue, locale), " ").concat(this.labels.get(CASH_DUE_AT_SIGNING))) : null;
        var payment = specific.monthlyPayment ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.monthlyPayment, locale), " ").concat(this.labels.get(PER_MONTH)), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null) : '';

        if (specific._type) {
          switch (specific._type) {
            case 'CASH':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, cashBack, effectiveDates);
              break;

            case 'FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), effectiveDates, cashDue);
              break;

            case 'CASH_AND_FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.labels.get(AND)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'CASH_OR_FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.labels.get(OR)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'LEASE':
              // TODO: Missing "lease term" field from VCDA
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, payment, effectiveDates, cashDue);
              break;

            case 'UNDEFINED_TERM':
              // TODO: Missing "apr" field from VCDA
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, cashBack, effectiveDates, cashDue);
              break;

            default:
              // PROMOTION
              details = effectiveDates;
          }
        }
      }

      return details;
    }
  }]);

  return SpecificDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
SpecificDetails.propTypes = {
  incentive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    offerDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    shortTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    effectiveDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    expirationDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    conditional: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    make: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    manufacturerOffer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    specific: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var defaultClickEvent = {
  widgetId: '',
  widgetName: 'wsm-incentive-modal',
  widgetState: 'default',
  event: 'widgetUserEvent',
  element: '',
  elementCTA: undefined,
  action: 'clicked',
  result: '',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = window.jQuery(document) || {};

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function viewSpecialsDetailsEvent(widgetName, widgetId, elementCTA) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    element: 'Specials details link',
    elementCTA: elementCTA,
    result: 'Opened dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}
function closeSpecialsDetailsEvent(widgetName, widgetId) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    widgetState: 'Special dialog',
    element: 'Close button',
    result: 'Closed dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}

var IncentiveModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentiveModal, _React$Component);

  function IncentiveModal(props) {
    var _this;

    _classCallCheck(this, IncentiveModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncentiveModal).call(this, props)); // TODO: remove LabelObj when <Common /> is added for labels

    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
    _this.onOpen = _this.onOpen.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(IncentiveModal, [{
    key: "onOpen",
    value: function onOpen() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          _this$props$widgetInf = _this$props.widgetInfo,
          windowId = _this$props$widgetInf.windowId,
          widgetName = _this$props$widgetInf.widgetName; // Track when modal is opened

      if (incentive && Object.keys(incentive).length > 0) {
        var title = incentive.title;
        viewSpecialsDetailsEvent(widgetName, windowId, title);
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var _this$props2 = this.props,
          onModalClose = _this$props2.onModalClose,
          _this$props2$widgetIn = _this$props2.widgetInfo,
          windowId = _this$props2$widgetIn.windowId,
          widgetName = _this$props2$widgetIn.widgetName;
      onModalClose(); // Track when modal is closed

      closeSpecialsDetailsEvent(widgetName, windowId);
    }
  }, {
    key: "getOfferType",
    value: function getOfferType(specific, manufacturerOffer, make, accountName) {
      var issuer = accountName;

      if (manufacturerOffer) {
        issuer = make;
      }

      var typeHeading = PROMOTION_FROM;

      if (specific && specific._type) {
        switch (specific._type) {
          case 'CASH':
            typeHeading = CASH_OFFER_FROM;
            break;

          case 'FINANCE':
          case 'UNDEFINED_TERM':
            typeHeading = FINANCE_OFFER_FROM;
            break;

          case 'CASH_AND_FINANCE':
            typeHeading = FINANCE_AND_CASH_OFFER_FROM;
            break;

          case 'CASH_OR_FINANCE':
            typeHeading = FINANCE_OR_CASH_OFFER_FROM;
            break;

          case 'LEASE':
            typeHeading = LEASE_OFFER_FROM;
            break;

          default:
            // PROMOTION
            typeHeading = PROMOTION_FROM;
        }
      }

      return "".concat(this.labels.get(typeHeading), " ").concat(issuer);
    }
  }, {
    key: "getIncentiveDetails",
    value: function getIncentiveDetails() {
      var _this$props3 = this.props,
          incentive = _this$props3.incentive,
          newListingPath = _this$props3.newListingPath,
          usedListingPath = _this$props3.usedListingPath,
          account = _this$props3.account,
          locale = _this$props3.locale,
          prefs = _this$props3.prefs;
      var key = incentive.key,
          specific = incentive.specific,
          title = incentive.title,
          shortTitle = incentive.shortTitle,
          offerDetails = incentive.offerDetails,
          make = incentive.make,
          condition = incentive.condition,
          manufacturerOffer = incentive.manufacturerOffer;

      var _parseIncentiveKey = parseIncentiveKey(key),
          incentiveId = _parseIncentiveKey.incentiveId,
          incentiveAccountId = _parseIncentiveKey.incentiveAccountId;

      var offerType = this.getOfferType(specific, manufacturerOffer, make, account.name);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "mt-2 mb-0 h5",
        "data-testid": "offerType"
      }, offerType), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "mt-0"
      }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "mt-2 mb-0 h5 text-capitalize"
      }, this.labels.get(DETAILS)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, offerDetails), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpecificDetails, {
        incentive: incentive,
        locale: locale,
        prefs: prefs
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListingLink, {
        incentiveId: incentiveId,
        incentiveAccountId: incentiveAccountId,
        incentiveName: shortTitle,
        condition: condition,
        newListingPath: newListingPath,
        usedListingPath: usedListingPath,
        locale: locale
      }));
    }
  }, {
    key: "getIncentiveDisclaimer",
    value: function getIncentiveDisclaimer(disclaimer) {
      var incentiveDisclaimer = null;

      if (disclaimer) {
        incentiveDisclaimer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "text-muted small mt-4"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(this.labels.get(DISCLAIMER), ": ").concat(disclaimer)));
      }

      return incentiveDisclaimer;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          incentive = _this$props4.incentive,
          isMobile = _this$props4.isMobile,
          isOpen = _this$props4.isOpen;
      var shortTitle = incentive.shortTitle,
          disclaimer = incentive.disclaimer;
      var incentiveDetails = this.getIncentiveDetails();
      var incentiveDisclaimer = this.getIncentiveDisclaimer(disclaimer);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"], {
        show: isOpen,
        onHide: this.onClose,
        onShow: this.onOpen,
        className: "m-1 ".concat(isMobile ? 'dock-right' : null)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Header, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Title, {
        className: "text-center"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        "aria-label": "Close",
        className: "close text-muted",
        onClick: this.onClose
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
        className: "ddc-icon ddc-icon-close",
        "aria-hidden": "true"
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "h3 my-0 px-5"
      }, shortTitle))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Body, null, incentiveDetails, incentiveDisclaimer));
    }
  }]);

  return IncentiveModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
IncentiveModal.propTypes = {
  incentive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    offerDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    shortTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    effectiveDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    expirationDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    conditional: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    make: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    manufacturerOffer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    specific: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired,
  widgetInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    windowId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    widgetName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    deviceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onModalClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  account: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  newListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  usedListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    showEffectiveStartDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};
IncentiveModal.defaultProps = {
  newListingPath: null,
  usedListingPath: null,
  locale: 'en_US',
  prefs: {
    showEffectiveStartDate: 'true'
  }
};


//# sourceMappingURL=es.js.map


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wsm_common_data__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wsm_common_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}








function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }

  return target;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

var AND = 'AND';
var OR = 'OR';
var DETAILS = 'DETAILS';
var DISCLAIMER = 'DISCLAIMER';
var PERCENT_APR_FOR = 'PERCENT_APR_FOR';
var PER_MONTH = 'PER_MONTH';
var MONTHS = 'MONTHS';
var CASH_BACK = 'CASH_BACK';
var CASH_DUE_AT_SIGNING = 'CASH_DUE_AT_SIGNING';
var VIEW_APPLICABLE_VEHICLES = 'VIEW_APPLICABLE_VEHICLES';
var CASH_OFFER_FROM = 'CASH_OFFER_FROM';
var FINANCE_AND_CASH_OFFER_FROM = 'FINANCE_AND_CASH_OFFER_FROM';
var FINANCE_OR_CASH_OFFER_FROM = 'FINANCE_OR_CASH_OFFER_FROM';
var FINANCE_OFFER_FROM = 'FINANCE_OFFER_FROM';
var LEASE_OFFER_FROM = 'LEASE_OFFER_FROM';
var PROMOTION_FROM = 'PROMOTION_FROM'; // Temporary list of labels and the "labelObj" class to replicate labels.get() from ws-scripts
// Needed until <Common/> is broken out of ws-scripts for use in modules

var labels = {
  AND: {
    en: 'and',
    es: 'y',
    fr: 'et'
  },
  OR: {
    en: 'or',
    es: 'o',
    fr: 'ou'
  },
  DETAILS: {
    en: 'Details',
    es: 'Detalles',
    fr: 'Détails'
  },
  DISCLAIMER: {
    en: 'Disclaimer',
    es: 'Exención de responsabilidad',
    fr: 'Avertissement'
  },
  EFFECTIVE_THROUGH_X: {
    en: 'Effective through {{END_DATE}}',
    es: 'En vigencia hasta el {{END_DATE}}',
    fr: 'Efficace jusqu\'au {{END_DATE}}'
  },
  EFFECTIVE_X_THROUGH_X: {
    en: 'Effective {{START_DATE}} through {{END_DATE}}',
    es: 'Efectivo desde el {{START_DATE}} hasta el {{END_DATE}}',
    fr: 'En vigueur {{START_DATE}} à {{END_DATE}}'
  },
  PERCENT_APR_FOR: {
    en: '% APR for',
    es: '% tasa de porcentaje anual',
    fr: "% taux d'intérêt annuel"
  },
  PER_MONTH: {
    en: 'per month',
    es: 'por mes',
    fr: 'par mois'
  },
  MONTHS: {
    en: 'months',
    es: 'meses',
    fr: 'mois'
  },
  CASH_BACK: {
    en: 'cash back',
    es: 'reembolso',
    fr: 'argent en remise'
  },
  CASH_DUE_AT_SIGNING: {
    en: 'cash due at signing',
    es: 'pago en efectivo al firmar',
    fr: 'argent dû au moment de la signature'
  },
  VIEW_APPLICABLE_VEHICLES: {
    en: 'view applicable vehicles',
    es: 'ver vehículos aplicables',
    fr: 'voir les véhicules applicables'
  },
  CASH_OFFER_FROM: {
    en: 'Cash Offer from',
    es: 'Oferta en Efectivo de',
    fr: 'Offre en Espèces de'
  },
  FINANCE_AND_CASH_OFFER_FROM: {
    en: 'APR Finance and Cash Offer from',
    es: 'APR Finance y Oferta en Efectivo de',
    fr: 'APR Offre de Financement et en Espèces de'
  },
  FINANCE_OR_CASH_OFFER_FROM: {
    en: 'APR Finance or Cash Offer from',
    es: 'APR Finance o Oferta en Efectivo de',
    fr: 'APR Offre de Financement ou en Espèces de'
  },
  FINANCE_OFFER_FROM: {
    en: 'APR Finance Offer from',
    es: 'APR Finance Offer de',
    fr: 'APR Finance Offre de'
  },
  LEASE_OFFER_FROM: {
    en: 'Lease Offer from',
    es: 'Oferta de arrendamiento de',
    fr: 'Offre de location de'
  },
  PROMOTION_FROM: {
    en: 'Promotion from',
    es: 'Promoción desde',
    fr: 'Promotion à partir de'
  }
};

var LabelObj = function LabelObj() {
  var _this = this;

  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en_US';

  _classCallCheck$1(this, LabelObj);

  this.locale = locale;

  this.get = function () {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''; // Return untranslated label by default

    var translatedLabel = label;

    var language = _this.locale.split('_')[0];

    if (labels[label]) {
      if (labels[label][language]) {
        // Label exists for this language
        translatedLabel = labels[label][language];
      } else if (labels[label].en) {
        // Default to English
        translatedLabel = labels[label].en;
      }
    }

    return translatedLabel;
  };
};

var ListingLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(ListingLink, _React$Component); // TODO: remove constructor when <Common /> is added for labels


  function ListingLink(props) {
    var _this;

    _classCallCheck$1(this, ListingLink);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(ListingLink).call(this, props));
    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass$1(ListingLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentiveId = _this$props.incentiveId,
          incentiveAccountId = _this$props.incentiveAccountId,
          incentiveName = _this$props.incentiveName,
          condition = _this$props.condition,
          newListingPath = _this$props.newListingPath,
          usedListingPath = _this$props.usedListingPath;
      var url = '';

      if (condition === 'NEW') {
        url = newListingPath;
      } else {
        url = usedListingPath;
      }

      if (url) {
        url = "".concat(url, "?incentiveId=").concat(encodeURIComponent(incentiveId), "&incentiveAccountId=").concat(encodeURIComponent(incentiveAccountId));

        if (condition === 'CERTIFIED') {
          url = "".concat(url, "&compositeType=certified");
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          className: "small text-capitalize",
          href: url,
          "data-ga-event": "incentives|click|view inventory",
          "data-incentive-id": incentiveId,
          "data-incentive-name": incentiveName
        }, this.labels.get(VIEW_APPLICABLE_VEHICLES));
      } else {
        return null;
      }
    }
  }]);

  return ListingLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ListingLink.propTypes = {
  incentiveId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  incentiveAccountId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  incentiveName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  newListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  usedListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
ListingLink.defaultProps = {
  incentiveName: '',
  condition: 'NEW',
  newListingPath: null,
  usedListingPath: null
};

function parseIncentiveKey(key) {
  var incentiveInfo = {
    incentiveAccountId: '',
    incentiveId: ''
  };

  if (typeof key === 'string') {
    var keyParsed = key.split('_');

    if (keyParsed.length > 1) {
      incentiveInfo = {
        incentiveAccountId: keyParsed[0],
        incentiveId: keyParsed[1]
      };
    }
  }

  return incentiveInfo;
}

function formatNumber(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';

  if (typeof num !== 'number') {
    return '';
  }

  return new Intl.NumberFormat(locale.replace('_', '-')).format(num);
}

function formatCurrency(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var showFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = {
    style: 'currency',
    currency: locale.length && locale.indexOf('CA') > -1 ? 'CAD' : 'USD'
  };
  var currencyValue;

  if (typeof num !== 'number') {
    return '';
  }

  if (showFractionDigits) {
    // two fraction digits (aka decimal places) by default
    currencyValue = num;
  } else {
    currencyValue = Math.round(num);
    options.minimumFractionDigits = 0;
  }

  return new Intl.NumberFormat(locale.replace('_', '-'), options).format(currencyValue);
}

var TermsList =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(TermsList, _React$Component); // TODO: remove constructor when <Common /> is added for labels


  function TermsList(props) {
    var _this;

    _classCallCheck$1(this, TermsList);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(TermsList).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass$1(TermsList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          incentiveTerms = _this$props.incentiveTerms,
          locale = _this$props.locale;
      var termsList = null;

      if (incentiveTerms && incentiveTerms.length) {
        var terms;
        incentiveTerms.forEach(function (item) {
          terms = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, terms, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
            className: "list-group-item p-0 pb-1"
          }, "".concat(formatNumber(item.value, locale)).concat(_this2.labels.get(PERCENT_APR_FOR), " ").concat(item.term, " ").concat(_this2.labels.get(MONTHS))));
        });
        termsList = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
          className: "list-group list-group-flush mt-4"
        }, terms);
      }

      return termsList;
    }
  }]);

  return TermsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TermsList.propTypes = {
  incentiveTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    term: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })),
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
TermsList.defaultProps = {
  incentiveTerms: []
};

var SpecificDetails =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(SpecificDetails, _React$Component); // TODO: remove constructor when <Common /> is added for labels


  function SpecificDetails(props) {
    var _this;

    _classCallCheck$1(this, SpecificDetails);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(SpecificDetails).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass$1(SpecificDetails, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          locale = _this$props.locale,
          showEffectiveStartDate = _this$props.prefs.showEffectiveStartDate;
      var details = null;

      if (incentive && incentive.specific) {
        var effectiveDate = incentive.effectiveDate,
            expirationDate = incentive.expirationDate,
            specific = incentive.specific;
        var effectiveDates = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, showEffectiveStartDate.toLowerCase() === 'true' ? "".concat(this.labels.get('EFFECTIVE_X_THROUGH_X').replace(/({{\w+_?}})/gm, function (word) {
          if (word === '{{START_DATE}}') return effectiveDate;
          if (word === '{{END_DATE}}') return expirationDate;
        })) : "".concat(this.labels.get('EFFECTIVE_THROUGH_X').replace('{{END_DATE}}', expirationDate)));
        var cashBack = specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null;
        var cashDue = specific.cashDue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.cashDue, locale), " ").concat(this.labels.get(CASH_DUE_AT_SIGNING))) : null;
        var payment = specific.monthlyPayment ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.monthlyPayment, locale), " ").concat(this.labels.get(PER_MONTH)), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null) : '';

        if (specific._type) {
          switch (specific._type) {
            case 'CASH':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, cashBack, effectiveDates);
              break;

            case 'FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), effectiveDates, cashDue);
              break;

            case 'CASH_AND_FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.labels.get(AND)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'CASH_OR_FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.labels.get(OR)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'LEASE':
              // TODO: Missing "lease term" field from VCDA
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, payment, effectiveDates, cashDue);
              break;

            case 'UNDEFINED_TERM':
              // TODO: Missing "apr" field from VCDA
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, cashBack, effectiveDates, cashDue);
              break;

            default:
              // PROMOTION
              details = effectiveDates;
          }
        }
      }

      return details;
    }
  }]);

  return SpecificDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SpecificDetails.propTypes = {
  incentive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    offerDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    shortTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    effectiveDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    expirationDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    conditional: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    make: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    manufacturerOffer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    specific: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
var defaultClickEvent = {
  widgetId: '',
  widgetName: 'wsm-incentive-modal',
  widgetState: 'default',
  event: 'widgetUserEvent',
  element: '',
  elementCTA: undefined,
  action: 'clicked',
  result: '',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = window.jQuery(document) || {};

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function viewSpecialsDetailsEvent(widgetName, widgetId, elementCTA) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    element: 'Specials details link',
    elementCTA: elementCTA,
    result: 'Opened dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}

function closeSpecialsDetailsEvent(widgetName, widgetId) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    widgetState: 'Special dialog',
    element: 'Close button',
    result: 'Closed dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}

var IncentiveModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(IncentiveModal, _React$Component);

  function IncentiveModal(props) {
    var _this;

    _classCallCheck$1(this, IncentiveModal);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(IncentiveModal).call(this, props)); // TODO: remove LabelObj when <Common /> is added for labels

    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    _this.onClose = _this.onClose.bind(_assertThisInitialized$1(_this));
    _this.onOpen = _this.onOpen.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  _createClass$1(IncentiveModal, [{
    key: "onOpen",
    value: function onOpen() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          _this$props$widgetInf = _this$props.widgetInfo,
          windowId = _this$props$widgetInf.windowId,
          widgetName = _this$props$widgetInf.widgetName; // Track when modal is opened

      if (incentive && Object.keys(incentive).length > 0) {
        var title = incentive.title;
        viewSpecialsDetailsEvent(widgetName, windowId, title);
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var _this$props2 = this.props,
          onModalClose = _this$props2.onModalClose,
          _this$props2$widgetIn = _this$props2.widgetInfo,
          windowId = _this$props2$widgetIn.windowId,
          widgetName = _this$props2$widgetIn.widgetName;
      onModalClose(); // Track when modal is closed

      closeSpecialsDetailsEvent(widgetName, windowId);
    }
  }, {
    key: "getOfferType",
    value: function getOfferType(specific, manufacturerOffer, make, accountName) {
      var issuer = accountName;

      if (manufacturerOffer) {
        issuer = make;
      }

      var typeHeading = PROMOTION_FROM;

      if (specific && specific._type) {
        switch (specific._type) {
          case 'CASH':
            typeHeading = CASH_OFFER_FROM;
            break;

          case 'FINANCE':
          case 'UNDEFINED_TERM':
            typeHeading = FINANCE_OFFER_FROM;
            break;

          case 'CASH_AND_FINANCE':
            typeHeading = FINANCE_AND_CASH_OFFER_FROM;
            break;

          case 'CASH_OR_FINANCE':
            typeHeading = FINANCE_OR_CASH_OFFER_FROM;
            break;

          case 'LEASE':
            typeHeading = LEASE_OFFER_FROM;
            break;

          default:
            // PROMOTION
            typeHeading = PROMOTION_FROM;
        }
      }

      return "".concat(this.labels.get(typeHeading), " ").concat(issuer);
    }
  }, {
    key: "getIncentiveDetails",
    value: function getIncentiveDetails() {
      var _this$props3 = this.props,
          incentive = _this$props3.incentive,
          newListingPath = _this$props3.newListingPath,
          usedListingPath = _this$props3.usedListingPath,
          account = _this$props3.account,
          locale = _this$props3.locale,
          prefs = _this$props3.prefs;
      var key = incentive.key,
          specific = incentive.specific,
          title = incentive.title,
          shortTitle = incentive.shortTitle,
          offerDetails = incentive.offerDetails,
          make = incentive.make,
          condition = incentive.condition,
          manufacturerOffer = incentive.manufacturerOffer;

      var _parseIncentiveKey = parseIncentiveKey(key),
          incentiveId = _parseIncentiveKey.incentiveId,
          incentiveAccountId = _parseIncentiveKey.incentiveAccountId;

      var offerType = this.getOfferType(specific, manufacturerOffer, make, account.name);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "mt-2 mb-0 h5",
        "data-testid": "offerType"
      }, offerType), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "mt-0"
      }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "mt-2 mb-0 h5 text-capitalize"
      }, this.labels.get(DETAILS)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, offerDetails), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpecificDetails, {
        incentive: incentive,
        locale: locale,
        prefs: prefs
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListingLink, {
        incentiveId: incentiveId,
        incentiveAccountId: incentiveAccountId,
        incentiveName: shortTitle,
        condition: condition,
        newListingPath: newListingPath,
        usedListingPath: usedListingPath,
        locale: locale
      }));
    }
  }, {
    key: "getIncentiveDisclaimer",
    value: function getIncentiveDisclaimer(disclaimer) {
      var incentiveDisclaimer = null;

      if (disclaimer) {
        incentiveDisclaimer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "text-muted small mt-4"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(this.labels.get(DISCLAIMER), ": ").concat(disclaimer)));
      }

      return incentiveDisclaimer;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          incentive = _this$props4.incentive,
          isMobile = _this$props4.isMobile,
          isOpen = _this$props4.isOpen;
      var shortTitle = incentive.shortTitle,
          disclaimer = incentive.disclaimer;
      var incentiveDetails = this.getIncentiveDetails();
      var incentiveDisclaimer = this.getIncentiveDisclaimer(disclaimer);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"], {
        show: isOpen,
        onHide: this.onClose,
        onShow: this.onOpen,
        className: "m-1 ".concat(isMobile ? 'dock-right' : null)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Header, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Title, {
        className: "text-center"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        "aria-label": "Close",
        className: "close text-muted",
        onClick: this.onClose
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
        className: "ddc-icon ddc-icon-close",
        "aria-hidden": "true"
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "h3 my-0 px-5"
      }, shortTitle))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Body, null, incentiveDetails, incentiveDisclaimer));
    }
  }]);

  return IncentiveModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

IncentiveModal.propTypes = {
  incentive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    offerDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    shortTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    effectiveDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    expirationDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    conditional: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    make: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    manufacturerOffer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    specific: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired,
  widgetInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    windowId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    widgetName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    deviceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onModalClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  account: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  newListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  usedListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    showEffectiveStartDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};
IncentiveModal.defaultProps = {
  newListingPath: null,
  usedListingPath: null,
  locale: 'en_US',
  prefs: {
    showEffectiveStartDate: 'true'
  }
};

var PLEASE_CALL = 'PLEASE_CALL';
var DETAILS$1 = 'DETAILS';
var PRICE = 'PRICE';
var UNKNOWN = 'UNKNOWN';
var CLOSE = 'CLOSE';
var VDP = 'VDP';
var SRP = 'SRP';
var OFFSET_HEIGHT = 66;
var BUTTON_RESET_CLASSES = 'p-0 text-left bg-transparent border-0';

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
var isBrowser = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object';
var getPriceItemLabel = function getPriceItemLabel(_ref) {
  var item = _ref.item,
      prefs = _ref.prefs,
      labels = _ref.labels;
  var title = item.title,
      shortTitle = item.shortTitle,
      typeCssClass = item.typeCssClass,
      isFinalPrice = item.isFinalPrice,
      incentiveId = item.incentiveId;
  var label = item.label; // Conditional final price label is coming from BE as a label ID and not a translated label.
  // TODO remove this logic once CONDITIONAL_FINAL_PRICE label is being properly translated from BE.

  if (label === 'CONDITIONAL_FINAL_PRICE') {
    label = labels.get('CONDITIONAL_FINAL_PRICE');
  }

  var titlePref = prefs.incentiveTitleDisplay;
  var priceItemLabel = label;

  if (incentiveId) {
    if (title && titlePref === 'regular') {
      priceItemLabel = title;
    }

    if (shortTitle && titlePref === 'descriptive') {
      priceItemLabel = shortTitle;
    }

    if (titlePref === 'custom' && typeCssClass === 'discount' && !isFinalPrice) {
      priceItemLabel = labels.get(prefs.incentiveTitleCustom);
    }
  }

  return priceItemLabel;
};
/**
 * Filters undefined, null or empty strings from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 */

var setClassNames = function setClassNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var flattened = classes.reduce(function (acc, cur) {
    return acc.concat(cur);
  }, []);
  return _toConsumableArray(new Set(flattened)).filter(function (c) {
    return c;
  }).join(' ') || null;
};
var getDefaultPriceItem = function getDefaultPriceItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultItem = {
    isFinalPrice: true,
    type: UNKNOWN,
    label: PRICE,
    value: PLEASE_CALL
  };
  return _objectSpread2({}, defaultItem, {}, overrides);
};
/**
 * Incentives from /getInventory have been merged into a map that contains multiple
 * incentiveIds in a string array as a key for their respective values to reduce data
 * This Maps incentive keys and values as a standard singly keyed object using incentiveIds as keys (1 key, 1 value)
 * @param {object} incentives
 */

var mapIncentiveKeys = function mapIncentiveKeys(incentives) {
  var incentiveObjKeys = Object.keys(incentives);
  var incentiveMap = {};
  incentiveObjKeys.forEach(function (originalKey) {
    var keysToArray = originalKey.replace(/\[|]|\s/gm, '').split(',');
    keysToArray.forEach(function (key) {
      incentiveMap[key] = incentives[originalKey];
    });
  });
  return incentiveMap;
};
var getLoanDisclaimerPlaceholderObj = function getLoanDisclaimerPlaceholderObj(paymentInfo) {
  // TODO: format numbers by locale on service side (WIS)
  var apr = paymentInfo.apr,
      dealershipName = paymentInfo.dealershipName,
      downPayment = paymentInfo.downPayment,
      lenderLegalName = paymentInfo.lenderLegalName,
      creditScore = paymentInfo.creditScore,
      monthlyPaymentPerThousand = paymentInfo.monthlyPaymentPerThousand,
      programEndDate = paymentInfo.programEndDate,
      term = paymentInfo.term;
  return {
    '<%=loanCreditScore%>': creditScore,
    '<%=APR%>': apr,
    '<%=term%>': term,
    '<%=monthlyPaymentPerThousand%>': formatter.format(monthlyPaymentPerThousand),
    '<%=downPayment%>': formatter.format(downPayment),
    '<%=lenderLegalName%>': lenderLegalName,
    '<%=loanProgramEndDate%>': programEndDate || '',
    '<%=dealershipName%>': dealershipName
  };
};
var getLeaseDisclaimerPlaceholderObj = function getLeaseDisclaimerPlaceholderObj(paymentInfo) {
  var creditScore = paymentInfo.creditScore,
      lenderLegalName = paymentInfo.lenderLegalName,
      programEndDate = paymentInfo.programEndDate,
      term = paymentInfo.term,
      leaseDueAtSigning = paymentInfo.leaseDueAtSigning,
      acquisitionFee = paymentInfo.acquisitionFee,
      capCostTotal = paymentInfo.capCostTotal,
      totalMonthlyPayment = paymentInfo.totalMonthlyPayment,
      capCostReduction = paymentInfo.capCostReduction,
      leaseSecurityDeposit = paymentInfo.leaseSecurityDeposit,
      value = paymentInfo.value,
      excessMileCharge = paymentInfo.excessMileCharge,
      annualMiles = paymentInfo.annualMiles,
      dealershipName = paymentInfo.dealershipName;
  return {
    '<%=leaseCreditScore%>': creditScore,
    '<%=leaseLenderLegalName%>': lenderLegalName,
    '<%=leaseProgramEndDate%>': programEndDate || '',
    '<%=leaseTerm%>': term,
    '<%=leaseDueAtSigning%>': formatter.format(leaseDueAtSigning),
    '<%=acquisitionFee%>': formatter.format(acquisitionFee),
    '<%=capCostTotal%>': formatter.format(capCostTotal),
    '<%=totalMonthlyPayments%>': formatter.format(totalMonthlyPayment),
    '<%=capCostReduction%>': formatter.format(capCostReduction),
    '<%=leaseSecurityDeposit%>': formatter.format(leaseSecurityDeposit),
    '<%=monthlyPayment%>': value,
    '<%=excessMileCharge%>': formatter.format(excessMileCharge),
    '<%=annualMiles%>': annualMiles,
    '<%=dealershipName%>': dealershipName
  };
};
var replacePlaceholders = function replacePlaceholders(labelWithPlaceholder, placeholderValuesObj) {
  // global and ignore case flags which permits replace() to replace each occurrence of matched items
  // ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  if (!placeholderValuesObj || Object.entries(placeholderValuesObj).length === 0) {
    if (!labelWithPlaceholder || Object.entries(labelWithPlaceholder).length === 0) {
      return 'Invalid Input';
    }

    return labelWithPlaceholder;
  }

  var regex = new RegExp(Object.keys(placeholderValuesObj).join('|'), 'gi');
  return labelWithPlaceholder.replace(regex, function (matched) {
    return placeholderValuesObj[matched];
  });
};
function getAccountId(rData) {
  return rData.parameterMap && rData.parameterMap.accountId || rData.accountId;
} // showOnlyMSRPForSharedInventory pref: shows only MSRP for shared inventory
// TODO: discuss adding this to IDC

var filterMSRP = function filterMSRP() {
  var priceItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var retailPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return priceItems.filter(function (priceItem) {
    return priceItem.value === retailPrice;
  });
}; // filters out the final price from the summaryItems array
// this data is consumed by the PricingSummary component

function filterFinal() {
  var summaryItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return summaryItems.filter(function (item) {
    return item.isFinalPrice;
  });
} // filters out the loan and lease from the summaryItems array
// this data is consumed by the PricingLoanLease component

function filterLoanLease() {
  var summaryItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return summaryItems.filter(function (item) {
    return item.type === 'LOAN' || item.type === 'LEASE';
  });
}
function extractEPriceData(ePriceDetail) {
  var ePriceDifference = '';
  var ePriceValue = '';

  if (ePriceDetail && ePriceDetail.length) {
    var ePriceIndex = ePriceDetail.findIndex(function (element) {
      return element.type === 'EPRICE';
    });

    if (ePriceIndex) {
      // ePrice difference should be placed before ePrice value per Rules Provider
      var difference = ePriceDetail[ePriceIndex];
      var ePrice = ePriceDetail[ePriceIndex + 1];
      ePriceDifference = difference ? difference.value : '';
      ePriceValue = ePrice ? ePrice.value : '';
    }
  }

  return {
    ePriceDifference: ePriceDifference,
    ePriceValue: ePriceValue
  };
}
function getDOMContainer(doc, cssClass) {
  var _doc$querySelectorAll = doc.querySelectorAll(cssClass),
      _doc$querySelectorAll2 = _slicedToArray(_doc$querySelectorAll, 1),
      container = _doc$querySelectorAll2[0];

  return container;
}
function getDisclaimerPlaceholderObj(paymentInfo) {
  if (paymentInfo.type === 'LOAN') {
    var apr = paymentInfo.apr,
        dealershipName = paymentInfo.dealershipName,
        downPayment = paymentInfo.downPayment,
        lenderLegalName = paymentInfo.lenderLegalName,
        loanCreditScore = paymentInfo.loanCreditScore,
        monthlyPaymentPerThousand = paymentInfo.monthlyPaymentPerThousand,
        loanProgramEndDate = paymentInfo.loanProgramEndDate,
        term = paymentInfo.term;
    return {
      '<%=loanCreditScore%>': loanCreditScore,
      '<%=APR%>': apr,
      '<%=term%>': term,
      '<%=monthlyPaymentPerThousand%>': monthlyPaymentPerThousand,
      '<%=downPayment%>': downPayment,
      '<%=lenderLegalName%>': lenderLegalName,
      '<%=loanProgramEndDate%>': loanProgramEndDate,
      '<%=dealershipName%>': dealershipName
    };
  } else if (paymentInfo.type === 'LEASE') {
    var leaseCreditScore = paymentInfo.leaseCreditScore,
        leaseLenderLegalName = paymentInfo.leaseLenderLegalName,
        leaseProgramEndDate = paymentInfo.leaseProgramEndDate,
        leaseTerm = paymentInfo.leaseTerm,
        leaseDueAtSigning = paymentInfo.leaseDueAtSigning,
        acquisitionFee = paymentInfo.acquisitionFee,
        capCostTotal = paymentInfo.capCostTotal,
        totalMonthlyPayments = paymentInfo.totalMonthlyPayments,
        capCostReduction = paymentInfo.capCostReduction,
        leaseSecurityDeposit = paymentInfo.leaseSecurityDeposit,
        monthlyPayment = paymentInfo.monthlyPayment,
        excessMileCharge = paymentInfo.excessMileCharge,
        annualMiles = paymentInfo.annualMiles,
        _dealershipName = paymentInfo.dealershipName;
    return {
      '<%=leaseCreditScore%>': leaseCreditScore,
      '<%=leaseLenderLegalName%>': leaseLenderLegalName,
      '<%=leaseProgramEndDate%>': leaseProgramEndDate,
      '<%=leaseTerm%>': leaseTerm,
      '<%=leaseDueAtSigning%>': leaseDueAtSigning,
      '<%=acquisitionFee%>': acquisitionFee,
      '<%=capCostTotal%>': capCostTotal,
      '<%=totalMonthlyPayments%>': totalMonthlyPayments,
      '<%=capCostReduction%>': capCostReduction,
      '<%=leaseSecurityDeposit%>': leaseSecurityDeposit,
      '<%=monthlyPayment%>': monthlyPayment,
      '<%=excessMileCharge%>': excessMileCharge,
      '<%=annualMiles%>': annualMiles,
      '<%=dealershipName%>': _dealershipName
    };
  }

  return {};
}

var PricingWrapper = function PricingWrapper(_ref) {
  var vehicleCssClass = _ref.vehicleCssClass,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dl", {
    className: setClassNames('pricing-detail', 'line-height-condensed', 'mb-4', vehicleCssClass)
  }, children);
};

PricingWrapper.propTypes = {
  vehicleCssClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired
};

var IncentiveButton = function IncentiveButton(_ref) {
  var incentiveId = _ref.incentiveId,
      isMobile = _ref.isMobile,
      children = _ref.children,
      handleDetailClick = _ref.handleDetailClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: setClassNames('text-link', 'd-block', isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall'),
    onClick: function onClick() {
      handleDetailClick(incentiveId);
    }
  }, children);
};

IncentiveButton.propTypes = {
  incentiveId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired,
  handleDetailClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var PriceLabel = function PriceLabel(_ref) {
  var isStyleEditable = _ref.isStyleEditable,
      vehicleTypeClass = _ref.vehicleTypeClass,
      typeClass = _ref.typeClass,
      children = _ref.children;
  return (
    /* eslint react/no-danger: 0 */
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "price-label",
      "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-label") : null,
      "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-label") : null
    }, children)
  );
};

PriceLabel.defaultProps = {
  isStyleEditable: false,
  vehicleTypeClass: '',
  typeClass: ''
};
PriceLabel.propTypes = {
  isStyleEditable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vehicleTypeClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  typeClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
};

var PriceTitlePortal = function PriceTitlePortal(_ref) {
  var vehicleId = _ref.vehicleId,
      price = _ref.price,
      priceLabel = _ref.priceLabel,
      showTitlePriceLabel = _ref.showTitlePriceLabel;
  var titleRoot = null;

  if (!(typeof window === 'undefined') && window.document) {
    titleRoot = document.getElementById("".concat(vehicleId, "_priceTitle"));
  }

  var priceTitle = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, showTitlePriceLabel === 'true' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small", {
    className: "d-block"
  }, priceLabel), price);
  return titleRoot && __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(priceTitle, titleRoot) || null;
};

// without wrapping in a button which will have display issues

var ClickArea = function ClickArea(_ref) {
  var title = _ref.title,
      children = _ref.children,
      handleClick = _ref.handleClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  // TODO: re-enable these rules by making this component fully accessible

  /* eslint jsx-a11y/click-events-have-key-events: 0 */

  /* eslint jsx-a11y/interactive-supports-focus: 0 */
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    role: "button",
    onClick: handleClick,
    onKeyDown: handleClick,
    tabIndex: tabIndex,
    "aria-label": title
  }, children);
};

ClickArea.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var PriceItem = function PriceItem(_ref) {
  var _ref$item = _ref.item,
      type = _ref$item.type,
      incentiveId = _ref$item.incentiveId,
      value = _ref$item.value,
      isFinalPrice = _ref$item.isFinalPrice,
      _ref$item$typeClass = _ref$item.typeClass,
      typeClass = _ref$item$typeClass === void 0 ? '' : _ref$item$typeClass,
      isDiscount = _ref$item.isDiscount,
      item = _ref.item,
      incentives = _ref.incentives,
      stackType = _ref.stackType,
      isMobile = _ref.isMobile,
      _ref$prefs = _ref.prefs,
      priceDiscountColor = _ref$prefs.priceDiscountColor,
      finalPriceSize = _ref$prefs.finalPriceSize,
      finalPriceColor = _ref$prefs.finalPriceColor,
      showTitlePriceLabel = _ref$prefs.showTitlePriceLabel,
      vehicleCssClass = _ref.vehicleCssClass,
      isFirstItem = _ref.isFirstItem,
      handleDetailClick = _ref.handleDetailClick,
      vehicleId = _ref.vehicleId;
  var formattedPrice = value;
  var adjustmentDetected = false;
  var hasLineBreak = false;
  var isStackedFinal = type === 'SICF' || type === 'SIF';
  var isTotal = type === 'TOTAL' || // Represents the last price in the rule
  type === 'SICF' || // Final price including conditional incentives
  type === 'SIF' || // Final price including stack incentives
  isFinalPrice;
  var isConditionalFinal = type === 'SICF';
  var isEpriceFinal = stackType === 'ePrice' && isFinalPrice;
  var isIncentive = !!incentiveId;

  if ((isStackedFinal || isTotal) && !isFirstItem) {
    hasLineBreak = true;
  }

  if (isDiscount) {
    adjustmentDetected = true;
    hasLineBreak = false;
  } else {
    if (adjustmentDetected === true) {
      hasLineBreak = true;
    }

    adjustmentDetected = false;
  }

  var discountValueCssClass = '';
  var totalValueCssClass = '';
  var ePriceCssClass = '';
  var itemCssClass = typeClass && typeClass.toLowerCase() || '';
  var valueCssClass = '';

  if (value === PLEASE_CALL) {
    valueCssClass = 'no-value';
    formattedPrice = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(PLEASE_CALL);
      }
    });
  }

  if ((isDiscount || isIncentive) && value !== PLEASE_CALL) {
    formattedPrice = isMobile ? "- ".concat(value) : "-".concat(value);
    discountValueCssClass = "".concat(priceDiscountColor);
  } // TODO: Refactor condition once WIS has retailPrice field


  if (isTotal && !!isFinalPrice || value === PLEASE_CALL || type === 'SICF') {
    totalValueCssClass = 'font-weight-bold'; // suppressing finalPriceSize for total pricing that contains PLEASE_CALL value

    if (value !== PLEASE_CALL) {
      totalValueCssClass = "".concat(totalValueCssClass, " ").concat(finalPriceSize, " line-height-reset pb-2");
    }
  }

  if (isEpriceFinal) {
    ePriceCssClass = 'eprice';
  }

  if (isConditionalFinal) {
    totalValueCssClass = "".concat(totalValueCssClass, " text-muted");
  }

  var priceTitlePortal = null; // WIS has bug where isFinalPrice will be on multiple price items
  // we don't want to render multiple portals to the title area

  if (isFinalPrice === true && type !== 'MIDDLE') {
    itemCssClass = 'final-price';
    totalValueCssClass = "".concat(totalValueCssClass, " ").concat(finalPriceColor);

    if (value !== PLEASE_CALL) {
      priceTitlePortal = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceTitlePortal, {
        vehicleId: vehicleId,
        price: value,
        priceLabel: item.label,
        showTitlePriceLabel: showTitlePriceLabel,
        key: "".concat(vehicleId, "-price-title-portal")
      });
    }
  }

  var isStyleEditable = vehicleCssClass !== '' && itemCssClass !== '';
  var lineBreakMarkup = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dd", {
    className: "pricing-divider my-3",
    key: "".concat(type, "-divider")
  });
  var labelMarkup = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
    render: function render(_ref3) {
      var prefs = _ref3.prefs,
          labels = _ref3.labels;
      var itemWithIncentiveTitles = isIncentive && incentives && incentives[incentiveId] ? _objectSpread2({}, item, {
        title: incentives[incentiveId].title,
        shortTitle: incentives[incentiveId].shortTitle
      }) : _objectSpread2({}, item);
      var label = getPriceItemLabel({
        item: itemWithIncentiveTitles,
        prefs: prefs,
        labels: labels
      });
      var incentiveButton = isIncentive && incentives[incentiveId] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IncentiveButton, _extends({
        incentiveId: incentiveId,
        isMobile: isMobile,
        handleDetailClick: handleDetailClick
      }, {
        key: "".concat(type, "-button")
      }), labels.get(DETAILS$1)) : null;

      if (label && label._type) {
        label = label.en_US;
      }

      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceLabel, _extends({
        isStyleEditable: isStyleEditable,
        itemCssClass: itemCssClass,
        vehicleCssClass: vehicleCssClass
      }, {
        key: "".concat(type, "-label")
      }), labels.getHTML(label)), incentiveButton];
    }
  });
  var labelMarkupWithClick = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
    render: function render(_ref4) {
      var labels = _ref4.labels;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickArea, {
        handleClick: function handleClick(e) {
          if (e.type === 'click' || e.type === 'keydown' && (e.which === 13 || e.which === 32)) {
            handleDetailClick(incentiveId);
          }
        },
        title: labels.get(DETAILS$1),
        tabIndex: 0
      }, labelMarkup);
    }
  });
  var valueMarkup = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: setClassNames('price-value', valueCssClass),
    "data-style-editor-id": isStyleEditable ? "vdp-".concat(itemCssClass, "-price-value") : null,
    "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleCssClass, ".pricing-detail .").concat(itemCssClass, " .price-value") : null
  }, formattedPrice);
  var valueMarkupWithClick = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
    render: function render(_ref5) {
      var labels = _ref5.labels;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickArea, {
        handleClick: function handleClick() {
          handleDetailClick(incentiveId);
        },
        title: labels.get(DETAILS$1),
        tabIndex: 0
      }, valueMarkup);
    }
  });
  return [priceTitlePortal, hasLineBreak ? lineBreakMarkup : '', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dt", {
    "data-style-editor-price": isStyleEditable ? 'true' : null,
    className: setClassNames(isIncentive ? 'pointer' : '', isStyleEditable ? itemCssClass : ''),
    key: "".concat(type, "-dt")
  }, isIncentive ? labelMarkupWithClick : labelMarkup), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dd", {
    "data-style-editor-price": isStyleEditable ? 'true' : null,
    className: setClassNames(discountValueCssClass, totalValueCssClass, ePriceCssClass, isIncentive ? 'pointer' : '', isStyleEditable ? itemCssClass : ''),
    key: "".concat(type, "-dd")
  }, isIncentive ? valueMarkupWithClick : valueMarkup)];
};

PriceItem.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isFinalPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    incentiveId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    typeClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isDiscount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  incentives: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  stackType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  prefs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    priceDiscountColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    finalPriceSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    finalPriceColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    showTitlePriceLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  vehicleCssClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isFirstItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  vehicleId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
PriceItem.defaultProps = {
  item: {
    value: '',
    isFinalPrice: false,
    incentiveId: '',
    typeClass: '',
    isDiscount: false
  },
  prefs: {
    priceDiscountColor: null,
    finalPriceSize: null,
    finalPriceColor: null,
    showTitlePriceLabel: 'false'
  }
};

var FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE';
var FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE';
var EST_FINANCE_DISCLAIMER_HEADING = 'EST_FINANCE_DISCLAIMER_HEADING';
var EST_LEASE_DISCLAIMER_HEADING = 'EST_LEASE_DISCLAIMER_HEADING';
var FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE';
var THE_DEALERSHIP = 'THE_DEALERSHIP';
var CUSTOMIZE_PAYMENTS = 'CUSTOMIZE_PAYMENTS';
var DEALERSHIP_NAME_PRICE = 'DEALERSHIP_NAME_PRICE';
var DETAILED_PRICING = 'DETAILED_PRICING';
var DETAILS$2 = 'DETAILS';
var PLEASE_CALL$1 = 'PLEASE_CALL';
var PLUS_SALES_TAXES_ASTERISK = 'PLUS_SALES_TAXES_ASTERISK';
var PLUS_TAXES_ASTERISK = 'PLUS_TAXES_ASTERISK';
var SLASH_MO = 'SLASH_MO';
var CLICK_TO_VIEW_DISCLAIMER = 'CLICK_TO_VIEW_DISCLAIMER';

var DisclaimerContent = function DisclaimerContent(_ref) {
  var dealershipName = _ref.dealershipName,
      disclaimerLabel = _ref.disclaimerLabel,
      placeholderValuesObj = _ref.placeholderValuesObj;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
    render: function render(_ref2) {
      var labels = _ref2.labels;
      var introParagraph = labels.get(FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE);
      var dealershipText = dealershipName === THE_DEALERSHIP ? labels.get(THE_DEALERSHIP) : dealershipName;
      var disclaimerHtml = replacePlaceholders(labels.get(disclaimerLabel), _objectSpread2({}, placeholderValuesObj, {
        '<%=dealershipName%>': dealershipText
      }));
      /* eslint react/no-danger: 0 */

      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: "introHtml",
        dangerouslySetInnerHTML: {
          __html: introParagraph
        }
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: "disclaimerHtml",
        dangerouslySetInnerHTML: {
          __html: disclaimerHtml
        }
      })];
    }
  });
};

DisclaimerContent.propTypes = {
  dealershipName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  disclaimerLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  placeholderValuesObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired
};

var LoanLeaseModal = function LoanLeaseModal(_ref) {
  var options = _extends({}, _ref);

  var showState = options.showState,
      closeMethod = options.closeMethod,
      title = options.title,
      body = options.body,
      isMobile = options.isMobile;
  var modalClass = isMobile ? 'dock-right' : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"], {
    show: showState,
    onHide: function onHide() {
      return closeMethod();
    },
    className: "m-1 ".concat(modalClass)
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "p-1"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Header, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Title, {
    className: "text-center"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
    render: function render(_ref2) {
      var labels = _ref2.labels;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        "aria-label": labels.get(CLOSE),
        className: "close text-muted",
        onClick: function onClick() {
          return closeMethod();
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
        className: "ddc-icon ddc-icon-close",
        "aria-hidden": "true"
      }));
    }
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "my-0 px-5 h3"
  }, title))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Body, null, body)));
};
LoanLeaseModal.propTypes = {
  showState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  closeMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
};

var Payments = function Payments(_ref) {
  var _ref$loan = _ref.loan,
      loan = _ref$loan === void 0 ? {} : _ref$loan,
      _ref$lease = _ref.lease,
      lease = _ref$lease === void 0 ? {} : _ref$lease,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$accountInfo = _ref.accountInfo,
      accountInfo = _ref$accountInfo === void 0 ? {} : _ref$accountInfo;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDisclaimer = _useState2[0],
      setShowDisclaimer = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null)),
      _useState4 = _slicedToArray(_useState3, 2),
      disclaimerTitle = _useState4[0],
      setDisclaimerTitle = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null)),
      _useState6 = _slicedToArray(_useState5, 2),
      disclaimerContent = _useState6[0],
      setDisclaimerContent = _useState6[1];

  var toggleDisclaimer = function toggleDisclaimer() {
    var disclaimerTitleMarkup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null);
    var disclaimerContentMarkup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null);
    setShowDisclaimer(!showDisclaimer);
    setDisclaimerTitle(disclaimerTitleMarkup);
    setDisclaimerContent(disclaimerContentMarkup);
  };

  var icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "ddc-icon ddc-icon-help-circle text-muted ddc-icon-size-small d-inline-block pl-1"
  });

  var getLoanLeaseModalOptions = function getLoanLeaseModalOptions() {
    return {
      isMobile: isMobile,
      showState: showDisclaimer,
      closeMethod: toggleDisclaimer,
      title: disclaimerTitle,
      body: disclaimerContent
    };
  };

  var renderPayment = function renderPayment(item, labels) {
    var label = item.label,
        value = item.value;
    var isLease = item.type === 'lease';
    var disclaimer = isLease ? FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE : FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
    var disclaimerPlaceholder = isLease ? getLeaseDisclaimerPlaceholderObj(item) : getLoanDisclaimerPlaceholderObj(item);
    var disclaimerTitleKey = isLease ? EST_LEASE_DISCLAIMER_HEADING : EST_FINANCE_DISCLAIMER_HEADING;
    var DynamicDisclaimerContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DisclaimerContent, {
      placeholderValuesObj: disclaimerPlaceholder,
      disclaimerLabel: disclaimer,
      dealershipName: accountInfo.name
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dt", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      type: "button",
      className: "btn-link p-0",
      onClick: function onClick() {
        return toggleDisclaimer(labels.get(disclaimerTitleKey), DynamicDisclaimerContent);
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "price-label"
    }, label, icon))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dd", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "price-value font-weight-bold"
    }, value), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "text-muted"
    }, labels.get('SLASH_MO'))));
  };

  var loanItem = _objectSpread2({}, loan, {
    type: 'loan'
  });

  var leaseItem = _objectSpread2({}, lease, {
    type: 'lease'
  }); // eslint-disable-next-line react/prop-types


  var renderLayout = function renderLayout(_ref2) {
    var labels = _ref2.labels;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, loan && loanItem.value && renderPayment(loanItem, labels), lease && leaseItem.value && renderPayment(leaseItem, labels));
  };

  var options = getLoanLeaseModalOptions();
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
    render: renderLayout
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoanLeaseModal, options));
};

Payments.defaultProps = {
  loan: {},
  lease: {}
};
Payments.propTypes = {
  loan: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  lease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  accountInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

var defaultClickEvent$1 = {
  event: 'widgetUserEvent',
  element: 'More details button',
  elementCTA: 'Details',
  action: 'clicked',
  result: 'Revealed detail information popup',
  widgetName: 'ws-detailed-pricing',
  widgetId: 'detailed-pricing1',
  widgetState: 'default',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent$1(eventData) {
  var trackingObject = {};

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
    trackingObject = window.jQuery(document) || {};
  }

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread2({}, defaultClickEvent$1, {}, eventData));
  }
}

function priceDetailsScrollEvent(widgetName, widgetId) {
  var eventData = {
    element: 'Price details link',
    elementCTA: 'Pricing Detail',
    result: 'Scrolled to destination',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent$1(eventData);
}
function disclaimerDetailsModalEvents(widgetName, widgetId, modalState) {
  var eventData;

  if (modalState) {
    eventData = {
      element: 'Disclaimer details link',
      elementCTA: undefined,
      result: 'Opened dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  } else {
    eventData = {
      element: 'Close button',
      elementCTA: undefined,
      result: 'Closed dialog',
      widgetState: 'Disclaimer dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  }

  trackGoogleAnalyticsEvent$1(eventData);
}
function ePriceButtonTrackEvent(buttonLabel, widgetName, widgetId, openModal) {
  var eventData = {
    element: 'Instant ePrice button',
    elementCTA: buttonLabel,
    result: openModal ? 'Opened dialog' : 'ePrice diplayed',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent$1(eventData);
}

var InstantEpriceButton = function InstantEpriceButton(_ref) {
  var isModalVisible = _ref.isModalVisible,
      loadingUserProfile = _ref.loadingUserProfile,
      userLoggedIn = _ref.userLoggedIn,
      ePriceDetail = _ref.ePriceDetail,
      handleClick = _ref.handleClick,
      buttonLabel = _ref.buttonLabel,
      buttonStyle = _ref.buttonStyle,
      buttonSize = _ref.buttonSize,
      vehicleId = _ref.vehicleId,
      vehicleCategory = _ref.vehicleCategory,
      pageAlias = _ref.pageAlias,
      disabled = _ref.disabled,
      preventMultipleEpriceLeads = _ref.preventMultipleEpriceLeads;

  if (!buttonLabel) {
    return null;
  }

  var _useSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["useSelector"])(function (state) {
    return state;
  }),
      labels = _useSelector.labels;

  var _useSelector2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["useSelector"])(function (state) {
    return state.requestData;
  }),
      widgetName = _useSelector2.widgetName,
      windowId = _useSelector2.windowId;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      epriceDisplayData = _useState2[0],
      setEpriceDisplayData = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var _window = window,
        pubsub = _window.pubsub;

    if (pubsub && epriceDisplayData) {
      pubsub.subscribe('instant-eprice.complete', function () {
        if (ePriceDetail) {
          var _extractEPriceData = extractEPriceData(epriceDisplayData),
              ePriceValue = _extractEPriceData.ePriceValue,
              ePriceDifference = _extractEPriceData.ePriceDifference;

          pubsub.publish('instant-eprice.show', {
            ePriceDifference: ePriceDifference,
            yourEPrice: ePriceValue
          });
        }
      });
    }
  }, [epriceDisplayData]);
  var formUrl = "/instant-eprice-form.htm?itemId=".concat(vehicleId, "&vehicleId=").concat(vehicleId, "&category=").concat(vehicleCategory) + "&parentPageAlias=".concat(pageAlias, "&vcdaInstantEPrice");

  var allowLeadSubmission = function allowLeadSubmission() {
    // Don't submit a lead if preventMultipleEpriceLeads preference is set and
    // user has already submitted one
    return !(preventMultipleEpriceLeads && window.DDC.userProfile.ePriceVehicles && window.DDC.userProfileController.hasUserContactData());
  };

  var submitLeadConditionally = function submitLeadConditionally() {
    if (userLoggedIn && allowLeadSubmission()) {
      window.DDC.userProfileController.sendLeadForm(formUrl);
    }
  };

  var openModalOrSubmitLead = function openModalOrSubmitLead() {
    var _window2 = window,
        DDC = _window2.DDC;

    if (DDC) {
      if (userLoggedIn) {
        // Save eprice vehicle to profile
        DDC.toolbar.saveEpriceVehicleStatus(vehicleId); // Save eprice vehicle in session for guest user

        DDC.userProfileController.saveInstantEpriceVehicle(null, vehicleId);
      } else {
        // Provide data for dialog display
        DDC.currentVLPDialog = {
          instantEpriceUrl: formUrl,
          instantEpriceVehicleId: vehicleId
        };
        setEpriceDisplayData(ePriceDetail);
      }
    }

    try {
      handleClick(vehicleId);
    } catch (error) {
      throw new Error('Unable to handle click.');
    } finally {
      submitLeadConditionally();
    }

    ePriceButtonTrackEvent(buttonLabel, widgetName, windowId, false);
  };

  var buttonAttributes = {
    className: setClassNames('btn-block', 'btn', "btn-".concat(buttonStyle), buttonSize && buttonSize !== 'default' ? "btn-".concat(buttonSize) : null, 'instant-eprice', userLoggedIn ? 'slidein-disabled' : 'dialog', isModalVisible ? 'd-none' : null),
    'data-width': '600px',
    'data-location': 'vehicle-eprice-button'
  };
  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Tooltip"], {
    className: "tooltip",
    id: "eprice-tooltip"
  }, labels.INSTANT_EPRICE_DISABLED_POPOVER);
  var disabledButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", _extends({}, buttonAttributes, {
    type: "button",
    disabled: true
  }), buttonLabel));
  return disabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "disabled"
  }, typeof window !== 'undefined' && window.document ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["OverlayTrigger"], {
    placement: "top",
    overlay: tooltip,
    trigger: ['hover', 'click']
  }, disabledButton) : disabledButton) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", _extends({}, buttonAttributes, {
    type: "button",
    onClick: openModalOrSubmitLead,
    rel: "nofollow",
    "data-vehicle-uuid": vehicleId,
    "data-name": "instant-price-dialog",
    "data-href": userLoggedIn ? null : formUrl
  }), loadingUserProfile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "mr-3 ddc-icon ddc-icon-loading ddc-icon-animate-spin",
    "aria-hidden": "true"
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "sr-only"
  }, labels.LOADING)), buttonLabel), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    key: "label",
    className: setClassNames('instanteprice-pending', 'font-weight-bold', 'text-success', 'text-center', isModalVisible ? null : 'd-none')
  }, labels.EPRICE_PENDING));
};

InstantEpriceButton.propTypes = {
  ePriceDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isFinalPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    incentives: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
  })),
  isModalVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  loadingUserProfile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  userLoggedIn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  buttonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  buttonStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  buttonSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  vehicleId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  vehicleCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  pageAlias: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  preventMultipleEpriceLeads: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
InstantEpriceButton.defaultProps = {
  ePriceDetail: []
};

var InstantEpriceContainer = function InstantEpriceContainer(_ref) {
  var isMobile = _ref.isMobile,
      ePriceDetail = _ref.ePriceDetail,
      buttonLabel = _ref.buttonLabel,
      buttonStyle = _ref.buttonStyle,
      buttonSize = _ref.buttonSize,
      disabled = _ref.disabled,
      preventMultipleEpriceLeads = _ref.preventMultipleEpriceLeads,
      instantEpriceShowAllAfterLeadSubmit = _ref.instantEpriceShowAllAfterLeadSubmit,
      showEPrice = _ref.showEPrice,
      _ref$widgetInfo = _ref.widgetInfo,
      pageAlias = _ref$widgetInfo.pageAlias,
      vehicleId = _ref$widgetInfo.vehicleId,
      vehicleCategory = _ref$widgetInfo.vehicleCategory;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setIsModalVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoadingUserProfile = _useState4[0],
      setIsLoadingUserProfile = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isUserLoggedIn = _useState6[0],
      setIsUserLoggedIn = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState8 = _slicedToArray(_useState7, 2),
      userProfile = _useState8[0],
      setUserProfile = _useState8[1];

  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState10 = _slicedToArray(_useState9, 2),
      epriceVehicle = _useState10[0],
      setEpriceVehicle = _useState10[1];

  var showModal = function showModal(id) {
    setIsModalVisible(true);
    setEpriceVehicle(id);
  };

  var handleClick = function handleClick(id) {
    return isUserLoggedIn ? showEPrice(id) : showModal(id);
  };

  var updateUserState = function updateUserState() {
    var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (profile && Object.entries(profile).length !== 0) {
      var ePriceVehicles = profile.ePriceVehicles,
          profileId = profile.profileId;
      setIsUserLoggedIn(ePriceVehicles !== undefined || profileId !== undefined);
      setUserProfile(profile);
    } else {
      setIsUserLoggedIn(false);
      setUserProfile(null);
      showEPrice('none');
    }
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var _window = window,
        DDC = _window.DDC,
        $ = _window.$;

    if (DDC) {
      if ($) {
        $.subscribe('userProfile-updated', function () {
          return updateUserState(DDC.userProfile);
        });
      }

      if (DDC.userProfile) {
        updateUserState(DDC.userProfile);
        setIsLoadingUserProfile(false);
      }

      if (isMobile && DDC.mobile.slidein) {
        // Required to make instant eprice work on mobile
        DDC.mobile.slidein.init();
      }
    }
  }, []);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var _window2 = window,
        DDC = _window2.DDC,
        pubsub = _window2.pubsub;

    if (pubsub) {
      if (epriceVehicle && isModalVisible) {
        pubsub.subscribe('instant-eprice.complete', function () {
          showEPrice(epriceVehicle);
          updateUserState(DDC.userProfile);
          setEpriceVehicle(null);
        });
        pubsub.subscribe('instant-eprice.cancel', function () {
          setIsModalVisible(false);
        });
      }
    }
  }, [isModalVisible, epriceVehicle]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (userProfile) {
      var ePriceVehicles = userProfile.ePriceVehicles;

      if (instantEpriceShowAllAfterLeadSubmit === 'true' && !isModalVisible) {
        showEPrice(vehicleId);
      } else if (ePriceVehicles) {
        var isEpriceVehicle = ePriceVehicles.find(function (vehicle) {
          return vehicle.itemUUID === vehicleId;
        }); // User has the vehicle in their profile

        if (isEpriceVehicle && !isModalVisible) {
          showEPrice(vehicleId);
        }
      }
    }
  }, [userProfile]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstantEpriceButton, {
    userLoggedIn: isUserLoggedIn,
    loadingUserProfile: isLoadingUserProfile,
    isModalVisible: isModalVisible,
    ePriceDetail: ePriceDetail,
    buttonLabel: buttonLabel,
    buttonStyle: buttonStyle,
    buttonSize: buttonSize,
    handleClick: handleClick,
    vehicleId: vehicleId,
    vehicleCategory: vehicleCategory,
    pageAlias: pageAlias,
    disabled: disabled,
    preventMultipleEpriceLeads: preventMultipleEpriceLeads
  });
};

InstantEpriceContainer.propTypes = {
  showEPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  ePriceDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isFinalPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    incentives: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
  })),
  buttonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  buttonStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  widgetInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    vehicleId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    vehicleCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    pageAlias: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    windowId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    widgetName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  instantEpriceShowAllAfterLeadSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  preventMultipleEpriceLeads: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
InstantEpriceContainer.defaultProps = {
  ePriceDetail: [],
  buttonStyle: 'primary',
  buttonSize: 'default',
  instantEpriceShowAllAfterLeadSubmit: 'false'
};

var DisclaimersModal = function DisclaimersModal(props) {
  var isModalVisible = props.isModalVisible,
      handleClose = props.handleClose,
      paymentInfo = props.paymentInfo;

  if (!paymentInfo) {
    return null;
  }

  var modalBody = '';
  var title = '';
  var type = paymentInfo.type,
      dealershipName = paymentInfo.dealershipName;
  var placeholderValuesObj = getDisclaimerPlaceholderObj(paymentInfo);

  if (type === 'LOAN') {
    title = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(EST_FINANCE_DISCLAIMER_HEADING);
      }
    });
    modalBody = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DisclaimerContent, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  if (type === 'LEASE') {
    title = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(EST_LEASE_DISCLAIMER_HEADING);
      }
    });
    modalBody = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DisclaimerContent, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"], {
    show: isModalVisible,
    onHide: handleClose
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Header, {
    closeButton: true
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Title, {
    className: "text-center"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "h3"
  }, title))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Body, null, modalBody));
};

DisclaimersModal.defaultProps = {
  paymentInfo: null
};
DisclaimersModal.propTypes = {
  isModalVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  handleClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  paymentInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()
};

var LabelAsHTML = function LabelAsHTML(props) {
  var label = props.label,
      isStyleEditable = props.isStyleEditable,
      vehicleTypeClass = props.vehicleTypeClass,
      typeClass = props.typeClass;
  return (
    /* eslint react/no-danger: 0 */
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "price-label",
      "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-label") : null,
      "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-label") : null,
      dangerouslySetInnerHTML: {
        __html: label
      }
    })
  );
};

LabelAsHTML.defaultProps = {
  isStyleEditable: false,
  vehicleTypeClass: '',
  typeClass: ''
};
LabelAsHTML.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isStyleEditable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vehicleTypeClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  typeClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var PricingSummaryFinalPrice = function PricingSummaryFinalPrice(_ref) {
  var price = _ref.price,
      buttonResetClasses = _ref.buttonResetClasses,
      viewPriceDetail = _ref.viewPriceDetail,
      finalLabelSize = _ref.finalLabelSize,
      finalPrice = _ref.finalPrice,
      finalPriceSize = _ref.finalPriceSize;

  if (price && price.isFinalPrice && finalPrice && viewPriceDetail) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      className: "".concat(buttonResetClasses, " w-100"),
      onClick: viewPriceDetail,
      type: "button"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: setClassNames('text-muted', 'd-block', finalLabelSize)
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelAsHTML, {
      label: price.label
    }), ' '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", {
      className: setClassNames('line-height-reset', finalPriceSize)
    }, finalPrice));
  }

  return null;
};

PricingSummaryFinalPrice.propTypes = {
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    isFinalPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }).isRequired,
  buttonResetClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  viewPriceDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  finalLabelSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  finalPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  finalPriceSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
PricingSummaryFinalPrice.defaultProps = {
  buttonResetClasses: '',
  finalLabelSize: '',
  finalPriceSize: ''
};

var PricingSummaryPayments = function PricingSummaryPayments(_ref) {
  var price = _ref.price,
      paymentLabelSize = _ref.paymentLabelSize,
      paymentPrice = _ref.paymentPrice,
      paymentPriceSize = _ref.paymentPriceSize,
      handleHelpCircleIcon = _ref.handleHelpCircleIcon,
      pricingSummaryPaymentIntervalColor = _ref.pricingSummaryPaymentIntervalColor,
      pricingSummaryLoanLeaseHelpIconColor = _ref.pricingSummaryLoanLeaseHelpIconColor;

  if (price && !price.isFinalPrice && paymentPrice) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "flex-grow-1"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: setClassNames('text-muted', 'text-nowrap', 'd-block', paymentLabelSize)
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelAsHTML, {
          label: labels.get(price.label)
        });
      }
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      className: "text-link line-height-reset help-icon",
      onClick: handleHelpCircleIcon,
      type: "button"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
      className: setClassNames('ddc-icon', 'ddc-icon-help-circle', 'd-inline-block', 'pl-1', pricingSummaryLoanLeaseHelpIconColor),
      "aria-hidden": "true"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref3) {
        var labels = _ref3.labels;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "sr-only"
        }, labels.get(CLICK_TO_VIEW_DISCLAIMER));
      }
    }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", {
      className: setClassNames('line-height-reset', paymentPriceSize)
    }, paymentPrice), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: setClassNames('ddc-font-size-small', 'd-inline', 'line-height-reset', pricingSummaryPaymentIntervalColor)
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref4) {
        var labels = _ref4.labels;
        return labels.get(SLASH_MO);
      }
    })));
  }

  return null;
};

PricingSummaryPayments.propTypes = {
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    isFinalPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }).isRequired,
  paymentLabelSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  paymentPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  paymentPriceSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  handleHelpCircleIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  pricingSummaryPaymentIntervalColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pricingSummaryLoanLeaseHelpIconColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
PricingSummaryPayments.defaultProps = {
  paymentLabelSize: '',
  paymentPriceSize: '',
  pricingSummaryPaymentIntervalColor: '',
  pricingSummaryLoanLeaseHelpIconColor: ''
};

var PricingSummaryLink = function PricingSummaryLink(_ref) {
  var label = _ref.label,
      labelFontSize = _ref.labelFontSize,
      isCalculatePayment = _ref.isCalculatePayment,
      viewPriceDetail = _ref.viewPriceDetail;
  var calcPaymentClasses = isCalculatePayment ? ['calculate-payment-integrated', 'calculate-payment-scroll-up'] : [];

  if (label) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      onClick: !isCalculatePayment ? viewPriceDetail : null,
      type: "button",
      className: setClassNames.apply(void 0, ['text-link', 'text-left', 'd-block', 'line-height-reset', labelFontSize].concat(calcPaymentClasses))
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(label);
      }
    }));
  }

  return null;
};

PricingSummaryLink.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  labelFontSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isCalculatePayment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  viewPriceDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
PricingSummaryLink.defaultProps = {
  labelFontSize: '',
  isCalculatePayment: false,
  viewPriceDetail: function viewPriceDetail() {}
};

var CaDisclaimer = function CaDisclaimer(_ref) {
  var dealerAddress = _ref.dealerAddress,
      isFooter = _ref.isFooter;
  var CAAlternateDisclaimerProvinces = ['AB', 'BC', 'MB', 'ON', 'QC', 'SK'];
  var staticDisclaimerClasses = 'final-price-disclaimer ddc-font-size-xsmall text-muted w-100 ';
  var disclaimerClasses = staticDisclaimerClasses + (isFooter ? 'text-left summary-disclaimer' : 'text-right');
  var disclaimerLabel = PLUS_TAXES_ASTERISK;

  if (CAAlternateDisclaimerProvinces.includes(dealerAddress.state)) {
    disclaimerLabel = PLUS_SALES_TAXES_ASTERISK;
  }

  if (dealerAddress.country === 'CA') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: disclaimerClasses
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(disclaimerLabel);
      }
    }));
  } else {
    return null;
  }
};
CaDisclaimer.propTypes = {
  dealerAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    address1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    postalCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};
CaDisclaimer.defaultProps = {
  dealerAddress: {},
  isFooter: false
};

___$insertStyle("ul.pricing-summary li.summary-price {\n  max-width: 40%;\n}\nul.pricing-summary li.half-width {\n  min-width: 50%;\n}\nul.pricing-summary li.third-width {\n  min-width: 33%;\n}\n\n.vdp-sidebar.responsive-content-default .ws-detailed-pricing ul.pricing-summary {\n  display: none !important;\n}");

var getFormattedValue = function getFormattedValue(value) {
  var formattedValue = value;

  if (formattedValue === PLEASE_CALL$1) {
    formattedValue = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(PLEASE_CALL$1);
      }
    });
  }

  return formattedValue;
};

var PricingSummary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummary, _React$Component);

  function PricingSummary(props) {
    var _this;

    _classCallCheck(this, PricingSummary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummary).call(this, props));
    _this.state = {
      isModalVisible: false,
      paymentInfo: null
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PricingSummary, [{
    key: "closeModal",
    value: function closeModal() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      disclaimerDetailsModalEvents(widgetName, windowId, false);
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "handleHelpCircleIcon",
    value: function handleHelpCircleIcon(paymentInfo) {
      var _this$props$widgetInf2 = this.props.widgetInfo,
          widgetName = _this$props$widgetInf2.widgetName,
          windowId = _this$props$widgetInf2.windowId;
      disclaimerDetailsModalEvents(widgetName, windowId, true);
      this.setState({
        isModalVisible: true,
        paymentInfo: paymentInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$summary = _this$props.summary,
          summary = _this$props$summary === void 0 ? [] : _this$props$summary,
          isMobile = _this$props.isMobile,
          viewPriceDetail = _this$props.viewPriceDetail;
      var _this$props$prefs = this.props.prefs,
          showStickySidebarLoanLease = _this$props$prefs.showStickySidebarLoanLease,
          finalPriceFontWeight = _this$props$prefs.finalPriceFontWeight,
          finalPriceClasses = _this$props$prefs.finalPriceClasses,
          priceLabelClasses = _this$props$prefs.priceLabelClasses,
          pricingSummaryPaymentIntervalColor = _this$props$prefs.pricingSummaryPaymentIntervalColor,
          showCustomizePaymentsLink = _this$props$prefs.showCustomizePaymentsLink,
          pricingSummaryLoanLeaseHelpIconColor = _this$props$prefs.pricingSummaryLoanLeaseHelpIconColor,
          pricingSummaryAlignItems = _this$props$prefs.pricingSummaryAlignItems;
      var finalLabelSize = isMobile ? 'ddc-font-size-base' : 'ddc-font-size-small';
      var finalPriceSize = isMobile ? 'ddc-font-size-xxlarge' : 'ddc-font-size-xlarge';
      var paymentLabelSize = isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall';
      var paymentPriceSize = isMobile ? 'ddc-font-size-xlarge' : 'ddc-font-size-large';
      var summaryLength = summary.length;
      var pricingSummary;

      if (summaryLength === 0) {
        return null;
      } else if (summaryLength > 1 && showStickySidebarLoanLease === 'true') {
        var finalPriceSummary = filterFinal(summary);
        var paymentsSummary = filterLoanLease(summary);
        var _this$state = this.state,
            isModalVisible = _this$state.isModalVisible,
            paymentInfo = _this$state.paymentInfo;
        pricingSummary = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DisclaimersModal, {
          isModalVisible: isModalVisible,
          handleClose: this.closeModal,
          paymentInfo: paymentInfo
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
          className: setClassNames('pricing-summary', 'list-unstyled', 'd-flex', 'justify-items-between', 'mb-4', pricingSummaryAlignItems)
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: setClassNames(summaryLength <= 2 ? 'half-width' : 'third-width', ' d-flex', 'flex-wrap', 'mr-4', 'summary-price')
        }, finalPriceSummary.map(function (price) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryFinalPrice, _extends({
            price: price,
            viewPriceDetail: viewPriceDetail,
            finalLabelSize: finalLabelSize,
            finalPriceSize: finalPriceSize,
            paymentLabelSize: paymentLabelSize
          }, {
            key: price.type,
            buttonResetClasses: BUTTON_RESET_CLASSES,
            finalPrice: getFormattedValue(price.value)
          }));
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryLink, {
          label: DETAILED_PRICING,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: false,
          viewPriceDetail: viewPriceDetail
        })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: "d-flex flex-wrap flex-grow-1"
        }, paymentsSummary.map(function (price) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryPayments, _extends({
            price: price,
            paymentLabelSize: paymentLabelSize,
            paymentPriceSize: paymentPriceSize,
            pricingSummaryPaymentIntervalColor: pricingSummaryPaymentIntervalColor,
            pricingSummaryLoanLeaseHelpIconColor: pricingSummaryLoanLeaseHelpIconColor
          }, {
            key: price.type,
            paymentPrice: getFormattedValue(price.value),
            handleHelpCircleIcon: function handleHelpCircleIcon() {
              return _this2.handleHelpCircleIcon(price);
            }
          }));
        }), showCustomizePaymentsLink === 'true' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryLink, {
          label: CUSTOMIZE_PAYMENTS,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: true
        }))));
      } else {
        // single item (final price) will get detailed pricing markup
        // TODO: REPLACE THIS WITH GET FINAL PRICE
        var _summary$find = summary.find(function (price) {
          return price.isFinalPrice;
        }),
            label = _summary$find.label,
            value = _summary$find.value;

        var dealerAddress = this.props.dealerAddress;
        /* eslint react/no-danger: 0 */

        pricingSummary = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dl", {
          className: "pricing-detail final-price line-height-condensed mb-4"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dt", {
          className: priceLabelClasses || null
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          className: BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail,
          type: "button"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryLink, {
          label: DETAILED_PRICING,
          labelFontSize: paymentLabelSize
        }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dd", {
          className: setClassNames(finalPriceFontWeight, finalPriceSize, finalPriceClasses)
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          className: BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail,
          type: "button"
        }, getFormattedValue(value))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CaDisclaimer, {
          dealerAddress: dealerAddress
        }));
      }

      return pricingSummary;
    }
  }]);

  return PricingSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
PricingSummary.displayName = 'PricingSummary';
PricingSummary.propTypes = {
  prefs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    showStickySidebarLoanLease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    finalPriceFontWeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    finalPriceClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    priceLabelClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pricingSummaryPaymentIntervalColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    showCustomizePaymentsLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pricingSummaryLoanLeaseHelpIconColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pricingSummaryAlignItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })).isRequired,
  viewPriceDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  widgetInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    windowId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    widgetName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    deviceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  dealerAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    address1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    postalCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
PricingSummary.defaultProps = {
  dealerAddress: {},
  isMobile: false
};

var PricingSummaryPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryPortal, _React$Component);

  function PricingSummaryPortal() {
    _classCallCheck(this, PricingSummaryPortal);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryPortal).apply(this, arguments));
  }

  _createClass(PricingSummaryPortal, [{
    key: "render",
    value: function render() {
      this.containerEl = getDOMContainer(document, '.ddc-vehicle-pricing-summary');
      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary,
          prefs = _this$props.prefs,
          widgetInfo = _this$props.widgetInfo,
          isMobile = _this$props.isMobile;
      var summaryComp = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummary, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      }); // if there is a pricing summary, render in portal

      if (this.containerEl) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(summaryComp, this.containerEl);
      }

      return null;
    }
  }]);

  return PricingSummaryPortal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
PricingSummaryPortal.propTypes = {
  prefs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    showStickySidebarLoanLease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  widgetInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    windowId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    widgetName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    deviceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  viewPriceDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  dealerAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    address1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    postalCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
PricingSummaryPortal.defaultProps = {
  dealerAddress: {}
};

___$insertStyle(".mobile .ws-detailed-pricing ul.pricing-summary,\n.mobile .ws-detailed-pricing .final-price-disclaimer.summary-disclaimer {\n  display: none;\n}\n.mobile .fixed-vdp-footer .ws-detailed-pricing ul.pricing-summary,\n.mobile .fixed-vdp-footer .ws-detailed-pricing .final-price-disclaimer {\n  display: block;\n}");

var PricingSummaryFooter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooter, _React$Component);

  function PricingSummaryFooter() {
    _classCallCheck(this, PricingSummaryFooter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooter).apply(this, arguments));
  }

  _createClass(PricingSummaryFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          summary = _this$props.summary,
          dealershipName = _this$props.dealershipName,
          viewPriceDetail = _this$props.viewPriceDetail;
      var displayPrice = summary.find(function (price) {
        return price.isFinalPrice;
      });

      if (!displayPrice) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
        render: function render(_ref) {
          var labels = _ref.labels;
          var dealershipNamePriceText = replacePlaceholders(labels.get(DEALERSHIP_NAME_PRICE), {
            // THIS SHOULD BE A SEPARATE PROP!
            '<%=dealershipName%>': dealershipName
          });
          var formattedValue = displayPrice.value;

          if (formattedValue === PLEASE_CALL$1) {
            formattedValue = labels.get(PLEASE_CALL$1);
          }

          return (// using aria-hidden based on conversation with Rachael Arnold
            // and Jon Ferry. The data in the footer section is redundant
            // and comes after the detailed pricing data in the DOM
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
              onClick: viewPriceDetail,
              role: "button",
              "aria-hidden": true
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
              className: "pricing-summary list-unstyled line-height-condensed mb-2"
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
              className: "text-muted"
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
              className: "d-block text-truncate"
            }, dealershipNamePriceText)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", {
              className: "pr-3"
            }, formattedValue), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
              className: "text-link"
            }, labels.get(DETAILS$2)))))
          );
        }
      });
    }
  }]);

  return PricingSummaryFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
PricingSummaryFooter.propTypes = {
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  dealershipName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  viewPriceDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var PricingSummaryFooterPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooterPortal, _React$Component);

  function PricingSummaryFooterPortal(props) {
    var _this;

    _classCallCheck(this, PricingSummaryFooterPortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooterPortal).call(this, props));
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(PricingSummaryFooterPortal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.containerEl) {
        this.containerEl.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.containerEl = getDOMContainer(document, '.ddc-detailed-pricing-footer');

      if (this.containerEl) {
        this.containerEl.appendChild(this.el);
      }

      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary,
          dealershipName = _this$props.dealershipName;
      var summaryComp = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryFooter, {
        summary: summary,
        viewPriceDetail: viewPriceDetail,
        dealershipName: dealershipName
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CaDisclaimer, {
        dealerAddress: dealerAddress,
        isFooter: true
      })); // if there is a pricing footer, render in portal

      if (this.containerEl) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(summaryComp, this.el);
      }

      return summaryComp;
    }
  }]);

  return PricingSummaryFooterPortal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
PricingSummaryFooterPortal.propTypes = {
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  dealerAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    address1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    postalCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  viewPriceDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  dealershipName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
PricingSummaryFooterPortal.defaultProps = {
  dealerAddress: {}
};

var PricingSummaryContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryContainer, _React$Component);

  function PricingSummaryContainer(props) {
    var _this;

    _classCallCheck(this, PricingSummaryContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryContainer).call(this, props));
    _this.viewPriceDetail = _this.viewPriceDetail.bind(_assertThisInitialized(_this));
    _this.scrollToAnchor = _this.scrollToAnchor.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PricingSummaryContainer, [{
    key: "viewPriceDetail",
    value: function viewPriceDetail() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      priceDetailsScrollEvent(widgetName, windowId);
      this.scrollToAnchor();
    }
  }, {
    key: "scrollToAnchor",
    value: function scrollToAnchor() {
      var deviceType = this.props.widgetInfo.deviceType;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';
      var headerSelector = document && document.querySelector('[data-widget-id="template-navigation1"]');
      var scrollToSelector = '[data-widget-id="vehicle-title1"]';

      if (isMobile) {
        headerSelector = document && document.querySelector('[data-widget-id="template-navbar1"]');
        scrollToSelector = '[data-widget-id="detailed-pricing1"]';
      }

      var pageHeaderHeight = headerSelector && headerSelector.clientHeight || 0;

      if (window && window.DDC && window.DDC.scrollToAnchor) {
        window.DDC.scrollToAnchor($(scrollToSelector), {
          heightAdj: pageHeaderHeight + OFFSET_HEIGHT
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          deviceType = _this$props.widgetInfo.deviceType,
          dealerAddress = _this$props.dealerAddress,
          prefs = _this$props.prefs,
          summary = _this$props.summary,
          widgetInfo = _this$props.widgetInfo,
          dealershipName = _this$props.dealershipName;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';

      if (isMobile) {
        if (isBrowser) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryPortal, {
            prefs: prefs,
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            widgetInfo: widgetInfo,
            dealerAddress: dealerAddress,
            isMobile: isMobile
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryFooterPortal, {
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            dealerAddress: dealerAddress,
            dealershipName: dealershipName
          }));
        }

        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummary, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: this.viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      });
    }
  }]);

  return PricingSummaryContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
PricingSummaryContainer.propTypes = {
  prefs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    showStickySidebarLoanLease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })).isRequired,
  widgetInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    windowId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    widgetName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    deviceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  dealerAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    address1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    address3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    postalCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  dealershipName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
PricingSummaryContainer.defaultProps = {
  dealerAddress: {}
};

var PricingDetail = function PricingDetail(_ref) {
  var _ref$pricing = _ref.pricing,
      _ref$pricing$lease = _ref$pricing.lease,
      lease = _ref$pricing$lease === void 0 ? {} : _ref$pricing$lease,
      _ref$pricing$loan = _ref$pricing.loan,
      loan = _ref$pricing$loan === void 0 ? {} : _ref$pricing$loan,
      _ref$pricing$retailPr = _ref$pricing.retailPrice,
      retailPrice = _ref$pricing$retailPr === void 0 ? '' : _ref$pricing$retailPr,
      pricing = _ref.pricing,
      incentives = _ref.incentives,
      accountInfo = _ref.accountInfo,
      vehicleId = _ref.vehicleId,
      vehicleCategory = _ref.vehicleCategory,
      condition = _ref.condition,
      pageAlias = _ref.pageAlias,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? SRP : _ref$layout;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setIsModalVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      incentive = _useState4[0],
      setIncentive = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDisplayingEprice = _useState6[0],
      setIsDisplayingEprice = _useState6[1]; // TODO: pass these as props (using redux store keys may cause conflicts)


  var prefs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["useSelector"])(function (state) {
    return state.prefs;
  });
  var requestData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["useSelector"])(function (state) {
    return state.requestData;
  });
  var dealerAddress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["useSelector"])(function (state) {
    return state.dealerAddress;
  });
  var flags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["useSelector"])(function (state) {
    return state.flags;
  });
  var locale = requestData.locale,
      deviceType = requestData.deviceType;
  var priceDiscountColor = prefs.priceDiscountColor,
      finalPriceSize = prefs.finalPriceSize,
      finalPriceColor = prefs.finalPriceColor,
      showTitlePriceLabel = prefs.showTitlePriceLabel,
      showOnlyMSRPForSharedInventory = prefs.showOnlyMSRPForSharedInventory,
      instantEpricePreventMultipleEpriceLeads = prefs.instantEpricePreventMultipleEpriceLeads,
      showInstantEpriceForSharedInventory = prefs.showInstantEpriceForSharedInventory,
      instantEpriceShowAllAfterLeadSubmit = prefs.instantEpriceShowAllAfterLeadSubmit,
      buttonStyleEPrice = prefs.buttonStyleEPrice,
      buttonSizeEPrice = prefs.buttonSizeEPrice;
  var stackType = pricing.ePrice && isDisplayingEprice ? 'ePrice' : 'dPrice';
  var defaultPrice = getDefaultPriceItem();
  var incentiveMap = mapIncentiveKeys(incentives);
  var isMobile = deviceType === 'MOBILE';
  var priceStack = pricing[stackType];
  var finalPrice = filterFinal(priceStack);
  var vdpSummary = [_objectSpread2({}, loan, {
    type: 'LOAN'
  }), _objectSpread2({}, lease, {
    type: 'LEASE'
  }), _objectSpread2({}, finalPrice[0])]; // TODO: discuss adding this to IDC instead of preference

  var vehicleAccountId = accountInfo.id;
  var accountId = getAccountId(requestData);
  var isVehicleOffSite = accountId !== vehicleAccountId;

  if (showOnlyMSRPForSharedInventory === 'true' && isVehicleOffSite) {
    priceStack = filterMSRP(priceStack, retailPrice);
  }

  var toggleModal = function toggleModal() {
    var incentiveId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (incentiveId && !isModalVisible) {
      setIncentive(_objectSpread2({}, incentiveMap[incentiveId], {
        key: incentiveId
      }));
      setIsModalVisible(true);
    } else {
      setIncentive(null);
      setIsModalVisible(false);
    }
  };

  var incentiveModal = null;

  if (Object.keys(incentiveMap).length > 0 && incentive) {
    var flattenedIncentive = _objectSpread2({}, incentive);

    if (layout === VDP) {
      // Incentive data from WIS is in object form
      flattenedIncentive = _objectSpread2({}, incentive, {
        disclaimer: incentive.disclaimer[locale],
        offerDetails: incentive.offerDetails[locale],
        shortTitle: incentive.shortTitle[locale],
        title: incentive.title[locale]
      });
    }

    incentiveModal = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
      render: function render(_ref2) {
        var sitemap = _ref2.sitemap;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IncentiveModal, {
          incentive: flattenedIncentive,
          isOpen: isModalVisible,
          isMobile: isMobile,
          onModalClose: toggleModal,
          newListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_NEW'),
          usedListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_USED'),
          locale: locale,
          widgetInfo: requestData,
          account: accountInfo
        });
      }
    });
  }

  var vehicleCondition = condition.replace(/\s/g, ' ').toLowerCase();
  var vehicleCssClass = condition ? "inv-type-".concat(vehicleCondition) : '';
  var priceStackLength = priceStack && Object.keys(priceStack).length || 0; // START TEMP: in-place mutations
  // TODO: remove once web-inventory-service includes proper logic for isFinalPrice
  // gets all final price items in the stack, sets isFinalPrice=false to all but last in stack
  // there should be only 1 final price in stack

  var finalPriceIndexes = [];

  if (priceStack) {
    priceStack.forEach(function (item, i) {
      return item.isFinalPrice && finalPriceIndexes.push(i);
    });
  }

  if (finalPriceIndexes.length > 1) {
    var extraFinalPrices = finalPriceIndexes.slice(0, finalPriceIndexes.length - 1);
    extraFinalPrices.forEach(function (item) {
      priceStack[item].isFinalPrice = false;
    });
  } // If there is a "stacked incentive final"/SIF item, this should be set as final price


  var hasSIF = priceStack && priceStack.find(function (item) {
    return item.type === 'SIF';
  });

  if (hasSIF) {
    /* eslint no-param-reassign: 0 */
    // clear isFinalPrice
    priceStack.some(function (item) {
      var found = item.isFinalPrice;

      if (found) {
        item.isFinalPrice = false;
      }

      return found;
    }); // add to SIF item

    priceStack.some(function (item) {
      var found = item.type === 'SIF';

      if (found) {
        item.isFinalPrice = true;
      }

      return found;
    });
  } // END TEMP


  var priceItems = priceStack && priceStackLength > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_wsm_common_data__["Common"], {
    render: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, incentiveModal, priceStack.map(function (item, idx) {
        var isFirstItem = !idx;
        var key = "price-item-".concat(item.typeClass && item.typeClass.toLowerCase() || 'none', "-").concat(priceStackLength - idx);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceItem, _extends({
          item: item,
          stackType: stackType,
          isMobile: isMobile,
          vehicleCssClass: vehicleCssClass,
          isFirstItem: isFirstItem,
          vehicleId: vehicleId
        }, {
          incentives: incentiveMap,
          handleDetailClick: toggleModal,
          prefs: {
            priceDiscountColor: priceDiscountColor,
            finalPriceSize: finalPriceSize,
            finalPriceColor: finalPriceColor,
            showTitlePriceLabel: showTitlePriceLabel
          },
          key: key
        }));
      }));
    }
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceItem, _extends({
    item: defaultPrice,
    stackType: stackType,
    incentives: {},
    isMobile: isMobile,
    vehicleCssClass: vehicleCssClass,
    vehicleId: vehicleId
  }, {
    isLastItem: true,
    isFirstItem: true
  })); // ENABLED -> E-price is enabled/avaialble for the account, uuid combination.
  // DISABLED -> E-price is disabled/not available for the account, uuid combination. Reason for non availabilty is given in the reason string
  // NON_APPLICABLE -> E-price is not applicable for the account and uuid combination.

  var ePriceStatus = pricing.ePriceStatus,
      ePrice = pricing.ePrice,
      ePriceButtonLabel = pricing.ePriceButtonLabel;
  var hasEpriceStatus = ePriceStatus && ePriceStatus !== 'NON_APPLICABLE';
  var shouldDisplayEprice = showInstantEpriceForSharedInventory !== 'false' || !isVehicleOffSite;

  var _showEPrice = function showEPrice(id) {
    return setIsDisplayingEprice(id === vehicleId && id !== 'none');
  };

  var instantEPrice = hasEpriceStatus && shouldDisplayEprice && !isDisplayingEprice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstantEpriceContainer, {
    showEPrice: function showEPrice(id) {
      return _showEPrice(id);
    },
    instantEpriceShowAllAfterLeadSubmit: instantEpriceShowAllAfterLeadSubmit,
    ePriceDetail: ePrice,
    widgetInfo: _objectSpread2({}, requestData, {
      pageAlias: pageAlias,
      vehicleId: vehicleId,
      vehicleCategory: vehicleCategory
    }),
    buttonLabel: ePriceButtonLabel,
    buttonStyle: buttonStyleEPrice,
    buttonSize: buttonSizeEPrice,
    preventMultipleEpriceLeads: instantEpricePreventMultipleEpriceLeads === 'true',
    isMobile: isMobile,
    disabled: ePriceStatus && ePriceStatus === 'DISABLED'
  }) : null;
  var pricingSummary = layout === VDP ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingSummaryContainer, {
    prefs: prefs,
    summary: vdpSummary,
    widgetInfo: requestData,
    dealerAddress: dealerAddress,
    dealershipName: accountInfo.name
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, (loan && loan.value || lease && lease.value) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Payments, {
    loan: loan,
    lease: lease,
    isMobile: isMobile,
    accountInfo: accountInfo
  }));
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PricingWrapper, {
    vehicleCssClass: vehicleCssClass
  }, priceItems, layout !== VDP && pricingSummary), layout !== VDP ? flags['ws-inv-listing-show-instant-eprice'] && instantEPrice : instantEPrice, layout === VDP && pricingSummary);
};

PricingDetail.defaultProps = {
  vehicleCategory: 'AUTO',
  incentives: {},
  accountInfo: {},
  layout: SRP
};
PricingDetail.propTypes = {
  pricing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    // individual price items are validated by PriceItem component
    dPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),
    ePrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),
    vehicle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    lease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    loan: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    retailPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    ePriceStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ePriceButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  incentives: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  accountInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  vehicleId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  vehicleCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  pageAlias: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["default"] = (PricingDetail);
//# sourceMappingURL=es.js.map


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(17);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.0393fd9b8c4a9bf3eb85.js